(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9997],{

/***/ 35713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83112);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47247);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var client_icons_Fire__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54332);





var Allotment = function(param) {
    var allotment = param.allotment;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return allotment > 0 && allotment < 8 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().allotmentContainer),
        children: allotment === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Fire__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    size: 12
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: intl.formatMessage({
                        id: "allotment.last-room"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Fire__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    size: 12
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: intl.formatMessage({
                        id: "allotment.only-rooms"
                    }, {
                        roomsLeft: allotment
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Allotment);


/***/ }),

/***/ 41323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VoucherHeader_MessageHeader; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ./src/constants/voucher.js
var voucher = __webpack_require__(69835);
// EXTERNAL MODULE: ./client/icons/createSvgIcon.tsx + 1 modules
var createSvgIcon = __webpack_require__(88121);
;// CONCATENATED MODULE: ./client/icons/GreenCheck.js



/* harmony default export */ var GreenCheck = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "11",
            fill: "#1D8549"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#FFFFFF",
            d: "M11 16.333c-.267 0-.533-.133-.733-.333l-3.334-3.667c-.4-.4-.333-1.066.067-1.4.4-.4 1.067-.333 1.4.067l2.533 2.8 4.6-6.067c.334-.466.934-.533 1.4-.2.467.334.534.934.2 1.4l-5.333 7a.95.95 0 01-.8.4z"
        })
    ]
}), "GreenCheck"));

// EXTERNAL MODULE: ./client/icons/PendingCheck.js
var PendingCheck = __webpack_require__(27352);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(12411);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./client/components/VoucherHeader/MessageHeader/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 1100px;\n\n  ",
        " {\n    margin-inline: auto;\n    margin-block: auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding-inline-start: 20px;\n  margin-block-end: 20px;\n\n  &:empty {\n    margin-block-end: 0;\n  }\n\n  ",
        " {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-block-end: 0;\n  }\n  ",
        " {\n    padding-inline-start: 40px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding-block: 20px;\n  padding-inline: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  padding-block: 20px;\n  padding-inline: 0;\n\n  ",
        " {\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  fill: ",
        ";\n  margin-inline-end: 12px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 24px;\n\n  ",
        ";\n  ",
        ";\n\n  ",
        " {\n    font-size: 28px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n\n  padding-inline-start: 10px;\n\n  color: ",
        ";\n\n  ",
        " {\n    padding-inline-start: 40px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var MessageHeaderBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MessageHeaderBase",
    componentId: "sc-dd83d8c1-0"
})(_templateObject(), styles/* media.desktop */.BC.desktop);
var VoucherInformationRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__VoucherInformationRow",
    componentId: "sc-dd83d8c1-1"
})(_templateObject1(), styles/* media.tablet */.BC.tablet, styles/* media.desktop */.BC.desktop);
var LeftSide = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LeftSide",
    componentId: "sc-dd83d8c1-2"
})(_templateObject2());
var BookingStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BookingStatus",
    componentId: "sc-dd83d8c1-3"
})(_templateObject3(), styles/* media.tablet */.BC.tablet);
var BookingIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BookingIcon",
    componentId: "sc-dd83d8c1-4"
})(_templateObject4(), styles/* colors.white */.O9.white);
var BookingIconPending = (0,styled_components_browser_esm/* default */.ZP)(BookingIcon).withConfig({
    displayName: "styles__BookingIconPending",
    componentId: "sc-dd83d8c1-5"
})(_templateObject5(), styles/* colors.orange */.O9.orange);
var bookingConfirmed = (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), styles/* colors.green */.O9.green);
var bookingPending = (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), styles/* colors.orange */.O9.orange);
var BookingStatusText = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    displayName: "styles__BookingStatusText",
    componentId: "sc-dd83d8c1-6"
})(_templateObject8(), function(props) {
    return props.bookingStatus === voucher/* BOOKING_CONFIRMED */.a9 && bookingConfirmed;
}, function(props) {
    return (props.bookingStatus === voucher/* BOOKING_PENDING */.Bc || props.bookingStatus === voucher/* BOOKING_ERROR */.l1) && bookingPending;
}, styles/* media.mobile */.BC.mobile);
var BookingUnconfirmedText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BookingUnconfirmedText",
    componentId: "sc-dd83d8c1-7"
})(_templateObject9(), styles/* colors.grey2 */.O9.grey2, styles/* media.mobile */.BC.mobile);

// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./client/components/VoucherHeader/MessageHeader/messages.js

var messages = (0,lib/* defineMessages */.vU)({
    bookingPendingInformation: {
        id: "voucher.pending-booking"
    },
    bookingPendingContactHotel: {
        id: "booking.pending-contact"
    },
    yourPurchaseConfirmed: {
        id: "voucher.your-purchase-confirmed"
    }
});
/* harmony default export */ var MessageHeader_messages = (messages);

;// CONCATENATED MODULE: ./client/components/VoucherHeader/MessageHeader/index.js











var MessageHeader = function(param) {
    var statuses = param.statuses, _consumer = param.consumer, consumer = _consumer === void 0 ? "thanks" : _consumer;
    var pendingOrError = statuses === null || statuses === void 0 ? void 0 : statuses.some(function(status) {
        return status === voucher/* BOOKING_PENDING */.Bc || status === voucher/* BOOKING_ERROR */.l1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageHeaderBase, {
        className: "noPrint",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VoucherInformationRow, {
            children: [
                !pendingOrError && consumer === "thanks" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSide, {
                    "data-testid": "confirmed-view",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookingStatus, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingIcon, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenCheck, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingStatusText, {
                                bookingStatus: voucher/* BOOKING_CONFIRMED */.a9,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, MessageHeader_messages.yourPurchaseConfirmed))
                            })
                        ]
                    })
                }),
                pendingOrError && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftSide, {
                    "data-testid": "pending-view",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookingStatus, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingIconPending, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PendingCheck/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingStatusText, {
                                    bookingStatus: voucher/* BOOKING_PENDING */.Bc,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, MessageHeader_messages.bookingPendingInformation))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingUnconfirmedText, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, MessageHeader_messages.bookingPendingContactHotel), {
                                tagName: "p"
                            }))
                        })
                    ]
                })
            ]
        })
    });
};
MessageHeader.propTypes = {
    statuses: prop_types_default().oneOf(voucher/* BOOKING_VARIANTS */.Ok),
    consumer: (prop_types_default()).string
};
/* harmony default export */ var VoucherHeader_MessageHeader = (MessageHeader);


/***/ }),

/***/ 89317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ab": function() { return /* binding */ getIsFetching; },
/* harmony export */   "lR": function() { return /* binding */ getStatus; }
/* harmony export */ });
/* unused harmony exports getAllStatuses, getAllErrorCodes */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5170);

var getIsFetching = function(hash) {
    return function(state) {
        var ref, ref1;
        return (ref1 = (ref = state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .CANCEL_BOOKING_STATE */ .b5]) === null || ref === void 0 ? void 0 : ref.bookings[hash]) === null || ref1 === void 0 ? void 0 : ref1.isFetching;
    };
};
var getStatus = function(hash) {
    return function(state) {
        var ref, ref1;
        return (ref1 = (ref = state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .CANCEL_BOOKING_STATE */ .b5]) === null || ref === void 0 ? void 0 : ref.bookings[hash]) === null || ref1 === void 0 ? void 0 : ref1.status;
    };
};
var getAllStatuses = function(state) {
    var ref;
    return Object.keys((ref = state[CANCEL_BOOKING_STATE]) === null || ref === void 0 ? void 0 : ref.bookings).map(function(hash) {
        var ref;
        return (ref = state[CANCEL_BOOKING_STATE]) === null || ref === void 0 ? void 0 : ref.bookings[hash].status;
    });
};
var getAllErrorCodes = function(state) {
    var ref;
    return Object.keys((ref = state[CANCEL_BOOKING_STATE]) === null || ref === void 0 ? void 0 : ref.bookings).map(function(hash) {
        var ref;
        return (ref = state[CANCEL_BOOKING_STATE]) === null || ref === void 0 ? void 0 : ref.bookings[hash].errorCode;
    });
};


/***/ }),

/***/ 27352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12zm2 0c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8zm8.3-.2h2.5c.6 0 1 .5 1 1.1 0 .6-.4 1-1 1h-3.5c-.6 0-1-.4-1-1V8.2c0-.6.4-1 1-1s1 .4 1 1v3.6z"
}), "PendingCheck"));


/***/ }),

/***/ 35381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_KindlyChat; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
;// CONCATENATED MODULE: ./src/comps/KindlyChat/constants.ts
var KINDLYCHAT_KEY = "98f51f18-551a-4d45-8edc-250db0710cf9";
var EVENTS = {
    "open-chatbubble": "open_chat",
    "welcome-page-start-chat": "start_chat"
};
var MARKET_CONTEXT = {
    es: "spain",
    pt: "portugal"
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/index.ts
var useKafkaEvent = __webpack_require__(96128);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/constants.ts
var constants = __webpack_require__(18935);
// EXTERNAL MODULE: ./src/hooks/usePage/index.ts
var usePage = __webpack_require__(73250);
;// CONCATENATED MODULE: ./src/comps/KindlyChat/tracking.tsx








var ChatbotTracking = function(WrappedComponent) {
    var Tracking = function(props) {
        var _purchaseId = props.purchaseId, purchaseId = _purchaseId === void 0 ? "" : _purchaseId;
        var pageId = (0,usePage/* usePage */.q)().pageId;
        var chatbot = (0,useMarket/* useMarket */.A)().chatbot;
        var section = constants/* SECTIONS.CHATBOT */.SA.CHATBOT;
        var ref = (0,useKafkaEvent/* useKafkaEvent */.L)({
            eventName: "open_chat",
            page: pageId
        }), sendKafkaEventOpenChat = ref.sendEvent;
        var ref1 = (0,useKafkaEvent/* useKafkaEvent */.L)({
            eventName: "start_chat",
            page: pageId
        }), sendKafkaEventStartChat = ref1.sendEvent;
        var eventSenders = (0,react.useMemo)(function() {
            return {
                open_chat: sendKafkaEventOpenChat,
                start_chat: sendKafkaEventStartChat
            };
        }, [
            sendKafkaEventOpenChat,
            sendKafkaEventStartChat
        ]);
        (0,react.useEffect)(function() {
            if (false) {}
            var handleClick = null;
            if (chatbot) {
                handleClick = function(event) {
                    var customEvent = event;
                    var eventName = EVENTS[customEvent.detail.type];
                    if (!eventName) return;
                    var sendEvent = eventSenders[eventName];
                    if (sendEvent) {
                        sendEvent({
                            section: section
                        }, {
                            purchaseId: purchaseId
                        });
                    }
                };
                document.addEventListener("kindly:ui", handleClick);
            }
            return function() {
                if (handleClick) {
                    document.removeEventListener("kindly:ui", handleClick);
                }
            };
        }, [
            chatbot,
            purchaseId,
            eventSenders,
            section
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props));
    };
    return Tracking;
};
/* harmony default export */ var tracking = (ChatbotTracking);

;// CONCATENATED MODULE: ./src/comps/KindlyChat/index.tsx






var KindlyChat = function() {
    var ref = (0,useMarket/* useMarket */.A)(), chatbot = ref.chatbot, market = ref.market;
    (0,react.useEffect)(function() {
        if (chatbot && "object" !== "undefined") {
            window.kindlyBotKey = KINDLYCHAT_KEY;
            if (MARKET_CONTEXT[market]) {
                window.kindlyOptions = {
                    context: {
                        market: MARKET_CONTEXT[market]
                    }
                };
            }
        }
    }, [
        chatbot,
        market
    ]);
    if (!chatbot) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "kindly-chat",
        src: "https://chat.kindlycdn.com/kindly-chat.js",
        strategy: "afterInteractive",
        "data-shadow-dom": true
    });
};
/* harmony default export */ var comps_KindlyChat = (tracking(KindlyChat));


/***/ }),

/***/ 99646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_Link; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(54166);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(12411);
;// CONCATENATED MODULE: ./src/comps/Link/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LinkBase = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__LinkBase",
    componentId: "sc-3c0ec61b-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/comps/Link/index.js






var Link = function(param) {
    var page = param.page, children = param.children, onClick = param.onClick, _query = param.query, query = _query === void 0 ? {} : _query, _target = param.target, target = _target === void 0 ? "" : _target, _rel = param.rel, rel = _rel === void 0 ? "" : _rel;
    var handleClick = function handleClick() {
        if (onClick) onClick();
    };
    var handleKeyPress = function handleKeyPress(event) {
        if (event.key === "Enter") {
            handleClick();
        }
    };
    if (!page) {
        return children;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: {
            pathname: routes/* routes */._[page].pathname,
            query: query
        },
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkBase, {
            role: "link",
            tabIndex: 0,
            onClick: handleClick,
            onKeyPress: handleKeyPress,
            target: target,
            rel: rel,
            children: children
        })
    });
};
Link.propTypes = {
    children: (prop_types_default()).node.isRequired,
    onClick: (prop_types_default()).func,
    page: (prop_types_default()).string.isRequired,
    query: prop_types_default().objectOf((prop_types_default()).string),
    target: (prop_types_default()).string,
    rel: (prop_types_default()).string
};
/* harmony default export */ var comps_Link = (Link);


/***/ }),

/***/ 26252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ container; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
// EXTERNAL MODULE: ./src/comps/Voucher/actions.js
var actions = __webpack_require__(86431);
// EXTERNAL MODULE: ./src/effects/Search/actions.js
var Search_actions = __webpack_require__(63148);
// EXTERNAL MODULE: ./src/comps/Voucher/constants.js
var constants = __webpack_require__(32184);
;// CONCATENATED MODULE: ./src/comps/Voucher/selectors.js

var getVoucher = function(state) {
    return state[constants/* VOUCHER_STATE */.y][constants/* VOUCHER_STATE */.y] || {};
};
var getIsFetching = function(state) {
    return state[constants/* VOUCHER_STATE */.y].isFetching;
};
var getRefetch = function(state) {
    return state[constants/* VOUCHER_STATE */.y].refetch;
};
var getEmail = function(state) {
    return state[constants/* VOUCHER_STATE */.y].email;
};
var getPayNow = function(state) {
    var ref;
    return (ref = state[constants/* VOUCHER_STATE */.y][constants/* VOUCHER_STATE */.y]) === null || ref === void 0 ? void 0 : ref.payNow;
};

// EXTERNAL MODULE: ./client/types/checkout/index.js
var checkout = __webpack_require__(43026);
;// CONCATENATED MODULE: ./client/types/voucher/index.js

var typeBookingInformation = (0,prop_types.shape)({
    adults: prop_types.string,
    boardCode: prop_types.string,
    boardName: prop_types.string,
    bookingDate: prop_types.string,
    checkIn: prop_types.string,
    checkOut: prop_types.string,
    children: prop_types.string,
    childrenAges: prop_types.string,
    comments: prop_types.string,
    holder: prop_types.string,
    idBooking: prop_types.number,
    insurance: (0,prop_types.instanceOf)(Object),
    internal: prop_types.number,
    isCancellable: prop_types.bool,
    nights: prop_types.number,
    rateName: prop_types.string,
    roomName: prop_types.string,
    specialRequests: (0,prop_types.arrayOf)((0,prop_types.shape)({
        requestKey: prop_types.string,
        requestValue: prop_types.string
    })),
    cancellationPolicies: (0,prop_types.arrayOf)((0,prop_types.shape)({
        cancellationDate: prop_types.string,
        amount: prop_types.number,
        currency: prop_types.string
    })),
    ticketsPaid: (0,prop_types.arrayOf)((0,prop_types.shape)({
        idTicket: prop_types.number,
        total: prop_types.number,
        currency: prop_types.string,
        paymentStatus: prop_types.string,
        paymentType: prop_types.string,
        paymentDate: prop_types.string
    }))
});
var typePriceSummary = (0,prop_types.shape)({
    priceSummary: (0,prop_types.shape)({
        bookingId: prop_types.number,
        currency: prop_types.string,
        total: prop_types.number,
        pendingAmount: prop_types.number,
        wallet: prop_types.number,
        insurance: prop_types.number,
        taxes: prop_types.number,
        subtotal: prop_types.number,
        price: prop_types.number,
        additionalFees: (0,prop_types.arrayOf)((0,prop_types.shape)({
            amount: prop_types.number,
            currency: prop_types.string
        }))
    })
});
var typeHotelPreview = (0,prop_types.shape)({
    hotelPreview: (0,prop_types.shape)({
        propertyId: prop_types.string,
        propertyAddress: prop_types.string.isRequired,
        propertyName: prop_types.string.isRequired,
        propertyStars: prop_types.number,
        propertyImages: (0,prop_types.arrayOf)((0,prop_types.shape)({
            path: prop_types.string,
            source: prop_types.string,
            code: prop_types.string,
            bookingIdRoom: prop_types.string
        })),
        conditions: (0,prop_types.shape)({
            checkin: (0,prop_types.instanceOf)(Object),
            checkout: (0,prop_types.instanceOf)(Object),
            fees: (0,prop_types.instanceOf)(Object),
            policies: (0,prop_types.instanceOf)(Object)
        })
    })
});
var typeVoucher = (0,prop_types.shape)({
    bookingInformation: (0,prop_types.arrayOf)(typeBookingInformation),
    currency: prop_types.string,
    hotelPreview: typeHotelPreview,
    nights: prop_types.number.isRequired,
    priceSummary: typePriceSummary,
    rooms: prop_types.number
});

// EXTERNAL MODULE: ./src/comps/Atom/Loader/index.tsx
var Loader = __webpack_require__(43381);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/index.ts
var useKafkaEvent = __webpack_require__(96128);
// EXTERNAL MODULE: ./src/constants/voucher.js
var constants_voucher = __webpack_require__(69835);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/constants.ts
var useKafkaEvent_constants = __webpack_require__(18935);
// EXTERNAL MODULE: ./src/comps/Voucher/utils.js
var utils = __webpack_require__(7531);
// EXTERNAL MODULE: ../../packages/uikit/src/index.ts + 74 modules
var src = __webpack_require__(61756);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(6917);
// EXTERNAL MODULE: ./src/hooks/useBus/index.tsx
var useBus = __webpack_require__(71619);
// EXTERNAL MODULE: ./src/comps/DateIntl/constants.ts
var DateIntl_constants = __webpack_require__(85611);
// EXTERNAL MODULE: ./src/effects/ModifyDates/constants.js
var ModifyDates_constants = __webpack_require__(63538);
// EXTERNAL MODULE: ./client/components/Modal/constants.js
var Modal_constants = __webpack_require__(61673);
// EXTERNAL MODULE: ./src/effects/RefundWallet/constants.js
var RefundWallet_constants = __webpack_require__(7003);
// EXTERNAL MODULE: ./src/effects/RefundCreditCard/constants.js
var RefundCreditCard_constants = __webpack_require__(47195);
// EXTERNAL MODULE: ./src/comps/AlertMessage/actions.js
var AlertMessage_actions = __webpack_require__(87222);
// EXTERNAL MODULE: ./src/effects/RefundCreditCard/actions.js
var RefundCreditCard_actions = __webpack_require__(77127);
// EXTERNAL MODULE: ./src/effects/RefundWallet/actions.js
var RefundWallet_actions = __webpack_require__(64786);
// EXTERNAL MODULE: ./src/effects/ModifyDates/actions.js
var ModifyDates_actions = __webpack_require__(35340);
;// CONCATENATED MODULE: ./src/effects/ModifyDates/selectors.js

var selectors_getIsFetching = function(state) {
    return state[ModifyDates_constants/* MODIFY_DATES_STATE */.Zs].isFetching;
};
var getBookingRules = function(state) {
    return state[ModifyDates_constants/* MODIFY_DATES_STATE */.Zs].bookingRules;
};
var getBoardSelected = function(state) {
    return state[ModifyDates_constants/* MODIFY_DATES_STATE */.Zs].boardSelected;
};
var getDatesAndPaxes = function(state) {
    return state[ModifyDates_constants/* MODIFY_DATES_STATE */.Zs].datesAndPaxes;
};
var getIsFetchingConfirmation = function(state) {
    return state[ModifyDates_constants/* MODIFY_DATES_STATE */.Zs].isFetchingConfirmation;
};
var getStep = function(state) {
    return state[ModifyDates_constants/* MODIFY_DATES_STATE */.Zs].step;
};
var getStatus = function(state) {
    return state[MODIFY_DATES_STATE].status;
};
var getError = function(state) {
    return state[MODIFY_DATES_STATE].error;
};

// EXTERNAL MODULE: ./src/effects/VerifyEmail/constants.js
var VerifyEmail_constants = __webpack_require__(93341);
;// CONCATENATED MODULE: ./src/effects/VerifyEmail/selectors.js

var selectors_getStatus = function(hash) {
    return function(state) {
        var ref, ref1;
        return (ref1 = (ref = state[VerifyEmail_constants/* VERIFY_EMAIL_STATE */.pp]) === null || ref === void 0 ? void 0 : ref.bookings[hash]) === null || ref1 === void 0 ? void 0 : ref1.status;
    };
};
var getErrorCode = function(hash) {
    return function(state) {
        var ref, ref1;
        return (ref1 = (ref = state[VerifyEmail_constants/* VERIFY_EMAIL_STATE */.pp]) === null || ref === void 0 ? void 0 : ref.bookings[hash]) === null || ref1 === void 0 ? void 0 : ref1.errorCode;
    };
};
var VerifyEmail_selectors_getIsFetching = function(hash) {
    return function(state) {
        var ref, ref1;
        return ((ref1 = (ref = state[VerifyEmail_constants/* VERIFY_EMAIL_STATE */.pp]) === null || ref === void 0 ? void 0 : ref.bookings[hash]) === null || ref1 === void 0 ? void 0 : ref1.isFetching) || null;
    };
};

;// CONCATENATED MODULE: ./src/effects/RefundCreditCard/selectors.js

var RefundCreditCard_selectors_getStatus = function(state) {
    return state[RefundCreditCard_constants/* REFUND_CREDIT_CARD_STATE */.Uu].status;
};

;// CONCATENATED MODULE: ./src/effects/RefundWallet/selectors.js

var RefundWallet_selectors_getStatus = function(state) {
    return state[RefundWallet_constants/* REFUND_WALLET_STATE */.kg].status;
};

// EXTERNAL MODULE: ./lib/utils/scroll.ts
var utils_scroll = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/comps/ButtonSimple/index.js
var ButtonSimple = __webpack_require__(11102);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./client/contexts/CancelBooking/selectors.js
var selectors = __webpack_require__(89317);
// EXTERNAL MODULE: ./client/utils.js + 2 modules
var client_utils = __webpack_require__(30796);
// EXTERNAL MODULE: ./client/contexts/CancelBooking/constants.js
var CancelBooking_constants = __webpack_require__(5170);
// EXTERNAL MODULE: ./client/components/Price/index.js
var Price = __webpack_require__(50992);
// EXTERNAL MODULE: ./src/comps/DateIntl/index.tsx
var DateIntl = __webpack_require__(59154);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(12411);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./src/comps/CancellationMessage/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  font-size: 16px;\n  line-height: 150%;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var CancellationMessageBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CancellationMessageBase",
    componentId: "sc-c0278bc5-0"
})(_templateObject(), styles/* colors.grey2 */.O9.grey2);
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Title",
    componentId: "sc-c0278bc5-1"
})(_templateObject1());
var Message = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Message",
    componentId: "sc-c0278bc5-2"
})(_templateObject2());

// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./src/comps/CancellationMessage/messages.js

var messages = (0,lib/* defineMessages */.vU)({
    youWontPay: {
        id: "reservation.free-cancellation"
    },
    canNotBeCancelled: {
        id: "reservation.cannot-be-cancelled"
    },
    partialRefundDesc: {
        id: "global.cancellation-policies-refundable"
    },
    cancelWithRefund: {
        id: "reservation.cancel-with-refund"
    },
    NRF: {
        id: "reservation.no-refundable"
    },
    SFL: {
        id: "global.partial-refund"
    },
    NOR: {
        id: "global.free-cancellation"
    }
});
/* harmony default export */ var CancellationMessage_messages = (messages);

;// CONCATENATED MODULE: ./src/comps/CancellationMessage/index.js











var CancellationMessage = function(param) {
    var cancellationDate = param.cancellationDate, cancellationAmount = param.cancellationAmount, currency = param.currency, pendingAmount = param.pendingAmount;
    var Date = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DateIntl/* default */.Z, {
            value: cancellationDate,
            format: DateIntl_constants/* DATE_INTL_FORMAT_TWO_DIGITS */.IQ
        });
    };
    var PartialRefund = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, CancellationMessage_messages.SFL))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, CancellationMessage_messages.partialRefundDesc), {
                        values: {
                            date: /*#__PURE__*/ (0,jsx_runtime.jsx)(Date, {}),
                            amount: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                amount: cancellationAmount,
                                currency: currency
                            })
                        }
                    }))
                })
            ]
        });
    };
    var FreeCancellation = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, CancellationMessage_messages.NOR))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                    children: pendingAmount === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, CancellationMessage_messages.cancelWithRefund), {
                        values: {
                            cancellation_date: /*#__PURE__*/ (0,jsx_runtime.jsx)(Date, {})
                        }
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, CancellationMessage_messages.youWontPay), {
                        values: {
                            payment_date: /*#__PURE__*/ (0,jsx_runtime.jsx)(Date, {})
                        }
                    }))
                })
            ]
        });
    };
    var NonRefundable = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, CancellationMessage_messages.NRF))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, CancellationMessage_messages.canNotBeCancelled))
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CancellationMessageBase, {
        children: [
            !cancellationDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(NonRefundable, {}),
            cancellationDate && cancellationAmount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PartialRefund, {}),
            cancellationDate && cancellationAmount === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeCancellation, {})
        ]
    });
};
CancellationMessage.propTypes = {
    cancellationDate: (prop_types_default()).string,
    cancellationAmount: (prop_types_default()).number,
    currency: (prop_types_default()).string,
    pendingAmount: (prop_types_default()).number
};
/* harmony default export */ var comps_CancellationMessage = (CancellationMessage);

// EXTERNAL MODULE: ./client/icons/Checkmark.js
var Checkmark = __webpack_require__(43476);
// EXTERNAL MODULE: ./src/comps/ListItem/index.js + 1 modules
var ListItem = __webpack_require__(33665);
// EXTERNAL MODULE: ./client/components/Modal/index.js
var Modal = __webpack_require__(38997);
// EXTERNAL MODULE: ./src/effects/VerifyEmail/actions.js
var VerifyEmail_actions = __webpack_require__(68322);
// EXTERNAL MODULE: ./client/helpers/Form/index.ts + 1 modules
var Form = __webpack_require__(5766);
;// CONCATENATED MODULE: ./client/components/FeedbackVoucher/styles.js

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  background: ",
        ";\n  border: 2px solid;\n  border-radius: 8px;\n  color: ",
        ";\n  border-color: ",
        ";\n  width: 100%;\n  padding-block: 10px;\n  padding-inline: 20px;\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding-block-end: 10px;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-inline-end: 8px;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var FeedbackVoucherBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FeedbackVoucherBase",
    componentId: "sc-1b5d4b1c-0"
})(styles_templateObject(), styles/* colors.white */.O9.white, function(props) {
    return props.status === "STATUS_OK" ? "".concat(styles/* colors.orange */.O9.orange) : "".concat(styles/* colors.red2 */.O9.red2);
}, function(props) {
    return props.status === "STATUS_OK" ? "".concat(styles/* colors.orange */.O9.orange) : "".concat(styles/* colors.red2 */.O9.red2);
}, function(props) {
    return props.status === "STATUS_OK" ? "".concat(styles/* colors.orange */.O9.orange) : "".concat(styles/* colors.red2 */.O9.red2);
});
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-1b5d4b1c-1"
})(styles_templateObject1());
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__IconWrapper",
    componentId: "sc-1b5d4b1c-2"
})(styles_templateObject2());
var Text = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Text",
    componentId: "sc-1b5d4b1c-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./client/components/FeedbackVoucher/index.js




var FeedbackVoucher = function(param) {
    var text = param.text, status = param.status, dataTestId = param.dataTestId, title = param.title, icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FeedbackVoucherBase, {
        status: status,
        "data-testid": dataTestId,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                children: [
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                        "data-testid": "icon-".concat(dataTestId),
                        children: icon
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        children: title
                    })
                ]
            }),
            text.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: item
                }, item);
            })
        ]
    });
};
FeedbackVoucher.propTypes = {
    dataTestId: (prop_types_default()).string,
    icon: prop_types_default().instanceOf(Object),
    status: (prop_types_default()).string,
    text: prop_types_default().arrayOf((prop_types_default()).string),
    title: (prop_types_default()).string
};
/* harmony default export */ var components_FeedbackVoucher = (FeedbackVoucher);

// EXTERNAL MODULE: ./client/components/FormErrorMessage/index.tsx
var FormErrorMessage = __webpack_require__(92089);
// EXTERNAL MODULE: ./client/icons/Email.js
var Email = __webpack_require__(67835);
// EXTERNAL MODULE: ./client/components/InputLine/index.js
var InputLine = __webpack_require__(71581);
// EXTERNAL MODULE: ./src/comps/Button/styles.js
var Button_styles = __webpack_require__(13377);
// EXTERNAL MODULE: ./client/components/InputLine/styles.js
var InputLine_styles = __webpack_require__(52342);
;// CONCATENATED MODULE: ./src/effects/VerifyEmail/styles.js

function VerifyEmail_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width: 100%;\n  padding-block: 0 10px;\n  padding-inline: 20px;\n  border-radius: 8px;\n"
    ]);
    VerifyEmail_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VerifyEmail_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-block-end: 20px;\n"
    ]);
    VerifyEmail_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VerifyEmail_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 100%;\n\n  color: ",
        ";\n  margin-block-end: 12px;\n"
    ]);
    VerifyEmail_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n\n  color: ",
        ";\n  padding-block-end: 8px;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  padding-block: 0;\n  padding-inline: 0;\n\n  ",
        " {\n    width: auto;\n    margin-block-start: 3px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 177px;\n  width: 100%;\n  height: 48px;\n  font-size: 16px;\n\n  ",
        " {\n    flex: 0 0 auto;\n    font-size: 16px;\n    padding-block: 12px;\n    padding-inline: 22px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var VerifyEmailBase = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "styles__VerifyEmailBase",
    componentId: "sc-ad468d89-0"
})(VerifyEmail_styles_templateObject(), styles/* colors.white */.O9.white);
var styles_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-ad468d89-1"
})(VerifyEmail_styles_templateObject1());
var styles_Title = (0,styled_components_browser_esm/* default */.ZP)(styles_Row).withConfig({
    displayName: "styles__Title",
    componentId: "sc-ad468d89-2"
})(VerifyEmail_styles_templateObject2(), styles/* colors.grey1 */.O9.grey1);
var SubTitle = (0,styled_components_browser_esm/* default */.ZP)(styles_Row).withConfig({
    displayName: "styles__SubTitle",
    componentId: "sc-ad468d89-3"
})(styles_templateObject3(), styles/* colors.grey2 */.O9.grey2);
var ButtonContainer = (0,styled_components_browser_esm/* default */.ZP)(styles_Row).withConfig({
    displayName: "styles__ButtonContainer",
    componentId: "sc-ad468d89-4"
})(_templateObject4(), styles/* media.tablet */.BC.tablet);
var ButtonSubscribe = (0,styled_components_browser_esm/* default */.ZP)(Button_styles/* ButtonPrimary */.DF).withConfig({
    displayName: "styles__ButtonSubscribe",
    componentId: "sc-ad468d89-5"
})(_templateObject5(), styles/* media.tablet */.BC.tablet);
var InputSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__InputSection",
    componentId: "sc-ad468d89-6"
})(_templateObject6(), InputLine_styles/* InputWrapper */.SP);
var WrapperInput = (0,styled_components_browser_esm/* default */.ZP)(styles_Row).withConfig({
    displayName: "styles__WrapperInput",
    componentId: "sc-ad468d89-7"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/effects/VerifyEmail/messages.js

var messages_messages = (0,lib/* defineMessages */.vU)({
    email: {
        id: "global.email"
    },
    introduceEmail: {
        id: "global.email-booking"
    },
    forYourSafety: {
        id: "global.safety-verification"
    },
    verifyEmailUnathorized: {
        id: "login.valid-email"
    },
    cancelYourBooking: {
        id: "reservation.cancel-your-booking"
    }
});
/* harmony default export */ var VerifyEmail_messages = (messages_messages);

;// CONCATENATED MODULE: ./src/effects/VerifyEmail/index.js

















var VerifyEmail = function(param) {
    var hash = param.hash, onSuccess = param.onSuccess, buttonText = param.buttonText;
    var validForm = function validForm() {
        var error = {
            email: (0,Form/* validateEmail */.oH)(email, {
                required: true
            })
        };
        setErrors(error);
        return !error.email;
    };
    var handleSubmitForm = function handleSubmitForm(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!validForm()) {
            return;
        }
        dispatch((0,VerifyEmail_actions/* fetchVerifyEmailRequestAction */.oT)({
            email: email,
            hash: hash
        }));
        if (onSuccess) {
            onSuccess();
        }
    };
    var intl = (0,useIntl/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)({
        email: false
    }), errors = ref1[0], setErrors = ref1[1];
    var statusCode = (0,es/* useSelector */.v9)(getErrorCode(hash));
    var isLoading = (0,es/* useSelector */.v9)(VerifyEmail_selectors_getIsFetching(hash));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VerifyEmailBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Title, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, VerifyEmail_messages.introduceEmail))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, VerifyEmail_messages.forYourSafety))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputSection, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLine/* default */.Z, {
                            label: intl.formatMessage(VerifyEmail_messages.email),
                            name: "email",
                            onChange: function(event) {
                                return setEmail(event.target.value);
                            },
                            type: "email",
                            value: email,
                            role: "textbox",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Email/* default */.Z, {})
                        })
                    }),
                    errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
                        errors: errors.email
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                    dataTestId: "email-verification-submit",
                    onClick: function(event) {
                        return handleSubmitForm(event);
                    },
                    type: "submit",
                    isLoading: isLoading,
                    text: buttonText,
                    variant: "primary",
                    fullWidth: true
                })
            }),
            statusCode === VerifyEmail_constants/* HTTP_CODE_VERIFY_UNAUTHORIZED */.YG && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FeedbackVoucher, {
                dataTestId: "status-unauthorized",
                text: [
                    intl.formatMessage(VerifyEmail_messages.verifyEmailUnathorized)
                ],
                status: VerifyEmail_constants/* STATUS_NOT_OK */.lm
            })
        ]
    });
};
VerifyEmail.propTypes = {
    hash: (prop_types_default()).string,
    onSuccess: (prop_types_default()).func,
    buttonText: (prop_types_default()).string
};
/* harmony default export */ var effects_VerifyEmail = (VerifyEmail);

// EXTERNAL MODULE: ./client/components/Modal/styles.js
var Modal_styles = __webpack_require__(73135);
;// CONCATENATED MODULE: ./src/comps/CancellationPolicies/styles.js

function CancellationPolicies_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  border: 2px solid ",
        ";\n  padding-block: 20px;\n  padding-inline: 20px;\n  min-height: 245px;\n\n  ",
        " {\n    max-width: 400px;\n  }\n\n  ",
        " {\n    overflow: unset;\n  }\n\n  ",
        " {\n    background-color: unset;\n  }\n\n  @media screen and (max-width: ",
        "px) {\n    max-width: 100%;\n    width: 100%;\n    margin-block-start: 15px;\n  }\n"
    ]);
    CancellationPolicies_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CancellationPolicies_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 25px;\n  color: ",
        ";\n\n  padding-block-end: 20px;\n"
    ]);
    CancellationPolicies_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var CancellationPoliciesBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CancellationPoliciesBase",
    componentId: "sc-4778feff-0"
})(CancellationPolicies_styles_templateObject(), styles/* colors.grey4 */.O9.grey4, styles/* media.mobile */.BC.mobile, Modal_styles/* Content */.VY, Modal_styles/* Header */.h4, styles/* sizes.desktop */.J7.desktop - 1);
var CancellationPolicies_styles_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Title",
    componentId: "sc-4778feff-1"
})(CancellationPolicies_styles_templateObject1(), styles/* colors.grey1 */.O9.grey1);

;// CONCATENATED MODULE: ./src/comps/CancellationPolicies/messages.js

var CancellationPolicies_messages_messages = (0,lib/* defineMessages */.vU)({
    cancellationPolicies: {
        id: "global.cancellation-policies"
    },
    confirming: {
        id: "reservation.confirming"
    },
    cancelYourBooking: {
        id: "reservation.cancel-your-booking"
    }
});
/* harmony default export */ var CancellationPolicies_messages = (CancellationPolicies_messages_messages);

// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
;// CONCATENATED MODULE: ./src/comps/CancellationPolicies/index.js























var CancelBooking = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2729).then(__webpack_require__.bind(__webpack_require__, 92729));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92729)
            ];
        }
    },
    ssr: false
});
var CancelBookingSurvey = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1697), __webpack_require__.e(2469)]).then(__webpack_require__.bind(__webpack_require__, 42469));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42469)
            ];
        }
    },
    ssr: false
});
var modalConfig = {
    "cancelation-email": {
        titleKey: "",
        variant: Modal_constants/* VARIANT_ALONE */.BG,
        component: effects_VerifyEmail,
        buttonText: "reservation.cancel-your-booking"
    },
    "cancelation-survey": {
        titleKey: "reservation.cancel-your-booking",
        variant: Modal_constants/* VARIANT_DEFAULT */.Wv,
        component: CancelBookingSurvey,
        buttonText: ""
    },
    "cancel-booking": {
        titleKey: "reservation.cancel-your-booking",
        variant: Modal_constants/* VARIANT_DEFAULT */.Wv,
        component: CancelBooking,
        buttonText: ""
    }
};
var getIsMarketWithCancelationSurvey = function(locale) {
    return locale !== "sk-SK";
};
var getModalVariant = function(status, email, locale) {
    var isEmailValidated = email && status === CancelBooking_constants/* STATUS_OK */.Us;
    var isMarketWithCancelationSurvey = getIsMarketWithCancelationSurvey(locale);
    if (isEmailValidated && isMarketWithCancelationSurvey) {
        return "cancelation-survey";
    }
    if (isEmailValidated && !isMarketWithCancelationSurvey) {
        return "cancel-booking";
    }
    return "cancelation-email";
};
var CancellationPolicies = function(param) {
    var cancellationPolicies = param.cancellationPolicies, confirmedStatus = param.confirmedStatus, generatedWallet = param.generatedWallet, hash = param.hash, internal = param.internal, pendingAmount = param.pendingAmount, rateName = param.rateName, voucherIssues = param.voucherIssues, idBooking = param.idBooking;
    var ref, ref1, ref2;
    var intl = (0,useIntl/* default */.Z)();
    var statusEmail = (0,es/* useSelector */.v9)(selectors_getStatus(hash));
    var isCancelRejected = (0,es/* useSelector */.v9)((0,selectors/* getStatus */.lR)(hash));
    var email = (0,es/* useSelector */.v9)(getEmail);
    var ref3 = (0,react.useState)(false), open = ref3[0], setOpen = ref3[1];
    var locale = (0,useMarket/* useMarket */.A)().locale;
    (0,react.useEffect)(function() {
        if (isCancelRejected === CancelBooking_constants/* STATUS_REJECTED */.g_ || isCancelRejected === CancelBooking_constants/* STATUS_OK */.Us) {
            setOpen(false);
        }
    }, [
        isCancelRejected
    ]);
    var modalVariant = getModalVariant(statusEmail, email, locale);
    var _modalVariant = modalConfig[modalVariant], Component = _modalVariant.component, titleKey = _modalVariant.titleKey, variant = _modalVariant.variant, buttonText = _modalVariant.buttonText;
    var modalTitle = titleKey ? intl.formatMessage({
        id: titleKey
    }) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CancellationPoliciesBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CancellationPolicies_styles_Title, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, CancellationPolicies_messages.cancellationPolicies))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                icon: Checkmark/* default */.Z,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, CancellationPolicies_messages.confirming), {
                    values: {
                        rate_name: rateName
                    }
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_CancellationMessage, {
                    pendingAmount: pendingAmount,
                    cancellationDate: (ref = cancellationPolicies[0]) === null || ref === void 0 ? void 0 : ref.cancellationDate,
                    cancellationAmount: (ref1 = cancellationPolicies[0]) === null || ref1 === void 0 ? void 0 : ref1.amount,
                    currency: (ref2 = cancellationPolicies[0]) === null || ref2 === void 0 ? void 0 : ref2.currency
                })
            }),
            (0,client_utils/* isCancellable */.EJ)(cancellationPolicies) && confirmedStatus && !voucherIssues && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                onClick: function() {
                    return setOpen(!open);
                },
                variant: "primary",
                dataTestId: "cancellation-btn",
                text: intl.formatMessage(CancellationPolicies_messages.cancelYourBooking)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                title: modalTitle,
                handleClose: function() {
                    return setOpen(false);
                },
                show: open,
                variant: variant,
                width: "580px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                    hash: hash,
                    closeModal: function() {
                        return setOpen(false);
                    },
                    generatedWallet: generatedWallet,
                    internal: internal,
                    email: email,
                    idBooking: idBooking,
                    buttonText: buttonText && intl.formatMessage({
                        id: buttonText
                    })
                })
            })
        ]
    });
};
CancellationPolicies.propTypes = {
    cancellationPolicies: prop_types_default().arrayOf(Object),
    confirmedStatus: (prop_types_default()).bool,
    generatedWallet: (prop_types_default()).number,
    hash: (prop_types_default()).string,
    internal: (prop_types_default()).number,
    pendingAmount: (prop_types_default()).number,
    rateName: (prop_types_default()).string,
    voucherIssues: (prop_types_default()).bool,
    idBooking: (prop_types_default()).number
};
/* harmony default export */ var comps_CancellationPolicies = (CancellationPolicies);

// EXTERNAL MODULE: ./src/comps/Capacity/index.tsx + 3 modules
var Capacity = __webpack_require__(48320);
// EXTERNAL MODULE: ./client/components/CollapsibleSection/CollapsibleSection.js
var CollapsibleSection = __webpack_require__(28116);
// EXTERNAL MODULE: ./client/icons/PendingCheck.js
var PendingCheck = __webpack_require__(27352);
;// CONCATENATED MODULE: ./src/comps/InformationBox/styles.js

function InformationBox_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  background-color: ",
        ";\n  width: 100%;\n  border-radius: 8px;\n  border: 2px solid ",
        ";\n  border-color: ",
        ";\n\n  font-family: ",
        ";\n  font-size: 16px;\n  line-height: 150%;\n\n  padding-block: 20px;\n  padding-inline: 20px;\n"
    ]);
    InformationBox_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InformationBox_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n\n  color: ",
        ";\n"
    ]);
    InformationBox_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function InformationBox_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block-end: 12px;\n  color: ",
        ";\n  svg {\n    padding-inline-end: 10px;\n    fill: ",
        ";\n  }\n"
    ]);
    InformationBox_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var InformationBoxBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__InformationBoxBase",
    componentId: "sc-1a9f9d1c-0"
})(InformationBox_styles_templateObject(), styles/* colors.white */.O9.white, styles/* colors.grey4 */.O9.grey4, function(props) {
    return props.status === "STATUS_NOT_OK" ? "".concat(styles/* colors.red2 */.O9.red2) : "".concat(styles/* colors.grey4 */.O9.grey4);
}, styles/* fonts.default */.Rq["default"]);
var InformationBox_styles_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-1a9f9d1c-1"
})(InformationBox_styles_templateObject1(), function(props) {
    return props.status === "STATUS_NOT_OK" ? "".concat(styles/* colors.red2 */.O9.red2) : "".concat(styles/* colors.grey2 */.O9.grey2);
});
var InformationBox_styles_Title = (0,styled_components_browser_esm/* default */.ZP)(InformationBox_styles_Row).withConfig({
    displayName: "styles__Title",
    componentId: "sc-1a9f9d1c-2"
})(InformationBox_styles_templateObject2(), function(props) {
    return props.status === "STATUS_NOT_OK" ? "".concat(styles/* colors.red2 */.O9.red2) : "".concat(styles/* colors.grey1 */.O9.grey1);
}, function(props) {
    return props.status === "STATUS_NOT_OK" ? "".concat(styles/* colors.red2 */.O9.red2) : "".concat(styles/* colors.grey1 */.O9.grey1);
});

;// CONCATENATED MODULE: ./src/comps/InformationBox/index.js




var InformationBox = function(param) {
    var text = param.text, icon = param.icon, title = param.title, status = param.status;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationBoxBase, {
        status: status,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationBox_styles_Title, {
                status: status,
                children: [
                    icon,
                    title
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationBox_styles_Row, {
                status: status,
                children: text
            })
        ]
    });
};
InformationBox.propTypes = {
    text: (prop_types_default()).string,
    icon: prop_types_default().instanceOf(Object),
    title: (prop_types_default()).string,
    status: (prop_types_default()).string
};
/* harmony default export */ var comps_InformationBox = (InformationBox);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 105 modules
var ds_src = __webpack_require__(55349);
// EXTERNAL MODULE: ../../packages/icons/lib/IconCheck.tsx
var IconCheck = __webpack_require__(81913);
// EXTERNAL MODULE: ./src/comps/Molecules/InvoicePanel/CheckItem/index.module.css
var index_module = __webpack_require__(78005);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/InvoicePanel/CheckItem/index.tsx





var CheckItem = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).checkItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheck/* IconCheck */.N, {
                className: (index_module_default()).checkIcon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                variant: "body",
                size: "l",
                children: text
            })
        ]
    });
};
/* harmony default export */ var InvoicePanel_CheckItem = (CheckItem);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../packages/react-context/src/index.tsx + 11 modules
var react_context_src = __webpack_require__(67048);
// EXTERNAL MODULE: ../../packages/utils/src/hooks/useBrowser.ts
var useBrowser = __webpack_require__(77941);
// EXTERNAL MODULE: ../../packages/utility-css/dist/index.js
var dist = __webpack_require__(61366);
// EXTERNAL MODULE: ./src/comps/Atom/Inputs/Input/Input.tsx
var Input = __webpack_require__(69475);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ./src/comps/Molecules/InvoicePanel/RequestModal/SubmitButton/index.module.css
var SubmitButton_index_module = __webpack_require__(41685);
var SubmitButton_index_module_default = /*#__PURE__*/__webpack_require__.n(SubmitButton_index_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/InvoicePanel/RequestModal/SubmitButton/index.tsx








var SubmitButton = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SubmitButton_index_module_default()).formActions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            fullWidth: true,
            variant: "filled",
            type: "submit"
        }, props), {
            children: intl.formatMessage({
                id: "global.request-invoice"
            })
        }))
    });
};
/* harmony default export */ var RequestModal_SubmitButton = (SubmitButton);

// EXTERNAL MODULE: ./src/comps/Molecules/InvoicePanel/RequestModal/FormFields/index.module.css
var FormFields_index_module = __webpack_require__(80538);
var FormFields_index_module_default = /*#__PURE__*/__webpack_require__.n(FormFields_index_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/InvoicePanel/RequestModal/FormFields/index.tsx













var FORM_DATA_LANG_IDS_MAP = {
    name: "input.name-or-company-name",
    address: "address",
    vatNumber: "global.vat-number",
    email: "global.confirm-email"
};
var ERRORS_LANG_IDS_MAP = {
    required: "validation.required",
    pleaseEmail: "subscription.please-enter-your-email"
};
var FormFields = function(param) {
    var formData = param.formData, onFieldChange = param.onFieldChange, onSubmit = param.onSubmit, children = param.children;
    var validateField = function validateField(fieldName, value) {
        var rules = {
            required: true
        };
        var error = fieldName === "email" ? (0,Form/* validateEmail */.oH)(value, rules) : (0,Form/* validateName */.Ol)({
            name: value,
            rules: rules
        });
        setErrors((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errors), (0,_define_property/* default */.Z)({}, fieldName, error)));
        return !error;
    };
    var validateForm = function validateForm() {
        var nextErrors = {
            name: (0,Form/* validateName */.Ol)({
                name: formData.name,
                rules: {
                    required: true
                }
            }),
            address: (0,Form/* validateName */.Ol)({
                name: formData.address,
                rules: {
                    required: true
                }
            }),
            vatNumber: (0,Form/* validateName */.Ol)({
                name: formData.vatNumber,
                rules: {
                    required: true
                }
            }),
            email: (0,Form/* validateEmail */.oH)(formData.email, {
                required: true
            })
        };
        setErrors(nextErrors);
        var hasErrors = Object.values(nextErrors).some(Boolean);
        return !hasErrors;
    };
    var handdleInputChange = function handdleInputChange(value, fieldName) {
        onFieldChange(value, fieldName);
        validateField(fieldName, value);
    };
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)({}), errors = ref[0], setErrors = ref[1];
    var ref1 = (0,react.useState)(false), isSubmitting = ref1[0], setIsSubmitting = ref1[1];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                e.preventDefault();
                if (validateForm()) {
                    setIsSubmitting(true);
                    onSubmit(e);
                }
                return [
                    2
                ];
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            Object.keys(formData).map(function(key) {
                var ref, ref1;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: key === "email" ? (FormFields_index_module_default()).lastFormGroup : (FormFields_index_module_default()).formGroup,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        name: key,
                        value: formData[key],
                        onChange: function(value) {
                            return handdleInputChange(value, key);
                        },
                        onBlur: function() {
                            return validateField(key, formData[key]);
                        },
                        label: intl.formatMessage({
                            id: FORM_DATA_LANG_IDS_MAP[key]
                        }),
                        errors: (ref1 = (ref = errors[key]) === null || ref === void 0 ? void 0 : ref.slice(0, 1)) === null || ref1 === void 0 ? void 0 : ref1.map(function(error) {
                            return intl.formatMessage({
                                id: ERRORS_LANG_IDS_MAP[error.id]
                            });
                        })
                    })
                }, key);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FormFields_index_module_default()).emailNote,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                    variant: "body",
                    size: "m",
                    as: "p",
                    children: intl.formatMessage({
                        id: "confirm-email.assistive-text"
                    })
                })
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestModal_SubmitButton, {
                disabled: isSubmitting
            })
        ]
    });
};
/* harmony default export */ var RequestModal_FormFields = (FormFields);

// EXTERNAL MODULE: ./src/comps/Molecules/InvoicePanel/RequestModal/InvoiceInfo/index.module.css
var InvoiceInfo_index_module = __webpack_require__(93842);
var InvoiceInfo_index_module_default = /*#__PURE__*/__webpack_require__.n(InvoiceInfo_index_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/InvoicePanel/RequestModal/InvoiceInfo/index.tsx





var InvoiceInfo = function() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (InvoiceInfo_index_module_default()).invoiceNote,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
            variant: "body",
            size: "l",
            as: "p",
            children: intl.formatMessage({
                id: "invoice.conditions"
            })
        })
    });
};
/* harmony default export */ var RequestModal_InvoiceInfo = (InvoiceInfo);

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/comps/Molecules/InvoicePanel/RequestModal/TermsSection/index.module.css
var TermsSection_index_module = __webpack_require__(95934);
var TermsSection_index_module_default = /*#__PURE__*/__webpack_require__.n(TermsSection_index_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/InvoicePanel/RequestModal/TermsSection/index.tsx






var TermsSection = function() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TermsSection_index_module_default()).termsContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
            variant: "body",
            size: "m",
            as: "p",
            children: intl.formatMessage({
                id: "global.accept-conditions-continuing"
            }, {
                terms: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/general-conditions",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (TermsSection_index_module_default()).termsLink,
                        children: intl.formatMessage({
                            id: "legal.terms"
                        })
                    })
                }),
                privacy: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/privacy",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (TermsSection_index_module_default()).termsLink,
                        children: intl.formatMessage({
                            id: "global.privacy"
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var RequestModal_TermsSection = (TermsSection);

// EXTERNAL MODULE: ./src/comps/Molecules/InvoicePanel/RequestModal/index.module.css
var RequestModal_index_module = __webpack_require__(11062);
var RequestModal_index_module_default = /*#__PURE__*/__webpack_require__.n(RequestModal_index_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/InvoicePanel/RequestModal/index.tsx

























var RequestModal = function(param) {
    var hash = param.hash, isOpen = param.isOpen, onClose = param.onClose, onError = param.onError, onSubmit = param.onSubmit;
    var intl = (0,useIntl/* default */.Z)();
    var domain = (0,react_context_src/* useS4LContext */.ms)().domain;
    var device = (0,useBrowser/* useBrowser */.GF)().device;
    var isWide = (0,useMedia/* default */.Z)(styles/* breakpoint.tablet */.eq.tablet, device !== "mobile");
    var email = (0,es/* useSelector */.v9)(getEmail);
    var statusResponseEmail = (0,es/* useSelector */.v9)(selectors_getStatus(hash));
    var isEmailValidated = email && statusResponseEmail === "STATUS_OK";
    var ref = (0,react.useState)({
        name: "",
        address: "",
        vatNumber: "",
        email: ""
    }), formData = ref[0], setFormData = ref[1];
    if (!isOpen) return null;
    var handleChange = function(value, fieldName) {
        setFormData(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, fieldName, value));
        });
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        return [
                            4,
                            domain.CreateInvoiceRequestBookingUseCase.execute({
                                bookingHash: hash,
                                name: formData.name,
                                address: formData.address,
                                vatNumber: formData.vatNumber,
                                email: formData.email
                            })
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), error = ref[0];
                        if (error) {
                            console.error(error) // eslint-disable-line no-console
                            ;
                            onError === null || onError === void 0 ? void 0 : onError();
                        } else {
                            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: isOpen,
        handleClose: onClose,
        variant: isWide ? Modal_constants/* VARIANT_ALONE */.BG : Modal_constants/* VARIANT_FULLSCREEN */.VU,
        title: isEmailValidated && intl.formatMessage({
            id: "global.request-invoice"
        }),
        children: isEmailValidated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                    variant: "body",
                    size: "l",
                    as: "p",
                    className: (0,dist.cn)((RequestModal_index_module_default()).formTitle),
                    children: intl.formatMessage({
                        id: "global.fill-in-details"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestModal_FormFields, {
                    formData: formData,
                    onSubmit: handleSubmit,
                    onFieldChange: function(value, fieldName) {
                        return handleChange(value, fieldName);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestModal_InvoiceInfo, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestModal_TermsSection, {})
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(effects_VerifyEmail, {
            buttonText: intl.formatMessage({
                id: "global.request-invoice"
            }),
            hash: hash
        })
    });
};
/* harmony default export */ var InvoicePanel_RequestModal = (RequestModal);

;// CONCATENATED MODULE: ./src/comps/Molecules/InvoicePanel/RequestButton/index.tsx







var RequestButton = function(param) {
    var hash = param.hash, onSubmit = param.onSubmit;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleClick = function() {
        setIsModalOpen(true);
    };
    var handleCloseModal = function() {
        setIsModalOpen(false);
    };
    var handleFormSubmit = function() {
        setIsModalOpen(false);
        dispatch((0,AlertMessage_actions/* displayAlertAction */.Hn)({
            title: intl.formatMessage({
                id: "notification-success.invoice-title"
            }),
            description: intl.formatMessage({
                id: "notification-success.invoice-body"
            }),
            severity: "success"
        }));
        onSubmit();
    };
    var handleFormError = function() {
        dispatch((0,AlertMessage_actions/* displayAlertAction */.Hn)({
            title: intl.formatMessage({
                id: "notification-error.invoice-title"
            }),
            description: intl.formatMessage({
                id: "notification-error.invoice-body"
            }),
            severity: "error"
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Button */.zx, {
                fullWidth: true,
                variant: "outlined",
                onClick: handleClick,
                children: intl.formatMessage({
                    id: "global.request-invoice"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoicePanel_RequestModal, {
                hash: hash,
                isOpen: isModalOpen,
                onClose: handleCloseModal,
                onError: handleFormError,
                onSubmit: handleFormSubmit
            })
        ]
    });
};
/* harmony default export */ var InvoicePanel_RequestButton = (RequestButton);

// EXTERNAL MODULE: ./src/comps/MessageBox/index.tsx
var MessageBox = __webpack_require__(14686);
// EXTERNAL MODULE: ./src/comps/Molecules/InvoicePanel/types.ts
var types = __webpack_require__(77010);
// EXTERNAL MODULE: ./src/comps/Molecules/InvoicePanel/StatusBadge/index.module.css
var StatusBadge_index_module = __webpack_require__(76796);
var StatusBadge_index_module_default = /*#__PURE__*/__webpack_require__.n(StatusBadge_index_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/InvoicePanel/StatusBadge/index.tsx






var StatusBadge = function(param) {
    var date = param.date, type = param.type;
    var intl = (0,useIntl/* default */.Z)();
    if (!date) return null;
    var isRequested = type === types/* INVOICE_STATUS.REQUESTED */.U.REQUESTED;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (StatusBadge_index_module_default()).statusBadge,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageBox/* default */.Z, {
            message: intl.formatMessage({
                id: isRequested ? "invoice.requested" : "invoice.sent"
            }, {
                date: intl.formatDate(date, {
                    year: "numeric",
                    month: "long",
                    day: "numeric"
                }),
                time: intl.formatTime(date)
            }),
            type: "success"
        })
    });
};
/* harmony default export */ var InvoicePanel_StatusBadge = (StatusBadge);

// EXTERNAL MODULE: ./src/comps/Molecules/InvoicePanel/index.module.css
var InvoicePanel_index_module = __webpack_require__(77299);
var InvoicePanel_index_module_default = /*#__PURE__*/__webpack_require__.n(InvoicePanel_index_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/InvoicePanel/index.tsx










var InvoicePanel = function(param) {
    var _status = param.status, status = _status === void 0 ? types/* INVOICE_STATUS.DEFAULT */.U.DEFAULT : _status, date = param.date, hash = param.hash;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState({
        date: date,
        status: status
    }), 2), invoice = ref[0], setInvoice = ref[1];
    (0,react.useEffect)(function() {
        setInvoice({
            date: date,
            status: status
        });
    }, [
        date,
        status
    ]);
    var handleFormSubmit = function() {
        setInvoice({
            status: types/* INVOICE_STATUS.REQUESTED */.U.REQUESTED,
            date: new Date().toISOString()
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (InvoicePanel_index_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                variant: "title",
                size: "xs",
                as: "h3",
                className: (InvoicePanel_index_module_default()).title,
                children: intl.formatMessage({
                    id: "global.request-invoice"
                })
            }),
            invoice.status !== types/* INVOICE_STATUS.DEFAULT */.U.DEFAULT && /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoicePanel_StatusBadge, {
                type: invoice.status,
                date: invoice.date
            }),
            invoice.status === types/* INVOICE_STATUS.DEFAULT */.U.DEFAULT && /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoicePanel_CheckItem, {
                text: intl.formatMessage({
                    id: "invoice.info-request"
                })
            }),
            invoice.status !== types/* INVOICE_STATUS.NOT_AVAILABLE */.U.NOT_AVAILABLE && /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoicePanel_CheckItem, {
                text: intl.formatMessage({
                    id: "invoice.sent-by-email"
                })
            }),
            invoice.status === types/* INVOICE_STATUS.DEFAULT */.U.DEFAULT && /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoicePanel_RequestButton, {
                hash: hash,
                onSubmit: handleFormSubmit
            }),
            invoice.status === types/* INVOICE_STATUS.NOT_AVAILABLE */.U.NOT_AVAILABLE && /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoicePanel_CheckItem, {
                text: intl.formatMessage({
                    id: "invoice.booking"
                })
            })
        ]
    });
};
/* harmony default export */ var Molecules_InvoicePanel = (InvoicePanel);

// EXTERNAL MODULE: ./client/types/index.js
var client_types = __webpack_require__(12654);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/lodash/take.js
var take = __webpack_require__(85701);
var take_default = /*#__PURE__*/__webpack_require__.n(take);
// EXTERNAL MODULE: ./lib/dates.js + 3 modules
var dates = __webpack_require__(10595);
// EXTERNAL MODULE: ../../node_modules/date-fns-tz/toDate/index.js
var toDate = __webpack_require__(93629);
var toDate_default = /*#__PURE__*/__webpack_require__.n(toDate);
// EXTERNAL MODULE: ./lib/paxes.ts
var paxes = __webpack_require__(10306);
// EXTERNAL MODULE: ./src/comps/AgeSelector/index.js + 1 modules
var AgeSelector = __webpack_require__(91793);
// EXTERNAL MODULE: ./client/components/DatePicker/index.js + 2 modules
var DatePicker = __webpack_require__(76155);
// EXTERNAL MODULE: ./client/components/IncrementSelector/index.js + 3 modules
var IncrementSelector = __webpack_require__(46246);
// EXTERNAL MODULE: ./client/components/InputReadOnly/index.js
var InputReadOnly = __webpack_require__(55514);
// EXTERNAL MODULE: ./src/hooks/usePage/index.ts
var usePage = __webpack_require__(73250);
;// CONCATENATED MODULE: ./src/comps/DatesChangeConnected/index.ts






var handleClick = function(mouseEvent, children, sendChangeDatesPeople, context, details) {
    sendChangeDatesPeople({
        section: useKafkaEvent_constants/* SECTIONS.CHANGE_PAXES_DATES */.SA.CHANGE_PAXES_DATES
    }, {
        context: context,
        details: details
    });
    if (children.props.onClick) {
        children.props.onClick(mouseEvent);
    }
};
var DatesChangeConnected = function(param) {
    var trackingData = param.trackingData, children = param.children;
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var ref = trackingData || {}, context = ref.context, details = ref.details;
    var ref1 = (0,useKafkaEvent/* useKafkaEvent */.L)({
        eventName: "change_dates_people",
        eventType: "impression",
        page: pageId
    }), sendChangeDatesPeople = ref1.sendEvent;
    var handleClickBound = function(mouseEvent) {
        return handleClick(mouseEvent, children, sendChangeDatesPeople, context, details);
    };
    return react.cloneElement(children, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, children.props), {
        onClick: handleClickBound
    }));
};
/* harmony default export */ var comps_DatesChangeConnected = (DatesChangeConnected);

// EXTERNAL MODULE: ./src/comps/ModifyDates/ModifyDatesDetails/styles.module.css
var styles_module = __webpack_require__(49312);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/comps/ModifyDates/ModifyDatesDetails/utils.ts
var formatGuests = function(adults, children, i18n, rooms) {
    var adultsNumber = Number(adults);
    var childrenNumber = Number(children);
    var roomsLabel = rooms > 1 ? "(x".concat(rooms, ") ") : "";
    if (!adultsNumber && !childrenNumber) return "";
    var parts = [
        adultsNumber > 0 && "".concat(roomsLabel).concat(adultsNumber, " ").concat(i18n.formatMessage({
            id: adultsNumber === 1 ? "global.adult" : "global.adults"
        })),
        childrenNumber > 0 && "".concat(childrenNumber, " ").concat(i18n.formatMessage({
            id: childrenNumber === 1 ? "global.child" : "global.children"
        })), 
    ];
    return parts.filter(Boolean).join(" \xb7 ");
};

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInCalendarDays/index.js
var differenceInCalendarDays = __webpack_require__(8849);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
;// CONCATENATED MODULE: ../../packages/icons/lib/IconEdit.tsx




var IconEdit = function(_param) {
    var _color = _param.color, color = _color === void 0 ? "currentColor" : _color, _size = _param.size, size = _size === void 0 ? 24 : _size, className = _param.className, _rotateOnRtl = _param.rotateOnRtl, rotateOnRtl = _rotateOnRtl === void 0 ? false : _rotateOnRtl, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size",
        "className",
        "rotateOnRtl"
    ]);
    var props = (0,_object_spread/* default */.Z)((0,_define_property/* default */.Z)({
        width: size,
        height: size,
        fill: color,
        // stroke: color,
        className: className,
        viewBox: "0 0 24 24"
    }, "data-rotateonrtl", false), rest);
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ react.createElement("path", {
        d: "M4 16.6671V20H7.33287L17.1626 10.1703L13.8297 6.83738L4 16.6671ZM19.74 7.59283C20.0867 7.24622 20.0867 6.68629 19.74 6.33967L17.6603 4.25996C17.3137 3.91335 16.7538 3.91335 16.4072 4.25996L14.7807 5.8864L18.1136 9.21927L19.74 7.59283Z"
    }));
};

// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/comps/ModifyDates/ModifyDatesDetails/index.tsx













var ModifyDatesDetails = function(param) {
    var booking = param.booking, newBooking = param.newBooking, title = param.title, subtitle = param.subtitle, onClick = param.onClick, _total = param.total, total = _total === void 0 ? false : _total, totalFrom = param.totalFrom, _border = param.border, border = _border === void 0 ? false : _border, className = param.className;
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    var ref;
    var guests = formatGuests(booking === null || booking === void 0 ? void 0 : booking.adults, booking === null || booking === void 0 ? void 0 : booking.children, i18n, (ref = booking === null || booking === void 0 ? void 0 : booking.rooms) !== null && ref !== void 0 ? ref : 0);
    var ref1;
    var newGuests = (newBooking === null || newBooking === void 0 ? void 0 : newBooking.adults) ? formatGuests(newBooking === null || newBooking === void 0 ? void 0 : newBooking.adults, newBooking === null || newBooking === void 0 ? void 0 : newBooking.children, i18n, (ref1 = newBooking === null || newBooking === void 0 ? void 0 : newBooking.rooms) !== null && ref1 !== void 0 ? ref1 : 0) : null;
    var nights = (booking === null || booking === void 0 ? void 0 : booking.nights) ? booking.nights : (0,differenceInCalendarDays/* default */.Z)(new Date(booking === null || booking === void 0 ? void 0 : booking.checkOut), new Date(booking === null || booking === void 0 ? void 0 : booking.checkIn));
    var newNights = (newBooking === null || newBooking === void 0 ? void 0 : newBooking.checkOut) && (newBooking === null || newBooking === void 0 ? void 0 : newBooking.checkIn) ? (0,differenceInCalendarDays/* default */.Z)(new Date(newBooking.checkOut), new Date(newBooking.checkIn)) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((styles_module_default()).wrapper, (0,_define_property/* default */.Z)({}, (styles_module_default()).border, border), className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).header,
                children: [
                    title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                        variant: "body",
                        size: "xl",
                        bold: true,
                        children: i18n.formatMessage({
                            id: title
                        })
                    }) : null,
                    subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                        variant: "body",
                        size: "l",
                        children: i18n.formatMessage({
                            id: subtitle
                        })
                    }) : null,
                    onClick && /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Button */.zx, {
                        as: "button",
                        onClick: onClick,
                        variant: "text-flat",
                        leadingIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEdit, {
                            size: 16
                        }),
                        size: "small",
                        children: i18n.formatMessage({
                            id: "global.modify"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).grid,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).label,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                            variant: "body",
                            size: "l",
                            bold: true,
                            children: i18n.formatMessage({
                                id: "change-dates.arrival"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).value,
                        children: (booking === null || booking === void 0 ? void 0 : booking.checkIn) === (newBooking === null || newBooking === void 0 ? void 0 : newBooking.checkIn) || !(newBooking === null || newBooking === void 0 ? void 0 : newBooking.checkIn) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                            variant: "body",
                            size: "l",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateIntl/* default */.Z, {
                                value: booking === null || booking === void 0 ? void 0 : booking.checkIn,
                                format: DateIntl_constants/* DATE_INTL_FORMAT_WEEKDAY_MONTH_TEXT */.qN
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                    variant: "body",
                                    size: "l",
                                    strike: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateIntl/* default */.Z, {
                                        value: booking === null || booking === void 0 ? void 0 : booking.checkIn,
                                        format: DateIntl_constants/* DATE_INTL_FORMAT_WEEKDAY_MONTH_TEXT */.qN
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                    variant: "body",
                                    size: "l",
                                    bold: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateIntl/* default */.Z, {
                                        value: newBooking === null || newBooking === void 0 ? void 0 : newBooking.checkIn,
                                        format: DateIntl_constants/* DATE_INTL_FORMAT_WEEKDAY_MONTH_TEXT */.qN
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).label,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                            variant: "body",
                            size: "l",
                            bold: true,
                            children: i18n.formatMessage({
                                id: "change-dates.exit"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).value,
                        children: (booking === null || booking === void 0 ? void 0 : booking.checkOut) === (newBooking === null || newBooking === void 0 ? void 0 : newBooking.checkOut) || !(newBooking === null || newBooking === void 0 ? void 0 : newBooking.checkOut) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                            variant: "body",
                            size: "l",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateIntl/* default */.Z, {
                                value: booking === null || booking === void 0 ? void 0 : booking.checkOut,
                                format: DateIntl_constants/* DATE_INTL_FORMAT_WEEKDAY_MONTH_TEXT */.qN
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                    variant: "body",
                                    size: "l",
                                    strike: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateIntl/* default */.Z, {
                                        value: booking === null || booking === void 0 ? void 0 : booking.checkOut,
                                        format: DateIntl_constants/* DATE_INTL_FORMAT_WEEKDAY_MONTH_TEXT */.qN
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                    variant: "body",
                                    size: "l",
                                    bold: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateIntl/* default */.Z, {
                                        value: newBooking === null || newBooking === void 0 ? void 0 : newBooking.checkOut,
                                        format: DateIntl_constants/* DATE_INTL_FORMAT_WEEKDAY_MONTH_TEXT */.qN
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).label,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                            variant: "body",
                            size: "l",
                            bold: true,
                            children: i18n.formatMessage({
                                id: "change-dates.stay"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).value,
                        children: nights === newNights || !newNights ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                            variant: "body",
                            size: "l",
                            children: i18n.formatMessage({
                                id: "global.nights"
                            }, {
                                nights: nights
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                    variant: "body",
                                    size: "l",
                                    strike: true,
                                    children: i18n.formatMessage({
                                        id: "global.nights"
                                    }, {
                                        nights: nights
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                    variant: "body",
                                    size: "l",
                                    bold: true,
                                    children: i18n.formatMessage({
                                        id: "global.nights"
                                    }, {
                                        nights: newNights
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).label,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                            variant: "body",
                            size: "l",
                            bold: true,
                            children: i18n.formatMessage({
                                id: "change-dates.guests"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).value,
                        children: guests === newGuests || !newGuests ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                            variant: "body",
                            size: "l",
                            children: guests
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                    variant: "body",
                                    size: "l",
                                    strike: true,
                                    children: guests
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                    variant: "body",
                                    size: "l",
                                    bold: true,
                                    children: newGuests
                                })
                            ]
                        })
                    }),
                    total && (booking === null || booking === void 0 ? void 0 : booking.sellingRate) !== null && (booking === null || booking === void 0 ? void 0 : booking.currency) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).label,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                    variant: "body",
                                    size: "l",
                                    bold: true,
                                    children: i18n.formatMessage({
                                        id: "global.total"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).value,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                    variant: "title",
                                    size: "xs",
                                    bold: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                        amount: booking === null || booking === void 0 ? void 0 : booking.sellingRate,
                                        currency: booking === null || booking === void 0 ? void 0 : booking.currency
                                    })
                                })
                            })
                        ]
                    }),
                    totalFrom && (booking === null || booking === void 0 ? void 0 : booking.currency) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).label,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                    variant: "body",
                                    size: "l",
                                    bold: true,
                                    children: i18n.formatMessage({
                                        id: "global.total"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).totalValue,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                        variant: "body",
                                        size: "l",
                                        children: i18n.formatMessage({
                                            id: "global.from-intro"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                        variant: "title",
                                        size: "xs",
                                        bold: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                            amount: totalFrom,
                                            currency: booking === null || booking === void 0 ? void 0 : booking.currency
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ModifyDates_ModifyDatesDetails = (ModifyDatesDetails);

// EXTERNAL MODULE: ./src/hooks/useDevice/index.ts
var useDevice = __webpack_require__(72731);
// EXTERNAL MODULE: ./src/types/device.ts
var device = __webpack_require__(68686);
// EXTERNAL MODULE: ./client/icons/Spinner.js
var Spinner = __webpack_require__(69763);
// EXTERNAL MODULE: ./client/components/InputReadOnly/styles.js
var InputReadOnly_styles = __webpack_require__(73595);
// EXTERNAL MODULE: ./src/comps/AgeSelector/styles.js
var AgeSelector_styles = __webpack_require__(8483);
;// CONCATENATED MODULE: ./src/effects/ModifyDates/CheckAvailability/styles.js

function CheckAvailability_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding-block: 0 30px;\n  padding-inline: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-16);\n  width: 100%;\n  border-radius: 8px;\n\n  & > button {\n    min-width: 200px;\n    span svg {\n      animation: spin 1s linear infinite;\n    }\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(-360deg);\n    }\n  }\n\n  ",
        " {\n    flex-direction: column-reverse;\n\n    & > button {\n      order: 1;\n      align-self: end;\n    }\n  }\n"
    ]);
    CheckAvailability_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckAvailability_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    order: 2;\n  }\n"
    ]);
    CheckAvailability_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CheckAvailability_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n\n  padding-block: 15px;\n  padding-inline: 0;\n"
    ]);
    CheckAvailability_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CheckAvailability_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n\n  padding-block-end: 15px;\n  ",
        " {\n    max-width: unset;\n  }\n"
    ]);
    CheckAvailability_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-block-end: 16px;\n\n  ",
        " {\n    margin-block-end: 0;\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 8px;\n  border: 2px solid;\n  border-color: ",
        ";\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n\n  ",
        ";\n\n  .datepicker-default {\n    position: absolute;\n    inset-block-start: calc(100% + 10px);\n    inset-inline-start: 0;\n    z-index: 11;\n  }\n\n  ",
        " {\n    background-color: transparent;\n    padding-block: 9px;\n    padding-inline: 9px;\n\n    :first-of-type {\n      border-inline-end: 2px solid ",
        ";\n    }\n  }\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block-end: 20px;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-size: 12px;\n  line-height: 1.4;\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100px;\n  padding-inline-end: 20px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 25px;\n  color: ",
        ";\n  padding-block: 0 16px;\n  padding-inline: 0;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  padding-block: 0;\n  padding-inline: 0;\n\n  color: ",
        ";\n\n  ",
        " {\n    height: 28px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var CheckAvailabilityBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CheckAvailabilityBase",
    componentId: "sc-90ca7c4b-0"
})(CheckAvailability_styles_templateObject(), styles/* colors.white */.O9.white, styles/* media.tablet */.BC.tablet);
var ModifyDatesAndGuests = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ModifyDatesAndGuests",
    componentId: "sc-90ca7c4b-1"
})(CheckAvailability_styles_templateObject1(), styles/* media.tablet */.BC.tablet);
var CheckAvailability_styles_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-90ca7c4b-2"
})(CheckAvailability_styles_templateObject2());
var LeftRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LeftRow",
    componentId: "sc-90ca7c4b-3"
})(CheckAvailability_styles_templateObject3(), AgeSelector_styles/* AgeSelectorBase */.dC);
var DateSelectorBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DateSelectorBase",
    componentId: "sc-90ca7c4b-4"
})(styles_templateObject4(), styles/* media.tablet */.BC.tablet);
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Content",
    componentId: "sc-90ca7c4b-5"
})(styles_templateObject5(), styles/* colors.white */.O9.white, function(props) {
    return props.isFocus ? styles/* colors.grey1 */.O9.grey1 : styles/* colors.grey4 */.O9.grey4;
}, function(props) {
    return props.type === "inline" && "\n      flex: 0 0 auto;\n      margin-inline-end: .75em;\n      width: 300px;\n      padding-block: 0;\n      padding-inline: 1rem;\n  ";
}, InputReadOnly_styles/* InputGroup */.BZ, styles/* colors.grey4 */.O9.grey4);
var PaxWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PaxWrapper",
    componentId: "sc-90ca7c4b-6"
})(styles_templateObject6());
var ItemSelector = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ItemSelector",
    componentId: "sc-90ca7c4b-7"
})(styles_templateObject7());
var AgeRange = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__AgeRange",
    componentId: "sc-90ca7c4b-8"
})(_templateObject8(), styles/* colors.grey2 */.O9.grey2);
var ChildrenAge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ChildrenAge",
    componentId: "sc-90ca7c4b-9"
})(_templateObject9());
var CheckAvailability_styles_Title = (0,styled_components_browser_esm/* default */.ZP)(CheckAvailability_styles_Row).withConfig({
    displayName: "styles__Title",
    componentId: "sc-90ca7c4b-10"
})(_templateObject10(), styles/* colors.grey1 */.O9.grey1);
var styles_SubTitle = (0,styled_components_browser_esm/* default */.ZP)(CheckAvailability_styles_Row).withConfig({
    displayName: "styles__SubTitle",
    componentId: "sc-90ca7c4b-11"
})(_templateObject11(), styles/* colors.grey2 */.O9.grey2, styles/* media.tablet */.BC.tablet);

;// CONCATENATED MODULE: ./src/effects/ModifyDates/CheckAvailability/index.js



























var CheckAvailability = function(param) {
    var existingBooking = param.existingBooking, modifyDatesSectionRef = param.modifyDatesSectionRef, propertyId = param.propertyId, newDates = param.newDates;
    var updateDates = function updateDates(payload) {
        if (payload.checkIn && payload.checkOut) {
            setCheckin(payload.checkIn);
            setCheckout(payload.checkOut);
        }
    };
    var handleOpen = function handleOpen(input) {
        setFocusedInput(input);
        setDatePickerOpen(true);
    };
    var updatePaxes = function updatePaxes(eventData) {
        var changedAdults = eventData.adults, changedChildren = eventData.children;
        if (changedAdults) {
            setAdults(changedAdults);
            return;
        }
        setChildren(changedChildren);
        if (changedChildren < childrenAges.length) {
            var updatedArray = take_default()(childrenAges, childrenAges.length - 1);
            setChildrenAges((0,_to_consumable_array/* default */.Z)(updatedArray));
            return;
        }
        setChildrenAges((0,_to_consumable_array/* default */.Z)(childrenAges).concat([
            {
                index: childrenAges.length,
                value: null
            }
        ]));
    };
    var isEnabledButton = function isEnabledButton() {
        var validateAges = childrenAges.some(function(item) {
            return item.value === null;
        });
        var changeDatesOrPaxes = checkin.getTime() !== checkIn.getTime() || checkout.getTime() !== checkOut.getTime() || initialAdults !== adults || initialChildren !== children || !(0,paxes/* areSameAges */.Bl)(childrenAgesFromBooking, childrenAges);
        return validateAges || !changeDatesOrPaxes;
    };
    var handleChangeDatesAndPaxes = function handleChangeDatesAndPaxes() {
        dispatch((0,ModifyDates_actions/* modifyDatesRequestAction */.yk)({
            adults: adults,
            boardCode: boardCode,
            bookingHash: bookingHash,
            checkin: (0,dates/* formatISO */.cK)(checkin),
            checkout: (0,dates/* formatISO */.cK)(checkout),
            children: children,
            childrenAges: childrenAges,
            language: languageBooking,
            market: market,
            propertyId: propertyId,
            rooms: rooms
        }));
        dispatch((0,ModifyDates_actions/* saveDatesAndPaxesAction */.cd)({
            adults: adults,
            checkin: checkin,
            checkout: checkout,
            children: children,
            childrenAges: childrenAges
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var language = (0,useMarket/* useMarket */.A)().language;
    var initialAdults = existingBooking.adults, boardCode = existingBooking.boardCode, bookingHash = existingBooking.hash, initialChildren = existingBooking.children, initialChildrenAges = existingBooking.childrenAges, initialCheckIn = existingBooking.checkIn, initialCheckOut = existingBooking.checkOut, languageBooking = existingBooking.language, market = existingBooking.market, _rooms = existingBooking.rooms, rooms = _rooms === void 0 ? 1 : _rooms;
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var isDesktop = activeBreakpoint === device/* BreakpointSizes.L */.a.L;
    var isFetching = (0,es/* useSelector */.v9)(selectors_getIsFetching);
    var childrenAgesFromBooking = (0,paxes/* convertAgesToArray */.jD)(initialChildrenAges);
    var checkIn = toDate_default()(initialCheckIn);
    var checkOut = toDate_default()(initialCheckOut);
    var ref;
    var ref1 = (0,react.useState)((ref = newDates === null || newDates === void 0 ? void 0 : newDates.adults) !== null && ref !== void 0 ? ref : parseInt(initialAdults)), adults = ref1[0], setAdults = ref1[1];
    var ref2;
    var ref3 = (0,react.useState)((ref2 = newDates === null || newDates === void 0 ? void 0 : newDates.checkIn) !== null && ref2 !== void 0 ? ref2 : checkIn), checkin = ref3[0], setCheckin = ref3[1];
    var ref4;
    var ref5 = (0,react.useState)((ref4 = newDates === null || newDates === void 0 ? void 0 : newDates.checkOut) !== null && ref4 !== void 0 ? ref4 : checkOut), checkout = ref5[0], setCheckout = ref5[1];
    var ref6;
    var ref7 = (0,react.useState)((ref6 = newDates === null || newDates === void 0 ? void 0 : newDates.children) !== null && ref6 !== void 0 ? ref6 : initialChildren ? parseInt(initialChildren) : 0), children = ref7[0], setChildren = ref7[1];
    var ref8;
    var ref9 = (0,react.useState)((ref8 = newDates === null || newDates === void 0 ? void 0 : newDates.childrenAges) !== null && ref8 !== void 0 ? ref8 : childrenAgesFromBooking), childrenAges = ref9[0], setChildrenAges = ref9[1];
    var ref10 = (0,react.useState)(), focusedInput = ref10[0], setFocusedInput = ref10[1];
    var ref11 = (0,react.useState)(false), isDatePickerOpen = ref11[0], setDatePickerOpen = ref11[1];
    var isMultiroom = rooms > 1;
    var updateAge = function(index) {
        return function(age) {
            var removed = childrenAges.filter(function(item) {
                return item.index !== index;
            });
            var newElement = {
                index: index,
                value: age
            };
            var ordered = (0,_to_consumable_array/* default */.Z)(removed).concat([
                newElement
            ]).sort(function(a, b) {
                return a.index - b.index;
            });
            setChildrenAges(ordered);
        };
    };
    var childrenTitle = /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        children: [
            i18n.formatMessage({
                id: "global.children"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgeRange, {
                children: [
                    i18n.formatMessage({
                        id: "global.age"
                    }),
                    " 0-17"
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckAvailabilityBase, {
        "data-testid": "modify-dates-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Collapsible */.zF, {
                defaultOpen: true,
                title: i18n.formatMessage({
                    id: "change-dates.original-dates-title"
                }),
                className: classnames_default()("mb-24", "tablet:order-2"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModifyDates_ModifyDatesDetails, {
                    booking: existingBooking,
                    total: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModifyDatesAndGuests, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckAvailability_styles_Title, {
                        children: i18n.formatMessage(isMultiroom ? {
                            id: "global.modify-dates-multiroom"
                        } : {
                            id: "global.modify-dates-paxes"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_SubTitle, {
                        children: i18n.formatMessage(isMultiroom ? {
                            id: "global.select-dates-multiroom"
                        } : {
                            id: "global.select-dates-paxes"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckAvailability_styles_Row, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSelectorBase, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                type: "default",
                                isFocus: isDatePickerOpen,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputReadOnly/* default */.Z, {
                                        inputName: "checkIn",
                                        labelMessage: {
                                            id: "search.checkin"
                                        },
                                        onClick: function() {
                                            return handleOpen("checkin");
                                        },
                                        reference: modifyDatesSectionRef,
                                        type: "default",
                                        value: i18n.formatDate(checkin, DateIntl_constants/* formatMappings.DATE_INTL_FORMAT_TWO_DIGITS */.Wb.DATE_INTL_FORMAT_TWO_DIGITS),
                                        dataTestId: "check-in-test"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputReadOnly/* default */.Z, {
                                        inputName: "checkOut",
                                        labelMessage: {
                                            id: "search.checkout"
                                        },
                                        onClick: function() {
                                            return handleOpen("checkout");
                                        },
                                        type: "default",
                                        value: i18n.formatDate(checkout, DateIntl_constants/* formatMappings.DATE_INTL_FORMAT_TWO_DIGITS */.Wb.DATE_INTL_FORMAT_TWO_DIGITS),
                                        dataTestId: "check-out-test"
                                    }),
                                    isDatePickerOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker/* default */.Z, {
                                        checkIn: checkin,
                                        checkOut: checkout,
                                        initialFocusedInput: focusedInput,
                                        language: language,
                                        onChangeDates: updateDates,
                                        onClose: function() {
                                            return setDatePickerOpen(false);
                                        },
                                        type: "availability",
                                        market: market,
                                        unFreezeScroll: true
                                    })
                                ]
                            })
                        })
                    }),
                    !isMultiroom && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckAvailability_styles_Row, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaxWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelector, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IncrementSelector/* default */.Z, {
                                                maxLimit: 9,
                                                minLimit: 1,
                                                name: "adults",
                                                title: i18n.formatMessage({
                                                    id: "global.adults"
                                                }),
                                                value: adults,
                                                update: updatePaxes,
                                                position: 0
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelector, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IncrementSelector/* default */.Z, {
                                                maxLimit: 9,
                                                minLimit: 0,
                                                name: "children",
                                                title: childrenTitle,
                                                value: children,
                                                update: updatePaxes,
                                                position: 0
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftRow, {
                                children: childrenAges.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenAge, {
                                        "data-testid": "age-select-".concat(item.index),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AgeSelector/* default */.Z, {
                                            initialAge: item.value,
                                            item: item.value,
                                            titleTranslation: {
                                                id: "pax.children-ages-title"
                                            },
                                            update: updateAge(item.index)
                                        }, "".concat(item.index))
                                    }, "age-select-".concat(item.index));
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_DatesChangeConnected, {
                trackingData: {
                    context: "booking_thanks",
                    details: "Check availability"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Button */.zx, {
                    "data-testId": "change-date-btn",
                    disabled: isEnabledButton() || isFetching,
                    fullWidth: !isDesktop,
                    onClick: handleChangeDatesAndPaxes,
                    variant: "filled-rounded",
                    children: isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                        size: 18
                    }) : i18n.formatMessage({
                        id: "global.availability-check"
                    })
                })
            })
        ]
    });
};
CheckAvailability.propTypes = {
    existingBooking: prop_types_default().shape({
        adults: (prop_types_default()).number.isRequired,
        boardCode: (prop_types_default()).string.isRequired,
        hash: (prop_types_default()).string.isRequired,
        children: (prop_types_default()).number.isRequired,
        childrenAges: (prop_types_default()).string,
        checkIn: prop_types_default().instanceOf(Date).isRequired,
        checkOut: prop_types_default().instanceOf(Date).isRequired,
        language: (prop_types_default()).string.isRequired,
        market: (prop_types_default()).string.isRequired,
        rooms: (prop_types_default()).number
    }).isRequired,
    modifyDatesSectionRef: client_types/* typeRef */.ct,
    propertyId: (prop_types_default()).string.isRequired,
    newDates: prop_types_default().shape({
        checkIn: prop_types_default().instanceOf(Date),
        checkOut: prop_types_default().instanceOf(Date),
        childrenAges: (prop_types_default()).array,
        adults: (prop_types_default()).number,
        children: (prop_types_default()).number
    })
};
/* harmony default export */ var ModifyDates_CheckAvailability = (CheckAvailability);

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./lib/utils/url.js
var url = __webpack_require__(70284);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(54166);
;// CONCATENATED MODULE: ./src/effects/ModifyDates/ConfirmationError/constants.js
var VARIANTS = [
    "RESERVATION_NOT_OK",
    "CANCELLATION_NOT_OK"
];
var RESERVATION_NOT_OK = "RESERVATION_NOT_OK";
var CANCELLATION_NOT_OK = "CANCELLATION_NOT_OK";

// EXTERNAL MODULE: ./client/icons/Close.js
var Close = __webpack_require__(32902);
;// CONCATENATED MODULE: ./src/effects/ModifyDates/ConfirmationError/styles.js

function ConfirmationError_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ConfirmationError_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConfirmationError_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n\n  padding-block: 10px;\n  padding-inline: 0;\n"
    ]);
    ConfirmationError_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConfirmationError_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: flex;\n\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 130%;\n\n  svg {\n    fill: ",
        ";\n    padding-block-start: 2px 8px 0 8px;\n  }\n"
    ]);
    ConfirmationError_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConfirmationError_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 16px;\n  line-height: 150%;\n"
    ]);
    ConfirmationError_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ConfirmationError_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 10px;\n  padding-inline: 20px;\n"
    ]);
    ConfirmationError_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ConfirmationError_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 20px;\n  padding-inline: 20px;\n"
    ]);
    ConfirmationError_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var ConfirmationErrorBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ConfirmationErrorBase",
    componentId: "sc-955c7eda-0"
})(ConfirmationError_styles_templateObject());
var ConfirmationError_styles_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-955c7eda-1"
})(ConfirmationError_styles_templateObject1());
var ConfirmationError_styles_Title = (0,styled_components_browser_esm/* default */.ZP)(ConfirmationError_styles_Row).withConfig({
    displayName: "styles__Title",
    componentId: "sc-955c7eda-2"
})(ConfirmationError_styles_templateObject2(), styles/* colors.red */.O9.red, styles/* colors.red */.O9.red);
var Subtitle = (0,styled_components_browser_esm/* default */.ZP)(ConfirmationError_styles_Row).withConfig({
    displayName: "styles__Subtitle",
    componentId: "sc-955c7eda-3"
})(ConfirmationError_styles_templateObject3(), styles/* colors.grey2 */.O9.grey2);
var styles_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Content",
    componentId: "sc-955c7eda-4"
})(ConfirmationError_styles_templateObject4());
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ButtonWrapper",
    componentId: "sc-955c7eda-5"
})(ConfirmationError_styles_templateObject5());

;// CONCATENATED MODULE: ./src/effects/ModifyDates/ConfirmationError/messages.js

var ConfirmationError_messages_messages = (0,lib/* defineMessages */.vU)({
    reservationNotOk: {
        id: "global.new-reservation-notok"
    },
    reservationNextStep: {
        id: "global.new-reservation-next-step"
    },
    changeDatesNotOk: {
        id: "global.change-dates-notok"
    },
    dontWorry: {
        id: "global.change-dates-send-cs"
    },
    book: {
        id: "global.book"
    }
});
/* harmony default export */ var ConfirmationError_messages = (ConfirmationError_messages_messages);

;// CONCATENATED MODULE: ./src/effects/ModifyDates/ConfirmationError/index.js



















var ConfirmationError = function(param) {
    var variant = param.variant;
    var redirectToHotelDetail = function redirectToHotelDetail() {
        setIsLoading(true);
        router.push({
            pathname: (0,url/* buildPathParams */.J0)(routes/* routes.detail.pathname */._.detail.pathname, {
                country: hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.propertyCountry,
                slug: hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.propertySlug,
                city: hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.propertyCity
            }),
            query: (0,_object_spread/* default */.Z)({
                adults: datesAndPaxes === null || datesAndPaxes === void 0 ? void 0 : datesAndPaxes.adults,
                checkin: (0,dates/* formatISO */.cK)(datesAndPaxes === null || datesAndPaxes === void 0 ? void 0 : datesAndPaxes.checkIn),
                checkout: (0,dates/* formatISO */.cK)(datesAndPaxes === null || datesAndPaxes === void 0 ? void 0 : datesAndPaxes.checkOut)
            }, childrenParam)
        });
    };
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var hotelPreview = (0,es/* useSelector */.v9)(getVoucher).hotelPreview;
    var datesAndPaxes = (0,es/* useSelector */.v9)(getDatesAndPaxes);
    var ref = (0,react.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var childrenAges = (0,paxes/* convertAgesToString */.uo)(datesAndPaxes === null || datesAndPaxes === void 0 ? void 0 : datesAndPaxes.childrenAges);
    var childrenParam = childrenAges.length > 0 ? {
        children: childrenAges
    } : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmationErrorBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmationError_styles_Title, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                size: 24
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ConfirmationError_messages[variant === RESERVATION_NOT_OK ? "reservationNotOk" : "changeDatesNotOk"]), {
                                tagName: "span"
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, ConfirmationError_messages[variant === RESERVATION_NOT_OK ? "reservationNextStep" : "dontWorry"]))
                    })
                ]
            }),
            variant === RESERVATION_NOT_OK && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                    onClick: redirectToHotelDetail,
                    variant: "primary",
                    dataTestId: "book-btn-error",
                    text: intl.formatMessage(ConfirmationError_messages.book),
                    fullWidth: true,
                    isLoading: isLoading
                })
            })
        ]
    });
};
ConfirmationError.propTypes = {
    variant: prop_types_default().oneOf(VARIANTS)
};
/* harmony default export */ var ModifyDates_ConfirmationError = (ConfirmationError);

// EXTERNAL MODULE: ./src/effects/ModifyDates/ConfirmExit/styles.module.css
var ConfirmExit_styles_module = __webpack_require__(1566);
var ConfirmExit_styles_module_default = /*#__PURE__*/__webpack_require__.n(ConfirmExit_styles_module);
;// CONCATENATED MODULE: ./src/effects/ModifyDates/ConfirmExit/index.tsx





var ConfirmExit = function(param) {
    var open = param.open, onClose = param.onClose, onContinueEditing = param.onContinueEditing, onExitWithoutSaving = param.onExitWithoutSaving;
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* BottomSheet */.R1, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* BottomSheet.Content */.R1.Content, {
            title: i18n.formatMessage({
                id: "change-dates.unsaved-modal-title"
            }),
            modalOnDesktop: true,
            size: "s",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ConfirmExit_styles_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                        variant: "body",
                        size: "m",
                        children: i18n.formatMessage({
                            id: "change-dates.unsaved-modal-body"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ConfirmExit_styles_module_default()).actions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Button */.zx, {
                                variant: "outlined-rounded",
                                fullWidth: true,
                                onClick: onContinueEditing,
                                children: i18n.formatMessage({
                                    id: "change-dates.unsaved-modal-button"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Button */.zx, {
                                variant: "filled-rounded",
                                fullWidth: true,
                                onClick: onExitWithoutSaving,
                                children: i18n.formatMessage({
                                    id: "change-dates.unsaved-modal-cta"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
ConfirmExit.displayName = "ConfirmExit";
/* harmony default export */ var ModifyDates_ConfirmExit = (ConfirmExit);

// EXTERNAL MODULE: ./client/icons/Info.js
var Info = __webpack_require__(3802);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/Allotment/index.tsx
var Allotment = __webpack_require__(35713);
// EXTERNAL MODULE: ./src/comps/ModifyDates/ModifyDatesRoom/styles.module.css
var ModifyDatesRoom_styles_module = __webpack_require__(89549);
var ModifyDatesRoom_styles_module_default = /*#__PURE__*/__webpack_require__.n(ModifyDatesRoom_styles_module);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferConditions/RateNOR/index.tsx
var RateNOR = __webpack_require__(14346);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferConditions/RateNRF/index.tsx
var RateNRF = __webpack_require__(58112);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferConditions/RateSFL/index.tsx
var RateSFL = __webpack_require__(26613);
;// CONCATENATED MODULE: ../../packages/icons/lib/IconArrowDownGraph.tsx




var IconArrowDownGraph = function(_param) {
    var _color = _param.color, color = _color === void 0 ? "currentColor" : _color, _size = _param.size, size = _size === void 0 ? 24 : _size, className = _param.className, _rotateOnRtl = _param.rotateOnRtl, rotateOnRtl = _rotateOnRtl === void 0 ? false : _rotateOnRtl, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size",
        "className",
        "rotateOnRtl"
    ]);
    var props = (0,_object_spread/* default */.Z)((0,_define_property/* default */.Z)({
        width: size,
        height: size,
        fill: color,
        // stroke: color,
        className: className,
        viewBox: "0 0 24 24"
    }, "data-rotateonrtl", false), rest);
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.293109 4.29268C0.683753 3.90227 1.31692 3.90247 1.70732 4.29311L8.64 11.23L11.0453 8.8233C11.8265 8.0416 13.0936 8.04169 13.8747 8.8235L21 15.9552V13.5793C21 13.027 21.4477 12.5793 22 12.5793C22.5523 12.5793 23 13.027 23 13.5793V17.8679C23 18.6963 22.3285 19.3679 21.5 19.3679H17.2114C16.6591 19.3679 16.2114 18.9201 16.2114 18.3679C16.2114 17.8156 16.6591 17.3679 17.2114 17.3679H19.5843L12.4599 10.2371L10.0546 12.6438C9.2735 13.4254 8.0065 13.4254 7.22535 12.6438L0.292677 5.70689C-0.0977278 5.31625 -0.0975343 4.68308 0.293109 4.29268Z"
    }));
};

;// CONCATENATED MODULE: ../../packages/icons/lib/IconArrowUpGraph.tsx




var IconArrowUpGraph = function(_param) {
    var _color = _param.color, color = _color === void 0 ? "currentColor" : _color, _size = _param.size, size = _size === void 0 ? 24 : _size, className = _param.className, _rotateOnRtl = _param.rotateOnRtl, rotateOnRtl = _rotateOnRtl === void 0 ? false : _rotateOnRtl, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size",
        "className",
        "rotateOnRtl"
    ]);
    var props = (0,_object_spread/* default */.Z)((0,_define_property/* default */.Z)({
        width: size,
        height: size,
        fill: color,
        // stroke: color,
        className: className,
        viewBox: "0 0 24 24"
    }, "data-rotateonrtl", false), rest);
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.293109 19.0752C0.683753 19.4656 1.31692 19.4654 1.70732 19.0747L8.64 12.1378L11.0453 14.5446C11.8265 15.3263 13.0936 15.3262 13.8747 14.5444L21 7.41268V9.7886C21 10.3409 21.4477 10.7886 22 10.7886C22.5523 10.7886 23 10.3409 23 9.7886V5.5C23 4.67157 22.3285 4 21.5 4H17.2114C16.6591 4 16.2114 4.44772 16.2114 5C16.2114 5.55229 16.6591 6 17.2114 6H19.5843L12.4599 13.1308L10.0546 10.7241C9.2735 9.94243 8.0065 9.94243 7.22535 10.7241L0.292677 17.661C-0.0977278 18.0516 -0.0975343 18.6848 0.293109 19.0752Z"
    }));
};

;// CONCATENATED MODULE: ./src/comps/ModifyDates/ModifyDatesRoom/index.tsx
















var Rate;
(function(Rate) {
    Rate["NOR"] = "NOR";
    Rate["SFL"] = "SFL";
    Rate["NRF"] = "NRF";
})(Rate || (Rate = {}));
var ModifyDatesRoom = function(param) {
    var room = param.room, _offerSelected = param.offerSelected, offerSelected = _offerSelected === void 0 ? false : _offerSelected, onClick = param.onClick, existingBooking = param.existingBooking;
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    var adults = room.adults, children = room.children, childrenAges = room.childrenAges, roomName = room.roomName, roomsNumber = room.roomsNumber, allotment = room.allotment;
    var _obj;
    var rates = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Rate.NOR, RateNOR/* default */.ZP), (0,_define_property/* default */.Z)(_obj, Rate.NRF, RateNRF/* default */.ZP), (0,_define_property/* default */.Z)(_obj, Rate.SFL, RateSFL/* default */.ZP), _obj);
    var _paymentPolicy;
    var RateComponent = (_paymentPolicy = rates[room.paymentPolicy]) !== null && _paymentPolicy !== void 0 ? _paymentPolicy : rates[Rate.NOR];
    var rateProps = {
        cancellation: Array.isArray(room === null || room === void 0 ? void 0 : room.cancellation) ? room.cancellation[0] : room === null || room === void 0 ? void 0 : room.cancellation,
        currency: room.currency,
        payRate: room.payRate
    };
    var tagDiscount = (existingBooking === null || existingBooking === void 0 ? void 0 : existingBooking.sellingRate) && room.sellingRate - existingBooking.sellingRate;
    var renderDiscountTag = function() {
        if (!tagDiscount || tagDiscount === 0) {
            return null;
        }
        var isNegative = tagDiscount < 0;
        var Icon = isNegative ? IconArrowDownGraph : IconArrowUpGraph;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Tag */.Vp, {
            size: "m",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
            bgColor: isNegative ? "var(--color-success-500)" : "var(--color-error-500)",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                amount: tagDiscount,
                currency: room.currency
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ModifyDatesRoom_styles_module_default()).container,
        "data-testid": "room",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ModifyDatesRoom_styles_module_default()).roomContainer,
            children: [
                !offerSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ModifyDatesRoom_styles_module_default()).detailsContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ModifyDatesRoom_styles_module_default()).roomHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: (ModifyDatesRoom_styles_module_default()).roomName,
                                children: [
                                    roomsNumber > 1 ? "(x".concat(roomsNumber, ") ") : "",
                                    (roomName === null || roomName === void 0 ? void 0 : roomName.charAt(0).toUpperCase()) + (roomName === null || roomName === void 0 ? void 0 : roomName.slice(1))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ModifyDatesRoom_styles_module_default()).detailsCapacityContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Capacity/* default */.Z, {
                                    adults: adults,
                                    children: children,
                                    childrenAges: childrenAges,
                                    showAges: false,
                                    title: false,
                                    showIcons: false
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Allotment/* default */.Z, {
                                allotment: allotment
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ModifyDatesRoom_styles_module_default()).offersContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ModifyDatesRoom_styles_module_default()).boardContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ModifyDatesRoom_styles_module_default()).offerConditionsContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: (ModifyDatesRoom_styles_module_default()).offerConditionsList,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RateComponent, (0,_object_spread/* default */.Z)({}, rateProps))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ModifyDatesRoom_styles_module_default()).priceBookingContainer,
                                "data-testid": "room-prices",
                                "data-availability-id": room.availabilityId,
                                "data-currency": room.currency,
                                "data-total-price": room.sellingRate,
                                children: [
                                    existingBooking && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ModifyDatesRoom_styles_module_default()).priceContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                                variant: "body",
                                                size: "l",
                                                children: i18n.formatMessage({
                                                    id: "change-dates.original-price"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                                variant: "body",
                                                size: "xl",
                                                strike: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                    amount: existingBooking.sellingRate,
                                                    currency: existingBooking.currency
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ModifyDatesRoom_styles_module_default()).priceContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (ModifyDatesRoom_styles_module_default()).priceLabel,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                                        variant: "body",
                                                        size: "l",
                                                        children: i18n.formatMessage({
                                                            id: "change-dates.new-price"
                                                        })
                                                    }),
                                                    renderDiscountTag()
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                                variant: "body",
                                                size: "xl",
                                                bold: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                    amount: room.sellingRate,
                                                    currency: room.currency
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !offerSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ModifyDatesRoom_styles_module_default()).bookingButtonContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_DatesChangeConnected, {
                                    trackingData: {
                                        context: "booking_thanks",
                                        details: "Select offer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Button */.zx, {
                                        "data-testId": "button-modify-booking",
                                        onClick: onClick,
                                        variant: "filled-rounded",
                                        size: "small",
                                        children: i18n.formatMessage({
                                            id: "global.select-offer-modify-dates"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ModifyDates_ModifyDatesRoom = (ModifyDatesRoom);

;// CONCATENATED MODULE: ./src/effects/ModifyDates/ConfirmOffer/styles.js

function ConfirmOffer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 20px;\n  padding-inline: 20px;\n  position: fixed;\n  inset-block-end: 0;\n"
    ]);
    ConfirmOffer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConfirmOffer_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-height: 700px;\n  background-color: #fff;\n  overflow-y: hidden;\n  height: auto;\n\n  ",
        " {\n    margin-inline: 0;\n    margin-block: 20px;\n  }\n\n  ",
        " {\n    padding-block-start: 0;\n    min-height: 0;\n    height: calc(80vh);\n    overflow-y: scroll;\n  }\n\n  ",
        " {\n    position: fixed;\n    background-color: ",
        ";\n    padding-block: 10px;\n    padding-inline: 20px;\n    inset-block-end: 0;\n    width: 100%;\n    border-block-start: 1px solid ",
        ";\n\n    ",
        " {\n      position: unset;\n      padding-block: 20px;\n      padding-inline: 20px;\n      border-end-start-radius: 8px;\n      border-end-end-radius: 8px;\n    }\n  }\n"
    ]);
    ConfirmOffer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConfirmOffer_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 0;\n  padding-inline: 20px;\n  padding-bottom: 70px;\n\n  ",
        " {\n    padding-bottom: 0;\n  }\n"
    ]);
    ConfirmOffer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConfirmOffer_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n\n  padding-block: 15px;\n  padding-inline: 0;\n"
    ]);
    ConfirmOffer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ConfirmOffer_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 25px;\n  color: ",
        ";\n\n  padding-block: 0 16px;\n  padding-inline: 0;\n"
    ]);
    ConfirmOffer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ConfirmOffer_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border: var(--border-size-2) solid var(--color-neutral-400);\n  border-radius: var(--radius-8);\n\n  & > div {\n    border-width: 0;\n  }\n\n  & > section {\n    padding: var(--space-16);\n  }\n\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    ConfirmOffer_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var styles_ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ButtonWrapper",
    componentId: "sc-a50c69b9-0"
})(ConfirmOffer_styles_templateObject());
var ConfirmOfferBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ConfirmOfferBase",
    componentId: "sc-a50c69b9-1"
})(ConfirmOffer_styles_templateObject1(), InformationBoxBase, styles/* media.tablet */.BC.tablet, styles_ButtonWrapper, styles/* colors.white */.O9.white, styles/* colors.grey4 */.O9.grey4, styles/* media.tablet */.BC.tablet);
var ConfirmOffer_styles_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Content",
    componentId: "sc-a50c69b9-2"
})(ConfirmOffer_styles_templateObject2(), styles/* media.tablet */.BC.tablet);
var ConfirmOffer_styles_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-a50c69b9-3"
})(ConfirmOffer_styles_templateObject3());
var ConfirmOffer_styles_Title = (0,styled_components_browser_esm/* default */.ZP)(ConfirmOffer_styles_Row).withConfig({
    displayName: "styles__Title",
    componentId: "sc-a50c69b9-4"
})(ConfirmOffer_styles_templateObject4(), styles/* colors.grey1 */.O9.grey1);
var DetailsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DetailsWrapper",
    componentId: "sc-a50c69b9-5"
})(ConfirmOffer_styles_templateObject5(), styles/* media.tablet */.BC.tablet);

;// CONCATENATED MODULE: ./src/effects/ModifyDates/ConfirmOffer/messages.js

var ConfirmOffer_messages_messages = (0,lib/* defineMessages */.vU)({
    back: {
        id: "global.back"
    },
    confirmOffer: {
        id: "global.confirm-offer"
    },
    confirm: {
        id: "global.confirm"
    },
    importantInformation: {
        id: "global.confirm-conditions"
    },
    importantInformationTitle: {
        id: "global.important-information"
    }
});
/* harmony default export */ var ConfirmOffer_messages = (ConfirmOffer_messages_messages);

// EXTERNAL MODULE: ../../packages/icons/lib/IconArrowLeft.tsx
var IconArrowLeft = __webpack_require__(38062);
;// CONCATENATED MODULE: ./src/effects/ModifyDates/ConfirmOffer/index.js



















var ConfirmOffer = function(param) {
    var board = param.board, hash = param.hash, existingBooking = param.existingBooking;
    var handleBack = function handleBack() {
        dispatch((0,ModifyDates_actions/* modifyDatesBackToSelectOfferAction */.wN)());
    };
    var handleConfirmation = function handleConfirmation() {
        dispatch((0,ModifyDates_actions/* modifyDatesConfirmationRequestAction */.k1)({
            hash: hash,
            availabilityId: board.availabilityId
        }));
    };
    var intl = (0,useIntl/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var isFetching = (0,es/* useSelector */.v9)(getIsFetchingConfirmation);
    var ref = (0,es/* useSelector */.v9)(getDatesAndPaxes), checkInISO = ref.checkIn, checkOutISO = ref.checkOut;
    var step = (0,es/* useSelector */.v9)(getStep);
    var checkIn = (0,dates/* formatISO */.cK)(checkInISO);
    var checkOut = (0,dates/* formatISO */.cK)(checkOutISO);
    var newBooking = {
        checkIn: checkIn,
        checkOut: checkOut,
        adults: board === null || board === void 0 ? void 0 : board.adults,
        children: board === null || board === void 0 ? void 0 : board.children
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmOfferBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmOffer_styles_Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmOffer_styles_Title, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, ConfirmOffer_messages.confirmOffer))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Button */.zx, {
                        onClick: handleBack,
                        variant: "text-flat",
                        size: "small",
                        leadingIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowLeft/* IconArrowLeft */.D, {}),
                        className: "mb-16",
                        children: intl.formatMessage(ConfirmOffer_messages.back)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModifyDates_ModifyDatesDetails, {
                                booking: existingBooking,
                                newBooking: newBooking,
                                title: "change-dates.new-dates-title",
                                border: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModifyDates_ModifyDatesRoom, {
                                room: board,
                                existingBooking: existingBooking,
                                offerSelected: true,
                                isMultiroom: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_InformationBox, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {}),
                        text: intl.formatMessage(ConfirmOffer_messages.importantInformation),
                        title: intl.formatMessage(ConfirmOffer_messages.importantInformationTitle)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_DatesChangeConnected, {
                trackingData: {
                    context: "booking_thanks",
                    details: "Confirm offer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ButtonWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                        dataTestId: "confirm-offer-btn",
                        fullWidth: true,
                        isLoading: isFetching || step === null,
                        onClick: handleConfirmation,
                        text: intl.formatMessage(ConfirmOffer_messages.confirm),
                        variant: "primary"
                    })
                })
            })
        ]
    });
};
ConfirmOffer.propTypes = {
    board: prop_types_default().instanceOf(Object),
    hash: (prop_types_default()).string.isRequired,
    existingBooking: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var ModifyDates_ConfirmOffer = (ConfirmOffer);

// EXTERNAL MODULE: ./client/components/Rooms/BoardCode/styles.js
var BoardCode_styles = __webpack_require__(20239);
// EXTERNAL MODULE: ./src/comps/Capacity/styles.ts
var Capacity_styles = __webpack_require__(6865);
;// CONCATENATED MODULE: ./src/comps/RoomInformation/styles.js

function RoomInformation_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-radius: 8px;\n  border: 2px solid ",
        ";\n\n  width: 100%;\n"
    ]);
    RoomInformation_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RoomInformation_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 16px;\n  padding-inline: 16px;\n  ",
        " {\n    font-size: 16px;\n\n    text-transform: lowercase;\n    ::first-letter {\n      text-transform: uppercase;\n    }\n  }\n\n  ",
        " {\n    margin-block-end: 20px;\n  }\n"
    ]);
    RoomInformation_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RoomInformation_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  background-color: ",
        ";\n  width: 100%;\n  border-end-start-radius: 8px;\n  border-end-end-radius: 8px;\n\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n  width: 100%;\n\n  padding-block: 16px 12px;\n  padding-inline: 16px;\n  border-block-start: 1px solid ",
        ";\n"
    ]);
    RoomInformation_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RoomInformation_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n\n  padding-inline-start: 12px;\n"
    ]);
    RoomInformation_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RoomInformation_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 0 16px;\n  padding-inline: 16px 0;\n  color: ",
        ";\n"
    ]);
    RoomInformation_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RoomInformation_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-transform: capitalize;\n"
    ]);
    RoomInformation_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var RoomInformationBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RoomInformationBase",
    componentId: "sc-ef4726ae-0"
})(RoomInformation_styles_templateObject(), styles/* colors.white */.O9.white, styles/* colors.grey4 */.O9.grey4);
var RoomWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RoomWrapper",
    componentId: "sc-ef4726ae-1"
})(RoomInformation_styles_templateObject1(), BoardCode_styles/* BoardCodeBase */.R, Capacity_styles/* CapacityBase */.KJ);
var TotalCost = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TotalCost",
    componentId: "sc-ef4726ae-2"
})(RoomInformation_styles_templateObject2(), styles/* colors.white */.O9.white, styles/* fonts.default */.Rq["default"], styles/* colors.grey4 */.O9.grey4);
var Value = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__Value",
    componentId: "sc-ef4726ae-3"
})(RoomInformation_styles_templateObject3(), styles/* colors.grey2 */.O9.grey2);
var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Footer",
    componentId: "sc-ef4726ae-4"
})(RoomInformation_styles_templateObject4(), styles/* colors.grey2 */.O9.grey2);
var GreenCost = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__GreenCost",
    componentId: "sc-ef4726ae-5"
})(RoomInformation_styles_templateObject5(), styles/* colors.green4 */.O9.green4);

;// CONCATENATED MODULE: ./src/effects/ModifyDates/SelectOffer/styles.js

function SelectOffer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width: 100%;\n  overflow-y: hidden;\n  height: auto;\n\n  ",
        " {\n    height: calc(80vh);\n    overflow-y: scroll;\n  }\n"
    ]);
    SelectOffer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectOffer_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width: 100%;\n  padding-block: 0 var(--space-20);\n  padding-inline: var(--space-20);\n\n  ",
        " {\n    padding-block-start: var(--space-0);\n  }\n"
    ]);
    SelectOffer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SelectOffer_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  padding-block: var(--space-16);\n  padding-inline: var(--space-0);\n"
    ]);
    SelectOffer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SelectOffer_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 25px;\n  color: ",
        ";\n  padding-block: 0 var(--space-16);\n  padding-inline: 0;\n\n  ",
        " {\n    padding-inline: 0;\n  }\n"
    ]);
    SelectOffer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SelectOffer_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 500;\n  font-size: var(--font-size-1);\n  line-height: 100%;\n  color: ",
        ";\n  padding-block-end: var(--space-10);\n\n  ",
        " {\n    height: 28px;\n    padding-block: 0;\n    padding-inline: 0;\n  }\n"
    ]);
    SelectOffer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SelectOffer_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  gap: var(--space-16);\n\n  padding-block: var(--space-16);\n  padding-inline: var(--space-20);\n  ",
        " {\n    margin-block: var(--space-16);\n    margin-inline: 0;\n  }\n"
    ]);
    SelectOffer_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SelectOffer_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: column;\n  gap: var(--space-8);\n  align-items: center;\n\n  & > div {\n    border: var(--border-size-2) solid var(--color-neutral-400);\n    border-radius: var(--radius-8);\n    width: 100%;\n    padding: var(--space-16);\n  }\n\n  ",
        " {\n    flex-flow: row;\n    align-items: normal;\n    gap: var(--space-4);\n\n    & > svg {\n      align-self: center;\n      width: var(--size-48);\n      height: var(--size-48);\n      transform: rotate(270deg);\n    }\n  }\n"
    ]);
    SelectOffer_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var SelectOfferBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SelectOfferBase",
    componentId: "sc-15cc9eb0-0"
})(SelectOffer_styles_templateObject(), styles/* colors.grey5 */.O9.grey5, styles/* media.tablet */.BC.tablet);
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Header",
    componentId: "sc-15cc9eb0-1"
})(SelectOffer_styles_templateObject1(), styles/* colors.white */.O9.white, styles/* media.tablet */.BC.tablet);
var SelectOffer_styles_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-15cc9eb0-2"
})(SelectOffer_styles_templateObject2());
var SelectOffer_styles_Title = (0,styled_components_browser_esm/* default */.ZP)(SelectOffer_styles_Row).withConfig({
    displayName: "styles__Title",
    componentId: "sc-15cc9eb0-3"
})(SelectOffer_styles_templateObject3(), styles/* colors.grey1 */.O9.grey1, styles/* media.tablet */.BC.tablet);
var styles_Text = (0,styled_components_browser_esm/* default */.ZP)(SelectOffer_styles_Row).withConfig({
    displayName: "styles__Text",
    componentId: "sc-15cc9eb0-4"
})(SelectOffer_styles_templateObject4(), styles/* colors.grey2 */.O9.grey2, styles/* media.tablet */.BC.tablet);
var BoardsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoardsWrapper",
    componentId: "sc-15cc9eb0-5"
})(SelectOffer_styles_templateObject5(), RoomInformationBase);
var DatesDetailsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DatesDetailsWrapper",
    componentId: "sc-15cc9eb0-6"
})(SelectOffer_styles_templateObject6(), styles/* media.tablet */.BC.tablet);

// EXTERNAL MODULE: ./client/icons/ArrowDown.js
var ArrowDown = __webpack_require__(53589);
;// CONCATENATED MODULE: ./src/effects/ModifyDates/SelectOffer/messages.js

var SelectOffer_messages_messages = (0,lib/* defineMessages */.vU)({
    selectOffer: {
        id: "global.select-offer-modify-dates"
    },
    newSearch: {
        id: "global.your-new-search"
    },
    totalCostForChange: {
        id: "global.total-cost-change"
    }
});
/* harmony default export */ var SelectOffer_messages = (SelectOffer_messages_messages);

;// CONCATENATED MODULE: ./src/effects/ModifyDates/SelectOffer/index.js













var SelectOffer = function(param) {
    var adults = param.adults, children = param.children, childrenAges = param.childrenAges, _checkIn = param.checkIn, checkIn = _checkIn === void 0 ? new Date() : _checkIn, _checkOut = param.checkOut, checkOut = _checkOut === void 0 ? new Date() : _checkOut, _existingBooking = param.existingBooking, existingBooking = _existingBooking === void 0 ? {} : _existingBooking;
    var handleGoBack = function handleGoBack() {
        dispatch((0,ModifyDates_actions/* resetStatusNewDatesAndPaxesAction */.EJ)({
            checkIn: checkIn,
            checkOut: checkOut,
            adults: adults,
            children: children,
            childrenAges: childrenAges
        }));
    };
    var saveSelectedOffer = function saveSelectedOffer(board) {
        dispatch((0,ModifyDates_actions/* saveOfferAction */.JB)({
            board: board
        }));
    };
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var bookingRules = (0,es/* useSelector */.v9)(getBookingRules);
    var childrenAgesString = String(childrenAges);
    var selectedBooking = {
        checkIn: checkIn,
        checkOut: checkOut,
        adults: adults,
        children: children,
        childrenAges: childrenAgesString,
        currency: existingBooking === null || existingBooking === void 0 ? void 0 : existingBooking.currency
    };
    var totalFrom = bookingRules === null || bookingRules === void 0 ? void 0 : bookingRules.reduce(function(min, board) {
        return board.sellingRate < min ? board.sellingRate : min;
    }, ((ref = bookingRules[0]) === null || ref === void 0 ? void 0 : ref.sellingRate) || Infinity);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectOfferBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOffer_styles_Title, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, SelectOffer_messages.selectOffer))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DatesDetailsWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModifyDates_ModifyDatesDetails, {
                                    booking: existingBooking,
                                    title: "change-dates.original-dates-title",
                                    total: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModifyDates_ModifyDatesDetails, {
                                    booking: selectedBooking,
                                    title: "change-dates.new-dates-title",
                                    onClick: handleGoBack,
                                    totalFrom: totalFrom
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardsWrapper, {
                children: bookingRules === null || bookingRules === void 0 ? void 0 : bookingRules.map(function(board, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModifyDates_ModifyDatesRoom, {
                        room: board,
                        bestPrice: index === 0,
                        offerSelected: false,
                        onClick: function() {
                            return saveSelectedOffer(board);
                        },
                        existingBooking: existingBooking
                    }, board === null || board === void 0 ? void 0 : board.availabilityId);
                })
            })
        ]
    });
};
SelectOffer.propTypes = {
    adults: (prop_types_default()).number,
    boards: prop_types_default().instanceOf(Object),
    checkIn: prop_types_default().instanceOf(Date),
    checkOut: prop_types_default().instanceOf(Date),
    children: (prop_types_default()).number,
    childrenAges: prop_types_default().instanceOf(Array),
    sellingCurrent: (prop_types_default()).number,
    existingBooking: prop_types_default().instanceOf(Object),
    rooms: (prop_types_default()).number
};
/* harmony default export */ var ModifyDates_SelectOffer = (SelectOffer);

;// CONCATENATED MODULE: ./src/effects/ModifyDates/index.js
















var _obj;
var stepsMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ModifyDates_constants/* CHECK_AVAILABILITY */.UV, 0), (0,_define_property/* default */.Z)(_obj, ModifyDates_constants/* SELECT_OFFER */.xO, 1), (0,_define_property/* default */.Z)(_obj, ModifyDates_constants/* CONFIRM_OFFER */.bG, 2), (0,_define_property/* default */.Z)(_obj, ModifyDates_constants/* ERROR_CANCELLATION */.cl, 3), (0,_define_property/* default */.Z)(_obj, ModifyDates_constants/* ERROR_CONFIRMATION */.cy, 4), _obj);
var ModifyDates = function(param) {
    var bookingInformation = param.bookingInformation, modifyDatesSectionRef = param.modifyDatesSectionRef, _propertyId = param.propertyId, propertyId = _propertyId === void 0 ? "" : _propertyId, sellingRate = param.sellingRate, _rooms = param.rooms, rooms = _rooms === void 0 ? 1 : _rooms;
    var boardSelected = (0,es/* useSelector */.v9)(getBoardSelected);
    var datesAndPaxes = (0,es/* useSelector */.v9)(getDatesAndPaxes);
    var step = (0,es/* useSelector */.v9)(getStep);
    var ref = (0,react.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var bookingWithRooms = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bookingInformation), {
        rooms: rooms
    });
    (0,react.useEffect)(function() {
        if (step) setCurrentIndex(stepsMap[step]);
    }, [
        step
    ]);
    var steps = [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModifyDates_CheckAvailability, {
            existingBooking: bookingWithRooms,
            modifyDatesSectionRef: modifyDatesSectionRef,
            propertyId: propertyId,
            newDates: datesAndPaxes
        }, "".concat(step, "-").concat(currentIndex)),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModifyDates_SelectOffer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, datesAndPaxes), {
            beds: bookingInformation.beds,
            sellingCurrent: sellingRate,
            existingBooking: bookingWithRooms
        }), "SelectOffer-".concat(step, "-").concat(currentIndex)),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModifyDates_ConfirmOffer, {
            board: boardSelected,
            hash: bookingInformation === null || bookingInformation === void 0 ? void 0 : bookingInformation.hash,
            existingBooking: bookingWithRooms
        }, "ConfirmOffer-".concat(step, "-").concat(currentIndex)),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModifyDates_ConfirmationError, {
            variant: "CANCELLATION_NOT_OK"
        }, "CANCEL_NOT_OK-".concat(step, "-").concat(currentIndex)),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModifyDates_ConfirmationError, {
            variant: "RESERVATION_NOT_OK"
        }, "RESERV_NOT_OK-".concat(step, "-").concat(currentIndex)), 
    ];
    return steps[currentIndex];
};
ModifyDates_CheckAvailability.propTypes = {
    bookingInformation: prop_types_default().arrayOf(typeBookingInformation),
    modifyDatesSectionRef: client_types/* typeRef */.ct,
    propertyId: (prop_types_default()).string.isRequired,
    sellingRate: (prop_types_default()).number,
    rooms: (prop_types_default()).number.isRequired
};
ModifyDates.displayName = "ModifyDates";
ModifyDates.ConfirmExit = ModifyDates_ConfirmExit;
/* harmony default export */ var effects_ModifyDates = (ModifyDates);

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/parse/index.js + 50 modules
var parse = __webpack_require__(46423);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(28187);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/compareAsc/index.js
var compareAsc = __webpack_require__(2463);
// EXTERNAL MODULE: ./src/comps/PaymentForm/constants.js
var PaymentForm_constants = __webpack_require__(4708);
// EXTERNAL MODULE: ./client/contexts/Purchase/requests.js + 1 modules
var requests = __webpack_require__(46409);
// EXTERNAL MODULE: ./src/comps/Voucher/requests.js
var Voucher_requests = __webpack_require__(23395);
// EXTERNAL MODULE: ./src/comps/EmbedHtml/index.js
var EmbedHtml = __webpack_require__(71659);
// EXTERNAL MODULE: ./src/comps/PaymentForm/index.js + 32 modules
var PaymentForm = __webpack_require__(89561);
// EXTERNAL MODULE: ./src/comps/PayNow/constants.js
var PayNow_constants = __webpack_require__(41954);
;// CONCATENATED MODULE: ./src/comps/PayNow/selectors.js

var PayNow_selectors_getIsFetching = function(state) {
    var ref;
    return (ref = state[PayNow_constants/* PAY_NOW_STATE */.dM]) === null || ref === void 0 ? void 0 : ref.isFetching;
};
var getSecureCode = function(state) {
    var ref;
    return (ref = state[PayNow_constants/* PAY_NOW_STATE */.dM]) === null || ref === void 0 ? void 0 : ref.secureCode;
};

// EXTERNAL MODULE: ./src/comps/PayNow/actions.js
var PayNow_actions = __webpack_require__(55682);
// EXTERNAL MODULE: ./src/comps/CreditCardInfo/index.js + 1 modules
var CreditCardInfo = __webpack_require__(13473);
;// CONCATENATED MODULE: ./src/comps/PayNow/styles.js

function PayNow_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding-block: 0 20px;\n  padding-inline: 20px;\n  background: ",
        ";\n"
    ]);
    PayNow_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PayNow_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding-block-end: 20px;\n"
    ]);
    PayNow_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PayNow_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 27.3px;\n  color: ",
        ";\n  padding-block-end: 16px;\n"
    ]);
    PayNow_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PayNow_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n\n  color: ",
        ";\n"
    ]);
    PayNow_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PayNow_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  font-weight: 700;\n  width: 100%;\n  color: ",
        ";\n  padding-block-end: 20px;\n"
    ]);
    PayNow_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PayNow_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > div {\n    font-weight: normal;\n  }\n"
    ]);
    PayNow_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PayNow_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  cursor: pointer;\n  display: flex;\n  font-size: 14px;\n  line-height: 20px;\n  text-decoration: underline;\n\n  &:active,\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:focus {\n    outline: 0;\n  }\n"
    ]);
    PayNow_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PayNow_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block-end: 10px;\n"
    ]);
    PayNow_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var PayNowBase = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "styles__PayNowBase",
    componentId: "sc-fa2eb619-0"
})(PayNow_styles_templateObject(), styles/* colors.white */.O9.white);
var PayNow_styles_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-fa2eb619-1"
})(PayNow_styles_templateObject1());
var PayNow_styles_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Title",
    componentId: "sc-fa2eb619-2"
})(PayNow_styles_templateObject2(), styles/* colors.grey1 */.O9.grey1);
var PayNow_styles_Text = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Text",
    componentId: "sc-fa2eb619-3"
})(PayNow_styles_templateObject3(), styles/* colors.grey2 */.O9.grey2);
var PendingToPay = (0,styled_components_browser_esm/* default */.ZP)(PayNow_styles_Text).withConfig({
    displayName: "styles__PendingToPay",
    componentId: "sc-fa2eb619-4"
})(PayNow_styles_templateObject4(), styles/* colors.grey1 */.O9.grey1);
var PendingToPayText = (0,styled_components_browser_esm/* default */.ZP)(PendingToPay).withConfig({
    displayName: "styles__PendingToPayText",
    componentId: "sc-fa2eb619-5"
})(PayNow_styles_templateObject5());
var ChangeCreditCardLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__ChangeCreditCardLink",
    componentId: "sc-fa2eb619-6"
})(PayNow_styles_templateObject6(), styles/* colors.grey1 */.O9.grey1, styles/* colors.grey1 */.O9.grey1);
var PayNow_styles_ButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(PayNow_styles_Row).withConfig({
    displayName: "styles__ButtonWrapper",
    componentId: "sc-fa2eb619-7"
})(PayNow_styles_templateObject7());

;// CONCATENATED MODULE: ./src/comps/PayNow/messages.js

var PayNow_messages_messages = (0,lib/* defineMessages */.vU)({
    payNow: {
        id: "global.pay-now"
    },
    enterCard: {
        id: "global.select-card"
    },
    cancellationPoliciesRemain: {
        id: "global.cancel-remain"
    },
    cancelRemainExplain: {
        id: "global.cancel-remain-explain"
    },
    pendingToPay: {
        id: "global.pending-pay"
    },
    changeCreditCard: {
        id: "global.change-credit-card"
    },
    partialPay: {
        id: "reservation.partial-pay"
    },
    partialTitle: {
        id: "reservation.partial-pay-title"
    },
    partialPlaceholder: {
        id: "reservation.partial-pay-placeholder"
    }
});
/* harmony default export */ var PayNow_messages = (PayNow_messages_messages);

// EXTERNAL MODULE: ../../node_modules/rc-slider/es/index.js + 35 modules
var rc_slider_es = __webpack_require__(90843);
// EXTERNAL MODULE: ../../node_modules/rc-slider/assets/index.css
var assets = __webpack_require__(79373);
;// CONCATENATED MODULE: ./client/components/PriceRange/styles.js

function PriceRange_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-block: 27px 30px;\n  margin-inline: 10px;\n  ",
        "\n  .rc-slider-rail {\n    height: 2px;\n    background-color: ",
        ";\n  }\n  .rc-slider-track {\n    background-color: ",
        ";\n    height: 2px;\n  }\n  .rc-slider-handle {\n    width: 24px;\n    height: 24px;\n    border: solid 2px ",
        ";\n    margin-block-start: -11px;\n  }\n  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n    border-color: ",
        ";\n    box-shadow: 0 0 0 5px ",
        ";\n  }\n"
    ]);
    PriceRange_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PriceRange_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-block-end: 10px;\n  ",
        "\n  ",
        " {\n    max-width: calc(50% - 12px);\n  }\n"
    ]);
    PriceRange_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var loadingBlock = function() {
    return "\n  opacity: 0.5;\n  pointer: events;\n";
};
var RangeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RangeWrapper",
    componentId: "sc-c7985fe5-0"
})(PriceRange_styles_templateObject(), function(props) {
    return props.isLoading && loadingBlock();
}, styles/* colors.grey4 */.O9.grey4, styles/* colors.magenta */.O9.magenta, styles/* colors.magenta */.O9.magenta, styles/* colors.magenta */.O9.magenta, styles/* colors.magenta2 */.O9.magenta2);
var styles_InputSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__InputSection",
    componentId: "sc-c7985fe5-1"
})(PriceRange_styles_templateObject1(), function(props) {
    return props.isLoading && loadingBlock();
}, InputLine_styles/* InputWrapper */.SP);

;// CONCATENATED MODULE: ./src/comps/PayNow/PayPartialNow.js














var PayPartialNow = function(param) {
    var amount = param.amount, partialAmounts = param.partialAmounts, currency = param.currency, handleAmount = param.handleAmount;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayNow_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PayNow_styles_Title, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, PayNow_messages.partialPay))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PayNow_styles_Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PendingToPayText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, PayNow_messages.partialTitle), {
                                tagName: "div"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                amount: amount,
                                currency: currency
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rc_slider_es/* default */.Z, {
                            min: partialAmounts.min,
                            max: partialAmounts.max,
                            defaultValue: amount,
                            onChange: handleAmount
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayNow_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_InformationBox, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {}),
                    text: intl.formatMessage(PayNow_messages.cancelRemainExplain),
                    title: intl.formatMessage(PayNow_messages.cancellationPoliciesRemain)
                })
            })
        ]
    });
};
PayPartialNow.propTypes = {
    amount: (prop_types_default()).number,
    partialAmounts: prop_types_default().instanceOf({
        min: (prop_types_default()).number,
        max: (prop_types_default()).number
    }),
    currency: (prop_types_default()).string,
    handleAmount: (prop_types_default()).func
};
/* harmony default export */ var PayNow_PayPartialNow = (PayPartialNow);

;// CONCATENATED MODULE: ./src/comps/PayNow/PayAll.js











var PayAll = function(param) {
    var currency = param.currency, pendingAmount = param.pendingAmount;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PayNow_styles_Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PayNow_styles_Title, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, PayNow_messages.payNow))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PayNow_styles_Text, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, PayNow_messages.enterCard))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayNow_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_InformationBox, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {}),
                    text: intl.formatMessage(PayNow_messages.cancelRemainExplain),
                    title: intl.formatMessage(PayNow_messages.cancellationPoliciesRemain)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayNow_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PendingToPay, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, PayNow_messages.pendingToPay), {
                            tagName: "div"
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                            amount: pendingAmount,
                            currency: currency
                        })
                    ]
                })
            })
        ]
    });
};
PayAll.propTypes = {
    brand: (prop_types_default()).string,
    currency: (prop_types_default()).string,
    expiryDate: (prop_types_default()).string,
    handleCloseModal: (prop_types_default()).func,
    holder: (prop_types_default()).string,
    number: (prop_types_default()).string,
    partialPay: (prop_types_default()).bool,
    partialAmounts: prop_types_default().instanceOf({
        min: (prop_types_default()).number,
        max: (prop_types_default()).number
    }),
    pendingAmount: (prop_types_default()).number,
    purchaseId: (prop_types_default()).string,
    roomName: (prop_types_default()).string
};
/* harmony default export */ var PayNow_PayAll = (PayAll);

;// CONCATENATED MODULE: ./src/comps/PayNow/index.js


















var PayNow = function(param) {
    var bookingHash = param.bookingHash, brand = param.brand, currency = param.currency, expiryDate = param.expiryDate, handleCloseModal = param.handleCloseModal, holder = param.holder, number = param.number, _isPartialPay = param.isPartialPay, isPartialPay = _isPartialPay === void 0 ? false : _isPartialPay, _partialAmounts = param.partialAmounts, partialAmounts = _partialAmounts === void 0 ? {} : _partialAmounts, pendingAmount = param.pendingAmount, purchaseId = param.purchaseId;
    var handlePayNow = function handlePayNow(e) {
        e.preventDefault();
        dispatch((0,PayNow_actions/* payNowRequestAction */.$L)({
            purchaseId: purchaseId,
            creditCardNumber: number,
            amount: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                amount: amount,
                currency: currency
            }),
            rawAmount: amount,
            bookingHash: bookingHash,
            browserColorDepth: colorDepth,
            browserJavaEnabled: javaEnabled,
            browserLanguage: language,
            browserScreenHeight: screenHeight,
            browserScreenWidth: screenWidth,
            browserTimeZone: timeZone
        }));
    };
    var intl = (0,useIntl/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var isFetching = (0,es/* useSelector */.v9)(PayNow_selectors_getIsFetching);
    var secureCode = (0,es/* useSelector */.v9)(getSecureCode);
    var ref = (0,react.useState)(isPartialPay ? partialAmounts.min : pendingAmount), amount = ref[0], setAmount = ref[1];
    var ref1 = (0,useDevice/* useDevice */.F)(), colorDepth = ref1.colorDepth, javaEnabled = ref1.javaEnabled, language = ref1.language, screenHeight = ref1.screenHeight, screenWidth = ref1.screenWidth, timeZone = ref1.timeZone;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbedHtml/* default */.Z, {
                isBase64: true,
                children: secureCode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PayNowBase, {
                onSubmit: handlePayNow,
                children: [
                    isPartialPay ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PayNow_PayPartialNow, {
                        amount: amount,
                        currency: currency,
                        partialAmounts: partialAmounts,
                        handleAmount: setAmount
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PayNow_PayAll, {
                        currency: currency,
                        pendingAmount: pendingAmount
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PayNow_styles_Row, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardInfo/* default */.Z, {
                            holder: holder,
                            number: number,
                            expiryDate: expiryDate,
                            brand: brand,
                            inputRadioWrapped: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PayNow_styles_Row, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeCreditCardLink, {
                            onClick: handleCloseModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, PayNow_messages.changeCreditCard), {
                                tagName: "div"
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PayNow_styles_ButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                            fullWidth: true,
                            isLoading: isFetching,
                            text: intl.formatMessage(PayNow_messages.payNow),
                            variant: "primary"
                        })
                    })
                ]
            })
        ]
    });
};
PayNow.propTypes = {
    brand: (prop_types_default()).string,
    currency: (prop_types_default()).string,
    expiryDate: (prop_types_default()).string,
    handleCloseModal: (prop_types_default()).func,
    holder: (prop_types_default()).string,
    number: (prop_types_default()).string,
    isPartialPay: (prop_types_default()).bool,
    partialAmounts: prop_types_default().shape({
        min: (prop_types_default()).number,
        max: (prop_types_default()).number
    }),
    pendingAmount: (prop_types_default()).number,
    purchaseId: (prop_types_default()).string,
    roomName: (prop_types_default()).string,
    bookingHash: (prop_types_default()).string
};
/* harmony default export */ var comps_PayNow = (PayNow);

// EXTERNAL MODULE: ./src/comps/PaymentForm/styles.js
var PaymentForm_styles = __webpack_require__(40420);
;// CONCATENATED MODULE: ./client/components/PaymentInformation/styles.js

function PaymentInformation_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  background: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: 8px;\n  width: 100%;\n  padding-block: 20px;\n  padding-inline: 20px;\n  min-height: 130px;\n\n  ",
        " {\n    max-width: 430px;\n  }\n"
    ]);
    PaymentInformation_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PaymentInformation_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  padding-block-start: 20px;\n  width: 100%;\n"
    ]);
    PaymentInformation_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PaymentInformation_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  ",
        "\n"
    ]);
    PaymentInformation_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PaymentInformation_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  padding-block-end: 16px;\n  width: 100%;\n"
    ]);
    PaymentInformation_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PaymentInformation_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  width: 100%;\n"
    ]);
    PaymentInformation_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PaymentInformation_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  text-transform: capitalize;\n  font-size: 16px;\n  line-height: 150%;\n\n  color: ",
        ";\n"
    ]);
    PaymentInformation_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PaymentInformation_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n"
    ]);
    PaymentInformation_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PaymentInformation_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-block-end: 4px;\n  font-size: 16px;\n  line-height: 150%;\n\n  color: ",
        ";\n"
    ]);
    PaymentInformation_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 25px;\n  text-transform: capitalize;\n\n  color: ",
        ";\n  padding-block-end: 20px;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 150%;\n\n  padding-block: 16px 0;\n  padding-inline: 0;\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  ",
        " {\n    margin-block-start: 20px;\n  }\n\n  ",
        " {\n    ",
        " {\n      padding-block: 0;\n      padding-inline: 0;\n    }\n  }\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-block-end: 4px;\n  font-weight: 700;\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n  padding-block-end: 4px;\n\n  color: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 150%;\n  padding-block-end: 4px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  padding-block-start: 20px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}



var PaymentInformationBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PaymentInformationBase",
    componentId: "sc-7fa07a98-0"
})(PaymentInformation_styles_templateObject(), styles/* colors.white */.O9.white, styles/* colors.grey4 */.O9.grey4, styles/* media.desktop */.BC.desktop);
var PaymentInformation_styles_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-7fa07a98-1"
})(PaymentInformation_styles_templateObject1());
var PaidSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PaidSection",
    componentId: "sc-7fa07a98-2"
})(PaymentInformation_styles_templateObject2(), function(props) {
    return props.separator && "border-block-end: 1px solid ".concat(styles/* colors.grey4 */.O9.grey4);
});
var Transaction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Transaction",
    componentId: "sc-7fa07a98-3"
})(PaymentInformation_styles_templateObject3());
var styles_CreditCardInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CreditCardInfo",
    componentId: "sc-7fa07a98-4"
})(PaymentInformation_styles_templateObject4());
var PaymentDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PaymentDescription",
    componentId: "sc-7fa07a98-5"
})(PaymentInformation_styles_templateObject5(), styles/* colors.grey2 */.O9.grey2);
var PaymentDescriptionBold = (0,styled_components_browser_esm/* default */.ZP)(PaymentDescription).withConfig({
    displayName: "styles__PaymentDescriptionBold",
    componentId: "sc-7fa07a98-6"
})(PaymentInformation_styles_templateObject6());
var PaymentTotal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PaymentTotal",
    componentId: "sc-7fa07a98-7"
})(PaymentInformation_styles_templateObject7(), styles/* colors.grey2 */.O9.grey2);
var PaymentInformationTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PaymentInformationTitle",
    componentId: "sc-7fa07a98-8"
})(styles_templateObject8(), styles/* colors.grey1 */.O9.grey1);
var PendingPaymentTitle = (0,styled_components_browser_esm/* default */.ZP)(PaymentInformationTitle).withConfig({
    displayName: "styles__PendingPaymentTitle",
    componentId: "sc-7fa07a98-9"
})(styles_templateObject9());
var PendingSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PendingSection",
    componentId: "sc-7fa07a98-10"
})(styles_templateObject10(), PaymentForm_styles/* PaymentFormBase */.RA, styles/* updatedMedia.onlyMobile */.$c.onlyMobile, PaymentForm_styles/* PaymentFormBase */.RA);
var PendingValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PendingValue",
    componentId: "sc-7fa07a98-11"
})(styles_templateObject11());
var CreditCardNumberLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CreditCardNumberLabel",
    componentId: "sc-7fa07a98-12"
})(_templateObject12(), styles/* colors.grey1 */.O9.grey1);
var CreditCardNumberValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CreditCardNumberValue",
    componentId: "sc-7fa07a98-13"
})(_templateObject13());
var FeedbackSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FeedbackSection",
    componentId: "sc-7fa07a98-14"
})(_templateObject14());

;// CONCATENATED MODULE: ./client/components/PaymentInformation/messages.js

var PaymentInformation_messages_messages = (0,lib/* defineMessages */.vU)({
    paymentInfo: {
        id: "global.payment-info"
    },
    changeCreditCard: {
        id: "global.change-credit-card"
    },
    pendingToPay: {
        id: "global.pending-pay"
    },
    total: {
        id: "global.total"
    },
    creditCardUsed: {
        id: "voucher-credit-card-used"
    },
    payNow: {
        id: "global.pay-now"
    },
    partialPay: {
        id: "reservation.partial-pay"
    },
    warningCardExpiredAdd: {
        id: "global.card-expired-add"
    }
});
/* harmony default export */ var PaymentInformation_messages = (PaymentInformation_messages_messages);

;// CONCATENATED MODULE: ./client/components/PaymentInformation/index.js































var PaymentInformation = function(param) {
    var bookingHash = param.bookingHash, confirmedStatus = param.confirmedStatus, creditCard = param.creditCard, currency = param.currency, _displayForm = param.displayForm, displayForm = _displayForm === void 0 ? true : _displayForm, hash = param.hash, isCancellable = param.isCancellable, isCreditCard = param.isCreditCard, isPayable = param.isPayable, language = param.language, needToPay = param.needToPay, paymentMethods = param.paymentMethods, _partialAmounts = param.partialAmounts, partialAmounts = _partialAmounts === void 0 ? {} : _partialAmounts, pendingAmount = param.pendingAmount, purchaseId = param.purchaseId, _ticketsPaid = param.ticketsPaid, ticketsPaid = _ticketsPaid === void 0 ? [] : _ticketsPaid, totalPaid = param.totalPaid;
    var closeModal = function closeModal() {
        setIsButtonOn(true);
        setOpen(false);
    };
    var emailValidationMessage = function emailValidationMessage() {
        return isPartialPay ? PaymentInformation_messages.partialPay : PaymentInformation_messages.payNow;
    };
    var onPaymentFail = function onPaymentFail() {
        setPaymentError(true);
        setIsConfirming(false);
    };
    var shouldDisplayCreditCardPaid = function shouldDisplayCreditCardPaid(tickets) {
        return tickets.length === 0 || tickets.some(function(ticket) {
            return ticket.paymentMethod === PaymentForm_constants/* CREDIT_CARD_PAYMENT_METHOD */.io;
        });
    };
    var intl = (0,useIntl/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var device = (0,useDevice/* useDevice */.F)().device;
    var isWide = (0,useMedia/* default */.Z)(styles/* breakpoint.tablet */.eq.tablet, device !== "mobile");
    var email = (0,es/* useSelector */.v9)(getEmail);
    var statusResponseEmail = (0,es/* useSelector */.v9)(selectors_getStatus(hash));
    var payNow = (0,es/* useSelector */.v9)(getPayNow);
    var ref = (0,react.useState)(false), invalidCreditCard = ref[0], setInvalidCreditCard = ref[1];
    var ref1 = (0,react.useState)(false), isButtonOn = ref1[0], setIsButtonOn = ref1[1];
    var ref2 = (0,react.useState)(false), isConfirming = ref2[0], setIsConfirming = ref2[1];
    var ref3 = (0,react.useState)(false), open = ref3[0], setOpen = ref3[1];
    var ref4 = (0,react.useState)(false), paymentError = ref4[0], setPaymentError = ref4[1];
    var ref5 = (0,react.useState)(), secureCode = ref5[0], setSecureCode = ref5[1];
    var ref6 = (0,react.useState)(false), isPartialPay = ref6[0], setPartialPay = ref6[1];
    function onPaymentSuccess(paymentMethod, paymentParams) {
        return _onPaymentSuccess.apply(this, arguments);
    }
    function _onPaymentSuccess() {
        _onPaymentSuccess = (0,_async_to_generator/* default */.Z)(function(paymentMethod, paymentParams) {
            var ref, confirmation, challengeUrl, secureCodeRaw, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsConfirming(true);
                        setPaymentError(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!(paymentParams && paymentParams.paytpvToken)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,requests/* createAliasVoucher */.$5)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, paymentParams), {
                                purchaseId: purchaseId
                            }))
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            (0,Voucher_requests/* voucherPay */.p)({
                                purchaseId: purchaseId,
                                language: language,
                                hash: hash
                            })
                        ];
                    case 4:
                        ref = _state.sent(), confirmation = ref.data;
                        challengeUrl = confirmation.challenge_url // eslint-disable-line camelcase
                        ;
                        if (challengeUrl) {
                            window.location.href = challengeUrl;
                            return [
                                2
                            ];
                        }
                        secureCodeRaw = confirmation.secure_html_raw // eslint-disable-line camelcase
                        ;
                        if (secureCodeRaw) {
                            setSecureCode(secureCodeRaw);
                            return [
                                2
                            ];
                        }
                        dispatch((0,actions/* fetchVoucherRequestAction */.hE)({
                            purchaseId: purchaseId
                        }));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e = _state.sent();
                        onPaymentFail();
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _onPaymentSuccess.apply(this, arguments);
    }
    var checkCreditCardExpiration = function(expiryDate) {
        var currentDate = new Date();
        var expirationDate = (0,parse/* default */.Z)(expiryDate, "MMyy", new Date());
        var firstInvalidExpDate = (0,addMonths/* default */.Z)(expirationDate, 1);
        var notExpired = (0,compareAsc/* default */.Z)(firstInvalidExpDate, currentDate) > 0;
        if (notExpired) {
            setOpen(true);
        } else {
            setInvalidCreditCard(true);
            setIsButtonOn(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentInformationBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInformationTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, PaymentInformation_messages.paymentInfo))
            }),
            creditCard && shouldDisplayCreditCardPaid(ticketsPaid) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CreditCardInfo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardNumberLabel, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, PaymentInformation_messages.creditCardUsed))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardNumberValue, {
                        children: creditCard === null || creditCard === void 0 ? void 0 : creditCard.number
                    })
                ]
            }),
            ticketsPaid.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaidSection, {
                separator: pendingAmount > 0 || ticketsPaid.length > 1,
                children: ticketsPaid.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Transaction, {
                        "data-testid": "paid-transaction",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CreditCardInfo, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentDescription, {
                                    children: intl.formatDate(item.paymentDate)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentTotal, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                        amount: item.total,
                                        currency: item.currency
                                    })
                                })
                            ]
                        })
                    }, "ticket-".concat(item.total));
                })
            }),
            ticketsPaid.length > 1 && pendingAmount === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInformation_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CreditCardInfo, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentDescriptionBold, {
                            "data-testid": "total-payment",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, PaymentInformation_messages.total))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentTotal, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                amount: totalPaid,
                                currency: currency
                            })
                        })
                    ]
                })
            }),
            pendingAmount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PendingSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Transaction, {
                        "data-testid": "pending-transaction",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CreditCardInfo, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentDescription, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PendingPaymentTitle, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, PaymentInformation_messages.pendingToPay))
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PendingValue, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                        amount: pendingAmount,
                                        currency: currency
                                    })
                                })
                            ]
                        })
                    }),
                    (isPayable || isCancellable) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            isPayable && isCreditCard && confirmedStatus && !(isButtonOn || needToPay) && payNow && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInformation_styles_Row, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                                    onClick: function() {
                                        setPartialPay(false);
                                        checkCreditCardExpiration(creditCard === null || creditCard === void 0 ? void 0 : creditCard.expirationDate);
                                    },
                                    variant: "primary",
                                    dataTestId: "pay-now",
                                    text: intl.formatMessage(PaymentInformation_messages.payNow),
                                    fullWidth: true,
                                    disabled: isButtonOn
                                })
                            }),
                            isPayable && confirmedStatus && partialAmounts.min && partialAmounts.max && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInformation_styles_Row, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                                    onClick: function() {
                                        setPartialPay(true);
                                        checkCreditCardExpiration(creditCard === null || creditCard === void 0 ? void 0 : creditCard.expirationDate);
                                    },
                                    variant: "tertiary",
                                    dataTestId: "pay-partial",
                                    text: intl.formatMessage(PaymentInformation_messages.partialPay),
                                    fullWidth: true,
                                    disabled: isButtonOn
                                })
                            }),
                            confirmedStatus && displayForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInformation_styles_Row, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                                    onClick: function() {
                                        return setIsButtonOn(!isButtonOn);
                                    },
                                    variant: needToPay ? "primary" : "tertiary",
                                    dataTestId: "change-credit-card",
                                    text: intl.formatMessage(PaymentInformation_messages.changeCreditCard),
                                    fullWidth: true
                                })
                            }),
                            invalidCreditCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackSection, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FeedbackVoucher, {
                                    dataTestId: "status-not-ok",
                                    text: [
                                        intl.formatMessage(PaymentInformation_messages.warningCardExpiredAdd)
                                    ],
                                    status: "STATUS_NOT_OK"
                                })
                            })
                        ]
                    }),
                    isButtonOn && displayForm && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm/* default */.Z, {
                                paymentMethods: paymentMethods,
                                onSuccess: onPaymentSuccess,
                                onError: onPaymentFail,
                                error: paymentError,
                                isConfirming: isConfirming,
                                consumer: PaymentForm_constants/* VOUCHER */.uB
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbedHtml/* default */.Z, {
                                isBase64: true,
                                children: secureCode
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                handleClose: function() {
                    return setOpen(false);
                },
                show: open,
                variant: isWide ? Modal_constants/* VARIANT_ALONE */.BG : Modal_constants/* VARIANT_FULLSCREEN */.VU,
                width: "580px",
                children: email && statusResponseEmail === "STATUS_OK" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_PayNow, {
                    brand: creditCard === null || creditCard === void 0 ? void 0 : creditCard.brand,
                    currency: currency,
                    expiryDate: creditCard === null || creditCard === void 0 ? void 0 : creditCard.expirationDate,
                    handleCloseModal: closeModal,
                    holder: creditCard === null || creditCard === void 0 ? void 0 : creditCard.holder,
                    number: creditCard === null || creditCard === void 0 ? void 0 : creditCard.number,
                    pendingAmount: pendingAmount,
                    purchaseId: purchaseId,
                    isPartialPay: isPartialPay,
                    partialAmounts: partialAmounts,
                    bookingHash: bookingHash
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(effects_VerifyEmail, {
                    buttonText: intl.formatMessage(emailValidationMessage()),
                    hash: hash
                })
            })
        ]
    });
};
PaymentInformation.propTypes = {
    bookingHash: (prop_types_default()).string,
    confirmedStatus: (prop_types_default()).bool,
    currency: (prop_types_default()).string,
    displayForm: (prop_types_default()).bool,
    hash: (prop_types_default()).string,
    isCancellable: (prop_types_default()).bool,
    isCreditCard: (prop_types_default()).bool,
    isPayable: (prop_types_default()).bool,
    language: (prop_types_default()).string,
    needToPay: (prop_types_default()).bool,
    partialAmounts: prop_types_default().shape({
        min: (prop_types_default()).number,
        max: (prop_types_default()).number
    }),
    paymentMethods: checkout/* typePaymentMethods */.In,
    pendingAmount: (prop_types_default()).number,
    purchaseId: (prop_types_default()).string,
    ticketsPaid: prop_types_default().arrayOf(Object),
    totalPaid: (prop_types_default()).number,
    creditCard: prop_types_default().shape({
        number: (prop_types_default()).string,
        brand: (prop_types_default()).string,
        holder: (prop_types_default()).string,
        expirationDate: (prop_types_default()).string
    })
};
/* harmony default export */ var components_PaymentInformation = (PaymentInformation);

// EXTERNAL MODULE: ./src/comps/BedType/index.js + 3 modules
var BedType = __webpack_require__(52340);
// EXTERNAL MODULE: ./client/components/Rooms/BoardCode/index.js + 1 modules
var BoardCode = __webpack_require__(94424);
;// CONCATENATED MODULE: ./src/comps/BookingInformation/RoomCard/styles.js

function RoomCard_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 600px;\n  padding-block: 16px;\n  padding-inline: 16px;\n\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 8px;\n  overflow: hidden;\n\n  @media screen and (max-width: ",
        "px) {\n    max-width: 100%;\n    width: 100%;\n  }\n"
    ]);
    RoomCard_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RoomCard_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n\n  padding-block-end: 8px;\n"
    ]);
    RoomCard_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RoomCard_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block-start: 0;\n"
    ]);
    RoomCard_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RoomCard_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block-end: 12px;\n"
    ]);
    RoomCard_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RoomCard_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n  padding-inline-end: 12px;\n\n  color: ",
        ";\n"
    ]);
    RoomCard_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RoomCard_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n"
    ]);
    RoomCard_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RoomCard_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 150%;\n  padding-inline-end: 5px;\n\n  color: ",
        ";\n"
    ]);
    RoomCard_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function RoomCard_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n"
    ]);
    RoomCard_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function RoomCard_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-end;\n\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 150%;\n  margin-block-end: 8px;\n\n  color: ",
        ";\n"
    ]);
    RoomCard_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var RoomCardBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RoomCardBase",
    componentId: "sc-6353ebba-0"
})(RoomCard_styles_templateObject(), styles/* colors.white */.O9.white, styles/* colors.grey4 */.O9.grey4, styles/* sizes.desktop */.J7.desktop - 1);
var RoomCard_styles_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-6353ebba-1"
})(RoomCard_styles_templateObject1());
var RoomDescription = (0,styled_components_browser_esm/* default */.ZP)(RoomCard_styles_Row).withConfig({
    displayName: "styles__RoomDescription",
    componentId: "sc-6353ebba-2"
})(RoomCard_styles_templateObject2());
var HolderInformation = (0,styled_components_browser_esm/* default */.ZP)(RoomCard_styles_Row).withConfig({
    displayName: "styles__HolderInformation",
    componentId: "sc-6353ebba-3"
})(RoomCard_styles_templateObject3());
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Label",
    componentId: "sc-6353ebba-4"
})(RoomCard_styles_templateObject4(), styles/* colors.grey1 */.O9.grey1);
var LabelBold = (0,styled_components_browser_esm/* default */.ZP)(Label).withConfig({
    displayName: "styles__LabelBold",
    componentId: "sc-6353ebba-5"
})(RoomCard_styles_templateObject5());
var styles_Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Value",
    componentId: "sc-6353ebba-6"
})(RoomCard_styles_templateObject6(), styles/* colors.grey2 */.O9.grey2);
var Holder = (0,styled_components_browser_esm/* default */.ZP)(styles_Value).withConfig({
    displayName: "styles__Holder",
    componentId: "sc-6353ebba-7"
})(RoomCard_styles_templateObject7());
var BoardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BoardWrapper",
    componentId: "sc-6353ebba-8"
})(RoomCard_styles_templateObject8(), styles/* colors.grey2 */.O9.grey2);

;// CONCATENATED MODULE: ./src/comps/BookingInformation/RoomCard/messages.js

var RoomCard_messages_messages = (0,lib/* defineMessages */.vU)({
    room: {
        id: "global.room"
    },
    holder: {
        id: "global.holder"
    }
});
/* harmony default export */ var RoomCard_messages = (RoomCard_messages_messages);

// EXTERNAL MODULE: ./client/icons/MobilePhone.js
var MobilePhone = __webpack_require__(68436);
;// CONCATENATED MODULE: ./src/comps/MobileOnlyPrice/styles.js

function MobileOnlyPrice_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: ",
        ";\n  background-color: ",
        ";\n  padding-block: 4px;\n  padding-inline: 20px 8px;\n  border-start-start-radius: 0;\n  border-start-end-radius: 8px;\n  border-end-start-radius: 0;\n  border-end-end-radius: 8px;\n  width: max-content;\n  margin-inline-start: -20px;\n"
    ]);
    MobileOnlyPrice_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MobileOnlyPrice_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-block-end: 6px;\n      svg {\n        fill: ",
        ";\n      }\n      p {\n        color: ",
        ";\n        font-size: 16px;\n      }\n\n      ",
        " {\n        background-color: ",
        ";\n      }\n    "
    ]);
    MobileOnlyPrice_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MobileOnlyPrice_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 22px;\n  margin-block-end: ",
        ";\n  margin-block-start: 0;\n  width: 100%;\n\n  svg {\n    flex: 0 0 auto;\n    fill: ",
        ";\n    width: 20px;\n    height: 20px;\n  }\n\n  p {\n    width: 100%;\n    display: block;\n    font-size: 14px;\n    line-height: 20px;\n    margin-inline-start: 8px;\n    font-weight: 700;\n\n    &::first-letter {\n      text-transform: uppercase;\n    }\n  }\n\n  ",
        "\n"
    ]);
    MobileOnlyPrice_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var MobileOnlyContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MobileOnlyContainer",
    componentId: "sc-d23f9eb2-0"
})(MobileOnlyPrice_styles_templateObject(), styles/* colors.white */.O9.white, styles/* colors.green4 */.O9.green4);
var MobileOnlyBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MobileOnlyBase",
    componentId: "sc-d23f9eb2-1"
})(MobileOnlyPrice_styles_templateObject2(), function(props) {
    return props.as === "li" ? "4px" : "8px";
}, styles/* colors.white */.O9.white, function(props) {
    return props.variant === "text" && (0,styled_components_browser_esm/* css */.iv)(MobileOnlyPrice_styles_templateObject1(), props.theme.colors.success, props.theme.colors.success, MobileOnlyContainer, props.theme.colors.grey8);
});

;// CONCATENATED MODULE: ./src/comps/MobileOnlyPrice/messages.js

var MobileOnlyPrice_messages_messages = (0,lib/* defineMessages */.vU)({
    mobileOnlyTag: {
        id: "global.mobile-only-price"
    }
});
/* harmony default export */ var MobileOnlyPrice_messages = (MobileOnlyPrice_messages_messages);

;// CONCATENATED MODULE: ./src/comps/MobileOnlyPrice/index.js










var MobileOnlyPrice = function(param) {
    var isMobileRate = param.isMobileRate, _as = param.as, as = _as === void 0 ? "div" : _as, _variant = param.variant, variant = _variant === void 0 ? "label" : _variant;
    var device = (0,useDevice/* useDevice */.F)().device;
    if (!isMobileRate || device === "desktop") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOnlyBase, {
        "data-testid": "is-mobile-price",
        as: as,
        variant: variant,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileOnlyContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobilePhone/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, MobileOnlyPrice_messages.mobileOnlyTag), {
                    tagName: "p"
                }))
            ]
        })
    });
};
MobileOnlyPrice.propTypes = {
    as: (prop_types_default()).string,
    isMobileRate: (prop_types_default()).bool,
    variant: prop_types_default().oneOf([
        "label",
        "text"
    ])
};
/* harmony default export */ var comps_MobileOnlyPrice = (MobileOnlyPrice);

;// CONCATENATED MODULE: ./src/comps/BookingInformation/RoomCard/RoomCard.js











var RoomCard = function(param) {
    var adults = param.adults, beds = param.beds, boardCode = param.boardCode, boardName = param.boardName, children = param.children, childrenAges = param.childrenAges, holders = param.holders, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, roomName = param.roomName, rooms = param.rooms;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoomCardBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoomDescription, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, RoomCard_messages.room)),
                            ":"
                        ]
                    }),
                    rooms > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Value, {
                        children: "(x".concat(rooms, ")")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Value, {
                        children: roomName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomCard_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Capacity/* default */.Z, {
                    adults: adults,
                    children: children,
                    childrenAges: childrenAges
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomCard_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BedType/* default */.Z, {
                    beds: beds
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HolderInformation, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelBold, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, RoomCard_messages.holder)),
                            ":"
                        ]
                    }),
                    holders.map(function(holder, index) {
                        if (index < holders.length - 1) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Holder, {
                                children: "".concat(holder.name, ", ")
                            }, "holder-".concat(holder.name));
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Holder, {
                            children: holder.name
                        }, "holder-".concat(holder.name));
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardCode/* default */.Z, {
                    name: boardName,
                    code: boardCode
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_MobileOnlyPrice, {
                isMobileRate: isMobile
            })
        ]
    });
};
RoomCard.propTypes = {
    adults: (prop_types_default()).number,
    boardCode: (prop_types_default()).string,
    boardName: (prop_types_default()).string,
    children: (prop_types_default()).number,
    childrenAges: (prop_types_default()).string,
    holders: prop_types_default().arrayOf(prop_types_default().shape({
        name: (prop_types_default()).string
    })),
    isMobile: (prop_types_default()).bool,
    roomName: (prop_types_default()).string,
    rooms: (prop_types_default()).number,
    beds: prop_types_default().arrayOf(prop_types_default().shape({
        type: (prop_types_default()).string,
        description: (prop_types_default()).string,
        quantity: (prop_types_default()).number
    }))
};
/* harmony default export */ var RoomCard_RoomCard = (RoomCard);

// EXTERNAL MODULE: ./src/effects/SpecialRequests/actions.js
var SpecialRequests_actions = __webpack_require__(79113);
// EXTERNAL MODULE: ./src/effects/SpecialRequests/constants.js
var SpecialRequests_constants = __webpack_require__(90280);
;// CONCATENATED MODULE: ./src/effects/SpecialRequests/selectors.js

var SpecialRequests_selectors_getIsFetching = function(hash) {
    return function(state) {
        var ref, ref1;
        return (ref1 = (ref = state[SpecialRequests_constants/* SPECIAL_REQUESTS_STATE */.A6]) === null || ref === void 0 ? void 0 : ref.bookings[hash]) === null || ref1 === void 0 ? void 0 : ref1.isFetching;
    };
};
var SpecialRequests_selectors_getStatus = function(hash) {
    return function(state) {
        var ref, ref1;
        return (ref1 = (ref = state[SpecialRequests_constants/* SPECIAL_REQUESTS_STATE */.A6]) === null || ref === void 0 ? void 0 : ref.bookings[hash]) === null || ref1 === void 0 ? void 0 : ref1.status;
    };
};

// EXTERNAL MODULE: ./src/comps/TextArea/index.js + 1 modules
var TextArea = __webpack_require__(88113);
// EXTERNAL MODULE: ./src/effects/SpecialRequests/RequestSentPreview/styles.module.css
var RequestSentPreview_styles_module = __webpack_require__(89076);
var RequestSentPreview_styles_module_default = /*#__PURE__*/__webpack_require__.n(RequestSentPreview_styles_module);
;// CONCATENATED MODULE: ./src/effects/SpecialRequests/RequestSentPreview/index.tsx






var RequestSentPreview = function(param) {
    var children = param.children, Icon = param.icon, hasBackground = param.hasBackground, title = param.title;
    var baseClassName = classnames_default()((RequestSentPreview_styles_module_default()).requestSent, (0,_define_property/* default */.Z)({}, (RequestSentPreview_styles_module_default()).requestSentWithBackground, hasBackground));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: baseClassName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (RequestSentPreview_styles_module_default()).requestSentTitle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        className: (RequestSentPreview_styles_module_default()).requestSentTitleIcon
                    }),
                    " ",
                    title
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (RequestSentPreview_styles_module_default()).requestSentMessage,
                children: children || /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "room.special-requests-confirmation"
                })
            })
        ]
    });
};
/* harmony default export */ var SpecialRequests_RequestSentPreview = (RequestSentPreview);
RequestSentPreview.displayName = "RequestSentPreview";

// EXTERNAL MODULE: ../../packages/icons/lib/IconPeople.tsx
var IconPeople = __webpack_require__(50818);
// EXTERNAL MODULE: ./src/effects/SpecialRequests/RequestSentMessage/styles.module.css
var RequestSentMessage_styles_module = __webpack_require__(89751);
var RequestSentMessage_styles_module_default = /*#__PURE__*/__webpack_require__.n(RequestSentMessage_styles_module);
;// CONCATENATED MODULE: ./src/effects/SpecialRequests/RequestSentMessage/index.tsx






var RequestSentMessage = function(param) {
    var specialRequests = param.specialRequests;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: specialRequests.map(function(item, index) {
            var _requestKey;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-testid": "special-requests-".concat(index),
                children: item.requestKey ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (RequestSentMessage_styles_module_default()).requestName,
                            children: "".concat(item.requestKey, ":")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (RequestSentMessage_styles_module_default()).requestValue,
                            children: item.requestValue
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialRequests_RequestSentPreview, {
                    icon: IconPeople/* IconPeople */.G,
                    title: item.datetime ? intl.formatTime(item.datetime, {
                        day: "numeric",
                        month: "long",
                        year: "numeric"
                    }) : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        "data-testid": "comment-".concat(index),
                        children: item.requestValue
                    })
                })
            }, (_requestKey = item.requestKey) !== null && _requestKey !== void 0 ? _requestKey : index);
        })
    });
};
/* harmony default export */ var SpecialRequests_RequestSentMessage = (RequestSentMessage);
RequestSentMessage.displayName = "RequestSentMessage";

// EXTERNAL MODULE: ../../packages/icons/lib/IconCallCenter.tsx
var IconCallCenter = __webpack_require__(57184);
;// CONCATENATED MODULE: ../../packages/icons/lib/IconPlus.tsx




var IconPlus = function(_param) {
    var _color = _param.color, color = _color === void 0 ? "currentColor" : _color, _size = _param.size, size = _size === void 0 ? 24 : _size, className = _param.className, _rotateOnRtl = _param.rotateOnRtl, rotateOnRtl = _rotateOnRtl === void 0 ? false : _rotateOnRtl, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size",
        "className",
        "rotateOnRtl"
    ]);
    var props = (0,_object_spread/* default */.Z)((0,_define_property/* default */.Z)({
        width: size,
        height: size,
        fill: color,
        // stroke: color,
        className: className,
        viewBox: "0 0 24 24"
    }, "data-rotateonrtl", false), rest);
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z"
    }));
};

;// CONCATENATED MODULE: ../../packages/icons/lib/IconMinus.tsx




var IconMinus = function(_param) {
    var _color = _param.color, color = _color === void 0 ? "currentColor" : _color, _size = _param.size, size = _size === void 0 ? 24 : _size, className = _param.className, _rotateOnRtl = _param.rotateOnRtl, rotateOnRtl = _rotateOnRtl === void 0 ? false : _rotateOnRtl, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size",
        "className",
        "rotateOnRtl"
    ]);
    var props = (0,_object_spread/* default */.Z)((0,_define_property/* default */.Z)({
        width: size,
        height: size,
        fill: color,
        // stroke: color,
        className: className,
        viewBox: "0 0 24 24"
    }, "data-rotateonrtl", false), rest);
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z"
    }));
};

// EXTERNAL MODULE: ./src/effects/SpecialRequests/styles.module.css
var SpecialRequests_styles_module = __webpack_require__(7032);
var SpecialRequests_styles_module_default = /*#__PURE__*/__webpack_require__.n(SpecialRequests_styles_module);
;// CONCATENATED MODULE: ./src/effects/SpecialRequests/index.tsx



















var SpecialRequests = function(param) {
    var _specialRequests = param.specialRequests, specialRequests = _specialRequests === void 0 ? [] : _specialRequests, hash = param.hash;
    var handleAddNewSpecialRequests = function handleAddNewSpecialRequests() {
        setAddedRequests(function(prev) {
            return (0,_to_consumable_array/* default */.Z)(prev).concat([
                {
                    requestValue: textAreaValue,
                    datetime: new Date()
                }
            ]);
        });
        dispatch((0,SpecialRequests_actions/* fetchSpecialRequestsRequestAction */.Lk)({
            hash: hash,
            hotelRequest: textAreaValue
        }));
        setTextAreaValue("");
    };
    var intl = (0,useIntl/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var isLoading = (0,es/* useSelector */.v9)(SpecialRequests_selectors_getIsFetching(hash));
    var status = (0,es/* useSelector */.v9)(SpecialRequests_selectors_getStatus(hash));
    var ref = (0,react.useState)(""), textAreaValue = ref[0], setTextAreaValue = ref[1];
    var ref1 = (0,react.useState)([]), addedRequests = ref1[0], setAddedRequests = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SpecialRequests_styles_module_default()).specialRequests,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                className: (SpecialRequests_styles_module_default()).specialRequestsTitle,
                variant: "title",
                size: "s",
                as: "h5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "room.special-requests"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialRequests_RequestSentMessage, {
                specialRequests: (0,_to_consumable_array/* default */.Z)(specialRequests).concat((0,_to_consumable_array/* default */.Z)(addedRequests))
            }),
            specialRequests.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialRequests_RequestSentPreview, {
                hasBackground: true,
                icon: IconCallCenter/* IconCallCenter */.O,
                title: intl.formatMessage({
                    id: "room.special-requests-default-message"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleSection/* default */.Z, {
                fullWidth: true,
                "data-testid": "add-special-requests-section",
                title: intl.formatMessage({
                    id: "special-requests"
                }),
                iconToOpen: IconPlus,
                iconToClose: IconMinus,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SpecialRequests_styles_module_default()).addSpecialRequest,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "checkout.special-requests-advice",
                            tagName: "span"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                            role: "textbox",
                            placeholder: intl.formatMessage({
                                id: "room.special-requests"
                            }),
                            value: textAreaValue,
                            onChange: function(event) {
                                return setTextAreaValue(event.target.value);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                            onClick: handleAddNewSpecialRequests,
                            variant: "primary",
                            dataTestId: "send-request-btn",
                            text: intl.formatMessage({
                                id: "global.send-request"
                            }),
                            isLoading: isLoading,
                            disabled: textAreaValue === ""
                        })
                    ]
                })
            }),
            status === SpecialRequests_constants/* STATUS_OK */.Us && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SpecialRequests_styles_module_default()).feedbackSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FeedbackVoucher, {
                    dataTestId: "status-ok",
                    text: [
                        intl.formatMessage({
                            id: "room.special-requests-confirmation"
                        })
                    ],
                    status: SpecialRequests_constants/* STATUS_OK */.Us
                })
            }),
            status === SpecialRequests_constants/* STATUS_NOT_OK */.lm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SpecialRequests_styles_module_default()).feedbackSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FeedbackVoucher, {
                    dataTestId: "status-not-ok",
                    text: [
                        intl.formatMessage({
                            id: "room.special-requests-notok"
                        })
                    ],
                    status: SpecialRequests_constants/* STATUS_NOT_OK */.lm
                })
            })
        ]
    });
};
/* harmony default export */ var effects_SpecialRequests = (SpecialRequests);

// EXTERNAL MODULE: ./src/comps/ButtonSimple/styles.js
var ButtonSimple_styles = __webpack_require__(27933);
;// CONCATENATED MODULE: ./src/comps/BookingInformation/styles.js

function BookingInformation_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    BookingInformation_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BookingInformation_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    BookingInformation_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BookingInformation_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    BookingInformation_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BookingInformation_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    BookingInformation_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BookingInformation_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background: ",
        ";\n  padding-block: 20px;\n  padding-inline: ",
        ";\n  ",
        ";\n  border-radius: 8px;\n\n  height: 100%;\n  width: 100%;\n\n  ",
        " {\n    background-color: unset;\n    position: relative;\n  }\n\n  ",
        " {\n    overflow-y: scroll;\n  }\n\n  ",
        " {\n    ",
        " {\n      border-radius: 8px;\n      margin-block-end: 8px;\n    }\n  }\n\n  @media (max-width: ",
        "px) {\n    & > ",
        " {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    BookingInformation_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BookingInformation_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n\n  padding-block: 15px;\n  padding-inline: 0;\n\n  ",
        ",\n  ",
        " {\n    margin-block: 15px;\n    margin-inline: 0;\n  }\n\n  ",
        " {\n    ",
        ",\n    ",
        " {\n      margin-block: 0;\n      margin-inline: 0;\n    }\n  }\n"
    ]);
    BookingInformation_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function BookingInformation_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: flex-start;\n"
    ]);
    BookingInformation_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function BookingInformation_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 25px;\n\n  color: ",
        ";\n"
    ]);
    BookingInformation_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function BookingInformation_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  ",
        " {\n    align-items: center;\n  }\n"
    ]);
    BookingInformation_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function BookingInformation_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  ",
        " {\n    margin-inline-end: 25px;\n    flex-grow: 1;\n    width: auto;\n    max-width: 550px;\n  }\n\n  @media screen and (max-width: ",
        "px) {\n    max-width: 100%;\n    width: 100%;\n    margin-inline-end: 0;\n  }\n"
    ]);
    BookingInformation_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function BookingInformation_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-block-end: 1px solid ",
        ";\n"
    ]);
    BookingInformation_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function BookingInformation_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n  max-width: 300px;\n"
    ]);
    BookingInformation_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 16px;\n  line-height: 150%;\n\n  color: ",
        ";\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n\n  color: ",
        ";\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 150%;\n\n  color: ",
        ";\n\n  span {\n    padding-block: 0;\n    padding-inline: 10px;\n  }\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  padding-block-start: 20px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n  color: ",
        ";\n  padding-inline-end: 8px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n  color: ",
        ";\n  padding-inline-end: 8px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  ",
        ",\n  ",
        " {\n    ",
        ";\n    ",
        ";\n    ",
        ";\n\n    ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: flex-start;\n  ",
        " {\n    margin-block-start: 8px;\n  }\n\n  ",
        " {\n    ",
        " {\n      margin-inline-end: 8px;\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  ",
        " {\n    margin-block: 15px;\n    margin-inline: 0;\n  }\n\n  ",
        " {\n    ",
        " {\n      margin-block-start: 15px;\n    }\n  }\n\n  @media screen and (max-width: ",
        "px) {\n    max-width: 100%;\n    width: 100%;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    z-index: 14;\n  }\n\n  ",
        " {\n    overflow: unset;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}







var bookingConfirmed = (0,styled_components_browser_esm/* css */.iv)(BookingInformation_styles_templateObject(), styles/* colors.green */.O9.green);
var bookingPending = (0,styled_components_browser_esm/* css */.iv)(BookingInformation_styles_templateObject1(), styles/* colors.orange */.O9.orange);
var bookingUnsolved = (0,styled_components_browser_esm/* css */.iv)(BookingInformation_styles_templateObject2(), styles/* colors.orange */.O9.orange);
var bookingCancelled = (0,styled_components_browser_esm/* css */.iv)(BookingInformation_styles_templateObject3(), styles/* colors.red */.O9.red);
var BookingInformationBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BookingInformationBase",
    componentId: "sc-7fe478c1-0"
})(BookingInformation_styles_templateObject4(), styles/* colors.white */.O9.white, function(props) {
    return props.isCancelled ? "0" : "20px";
}, function(props) {
    return !props.isCancelled && "border: 2px solid ".concat(styles/* colors.grey4 */.O9.grey4);
}, Modal_styles/* Header */.h4, Modal_styles/* ModalBase */.eX, styles/* media.tablet */.BC.tablet, Modal_styles/* ExternalContent */._h, styles/* sizes.tablet */.J7.tablet - 1, Modal_styles/* ModalBase */.eX, function(props) {
    return props.theme.colors.grey8;
});
var BookingInformation_styles_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-7fe478c1-1"
})(BookingInformation_styles_templateObject5(), SpecialRequests_styles_module.SpecialRequestsBase, CancellationPoliciesBase, styles/* media.desktop */.BC.desktop, SpecialRequests_styles_module.SpecialRequestsBase, CancellationPoliciesBase);
var VoucherNumberRow = (0,styled_components_browser_esm/* default */.ZP)(BookingInformation_styles_Row).withConfig({
    displayName: "styles__VoucherNumberRow",
    componentId: "sc-7fe478c1-2"
})(BookingInformation_styles_templateObject6());
var BookingInformationTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BookingInformationTitle",
    componentId: "sc-7fe478c1-3"
})(BookingInformation_styles_templateObject7(), styles/* colors.grey1 */.O9.grey1);
var BookingInformationTitleSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BookingInformationTitleSection",
    componentId: "sc-7fe478c1-4"
})(BookingInformation_styles_templateObject8(), BookingInformation_styles_Row);
var BookingInformationHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BookingInformationHeader",
    componentId: "sc-7fe478c1-5"
})(BookingInformation_styles_templateObject9(), styles/* media.tablet */.BC.tablet, styles/* sizes.desktop */.J7.desktop - 1);
var RowSeparator = (0,styled_components_browser_esm/* default */.ZP)(BookingInformation_styles_Row).withConfig({
    displayName: "styles__RowSeparator",
    componentId: "sc-7fe478c1-6"
})(BookingInformation_styles_templateObject10(), styles/* colors.grey4 */.O9.grey4);
var RoomInfoRow = (0,styled_components_browser_esm/* default */.ZP)(BookingInformation_styles_Row).withConfig({
    displayName: "styles__RoomInfoRow",
    componentId: "sc-7fe478c1-7"
})(BookingInformation_styles_templateObject11());
var BookingInformationSubtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BookingInformationSubtitle",
    componentId: "sc-7fe478c1-8"
})(styles_templateObject12(), styles/* colors.grey2 */.O9.grey2);
var BookingInformationLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BookingInformationLabel",
    componentId: "sc-7fe478c1-9"
})(styles_templateObject13(), styles/* colors.grey1 */.O9.grey1);
var BookingInformationValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BookingInformationValue",
    componentId: "sc-7fe478c1-10"
})(styles_templateObject14(), styles/* colors.grey2 */.O9.grey2);
var styles_FeedbackSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FeedbackSection",
    componentId: "sc-7fe478c1-11"
})(_templateObject15());
var BookingStatusLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BookingStatusLabel",
    componentId: "sc-7fe478c1-12"
})(_templateObject16(), styles/* colors.green */.O9.green);
var BookingStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__BookingStatus",
    componentId: "sc-7fe478c1-13"
})(_templateObject17(), styles/* colors.green */.O9.green);
var StatusWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StatusWrapper",
    componentId: "sc-7fe478c1-14"
})(_templateObject18(), BookingStatusLabel, BookingStatus, function(props) {
    return props.status === constants_voucher/* BOOKING_PENDING */.Bc && bookingPending;
}, function(props) {
    return props.status === constants_voucher/* BOOKING_ERROR */.l1 && bookingPending;
}, function(props) {
    return props.status === constants_voucher/* BOOKING_UNSOLVED */.P1 && bookingUnsolved;
}, function(props) {
    return props.status === constants_voucher/* BOOKING_CANCELLED */.e1 && bookingCancelled;
}, function(props) {
    return props.status === constants_voucher/* BOOKING_CONFIRMED */.a9 && bookingConfirmed;
});
var RefundRow = (0,styled_components_browser_esm/* default */.ZP)(BookingInformation_styles_Row).withConfig({
    displayName: "styles__RefundRow",
    componentId: "sc-7fe478c1-15"
})(_templateObject19(), ButtonSimple_styles/* ButtonSimpleBase */.eX, styles/* media.tablet */.BC.tablet, ButtonSimple_styles/* ButtonSimpleBase */.eX);
var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Column",
    componentId: "sc-7fe478c1-16"
})(_templateObject20(), CancellationPoliciesBase, styles/* media.desktop */.BC.desktop, CancellationPoliciesBase, styles/* sizes.desktop */.J7.desktop - 1);
var ModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ModalContent",
    componentId: "sc-7fe478c1-17"
})(_templateObject21(), Modal_styles/* ModalBase */.eX, Modal_styles/* Content */.VY);

;// CONCATENATED MODULE: ./src/comps/BookingInformation/messages.js

var BookingInformation_messages_messages = (0,lib/* defineMessages */.vU)({
    additionalInformation: {
        id: "global.additional-information"
    },
    bookingInformation: {
        id: "global.booking-information"
    },
    bookedBy: {
        id: "global.booked-by"
    },
    bookingDate: {
        id: "global.booking-date"
    },
    checkIn: {
        id: "search.checkin"
    },
    checkOut: {
        id: "search.checkout"
    },
    stay: {
        id: "global.stay"
    },
    nightsCount: {
        id: "global.nights"
    },
    guests: {
        id: "global.guests"
    },
    modifyDatesAndPaxes: {
        id: "global.modify-dates-paxes"
    },
    modifyDates: {
        id: "global.modify-dates-multiroom"
    },
    room: {
        id: "global.room"
    },
    holder: {
        id: "global.holder"
    },
    voucherNumber: {
        id: "voucher.number"
    },
    pending: {
        id: "global.pending"
    },
    unsolved: {
        id: "global.unsolved"
    },
    bookingCancelled: {
        id: "global.voucher-booking-cancelled"
    },
    bookingNotPaid: {
        id: "voucher.booking-not-paid"
    },
    creditCardNeeded: {
        id: "voucher.credit-card-needed"
    },
    previousAttempt: {
        id: "voucher.previous-attempt"
    },
    bookingStatusMessage: {
        id: "global.booking-status"
    },
    cancelled: {
        id: "global.cancelled"
    },
    refundStaywallet: {
        id: "global.refund-staywallet"
    },
    refundCreditCard: {
        id: "global.refund-credit-card"
    },
    cancelErrorTitle: {
        id: "voucher.cancel-error-confirm"
    },
    cancelErrorDescription: {
        id: "voucher.cancellation-error"
    }
});
/* harmony default export */ var BookingInformation_messages = (BookingInformation_messages_messages);

// EXTERNAL MODULE: ./client/components/HtmlViewer/index.js
var HtmlViewer = __webpack_require__(1987);
;// CONCATENATED MODULE: ./src/comps/BookingInformation/index.js

















































var BookingInformation = function(param) {
    var bookingInformation = param.bookingInformation, displayForm = param.displayForm, paymentMethods = param.paymentMethods, propertyId = param.propertyId, purchaseId = param.purchaseId, rooms = param.rooms, _isRefundable = param.isRefundable, isRefundable = _isRefundable === void 0 ? false : _isRefundable;
    var closeModifyDatesModal = function closeModifyDatesModal() {
        dispatch((0,ModifyDates_actions/* resetStatusAction */.Qp)());
        if (step === ModifyDates_constants/* ERROR_CONFIRMATION */.cy) {
            dispatch((0,actions/* fetchVoucherRequestAction */.hE)({
                purchaseId: purchaseId
            }));
        }
    };
    var handleRefundWallet = function handleRefundWallet() {
        dispatch((0,RefundWallet_actions/* fetchRefundWalletRequestAction */.nG)({
            hash: bookingInformation === null || bookingInformation === void 0 ? void 0 : bookingInformation.hash
        }));
    };
    var handleRefundCreditCard = function handleRefundCreditCard() {
        dispatch((0,RefundCreditCard_actions/* fetchRefundCreditCardRequestAction */.Uv)({
            hash: bookingInformation === null || bookingInformation === void 0 ? void 0 : bookingInformation.hash
        }));
    };
    var handleCloseModal = function handleCloseModal() {
        setOpen(false);
        return isEmailVerified && closeModifyDatesModal;
    };
    var handleExitWithoutSaving = function handleExitWithoutSaving() {
        setConfirmExitOpen(false);
        setOpen(false);
        return isEmailVerified && closeModifyDatesModal;
    };
    var handleContinueEditing = function handleContinueEditing() {
        setConfirmExitOpen(false);
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var intl = (0,useIntl/* default */.Z)();
    var messageRef = (0,react.useRef)();
    var device = (0,useDevice/* useDevice */.F)().device;
    var subscribe = (0,useBus/* default */.Z)().subscribe;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isWide = (0,useMedia/* default */.Z)(styles/* breakpoint.tablet */.eq.tablet, device === "desktop");
    var email = (0,es/* useSelector */.v9)(getEmail);
    var step = (0,es/* useSelector */.v9)(getStep);
    var statusEmail = (0,es/* useSelector */.v9)(selectors_getStatus(bookingInformation === null || bookingInformation === void 0 ? void 0 : bookingInformation.hash));
    var statusRefundCreditCard = (0,es/* useSelector */.v9)(RefundCreditCard_selectors_getStatus);
    var statusRefundWallet = (0,es/* useSelector */.v9)(RefundWallet_selectors_getStatus);
    var isEmailVerified = email && statusEmail === ModifyDates_constants/* STATUS_OK */.Us;
    var ref6 = (0,react.useState)(false), open = ref6[0], setOpen = ref6[1];
    var ref7 = (0,react.useState)(false), confirmExitOpen = ref7[0], setConfirmExitOpen = ref7[1];
    subscribe("show-change-dates-modal", function() {
        setOpen(true);
    });
    var paymentStatusFailed = (bookingInformation === null || bookingInformation === void 0 ? void 0 : bookingInformation.paymentStatus) === "failed";
    var isCancelled = (bookingInformation === null || bookingInformation === void 0 ? void 0 : bookingInformation.bookingStatus) === constants_voucher/* BOOKING_CANCELLED */.e1;
    var unconfirmedStatus = bookingInformation.bookingStatus !== constants_voucher/* BOOKING_CONFIRMED */.a9;
    (0,react.useEffect)(function() {
        if (statusRefundWallet === RefundWallet_constants/* STATUS_REFUND_WALLET_OK */.nG) {
            dispatch((0,AlertMessage_actions/* displayAlertAction */.Hn)({
                messageId: "successRefund",
                severity: "success"
            }));
        }
        if (statusRefundWallet === RefundWallet_constants/* STATUS_REFUND_WALLET_NOT_OK */.Ud) {
            dispatch((0,AlertMessage_actions/* displayAlertAction */.Hn)({
                messageId: "errorDefault"
            }));
        }
    }, [
        dispatch,
        statusRefundWallet
    ]);
    (0,react.useEffect)(function() {
        if (statusRefundCreditCard === RefundCreditCard_constants/* STATUS_REFUND_CREDIT_CARD_OK */.Co) {
            dispatch((0,AlertMessage_actions/* displayAlertAction */.Hn)({
                messageId: "successRefund",
                severity: "success"
            }));
        }
        if (statusRefundCreditCard === RefundCreditCard_constants/* STATUS_REFUND_CREDIT_CARD_NOT_OK */.fN) {
            dispatch((0,AlertMessage_actions/* displayAlertAction */.Hn)({
                messageId: "errorDefault"
            }));
        }
    }, [
        dispatch,
        statusRefundCreditCard
    ]);
    (0,react.useEffect)(function() {
        if (displayForm && paymentStatusFailed) {
            (0,utils_scroll/* scrollToPosition */.p)({
                ref: messageRef
            });
        }
    }, [
        displayForm,
        paymentStatusFailed
    ]);
    if (!bookingInformation) {
        return null;
    }
    var showRefundableBtn = isRefundable && bookingInformation.bookingStatus === constants_voucher/* BOOKING_UNSOLVED */.P1;
    var adults = parseInt(bookingInformation.adults, 10);
    var children = parseInt(bookingInformation.children, 10);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookingInformationBase, {
        "data-testid": "booking-information",
        isCancelled: isCancelled,
        children: [
            ((ref = bookingInformation.issues) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformation_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_InformationBox, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PendingCheck/* default */.Z, {}),
                    text: intl.formatMessage(BookingInformation_messages.cancelErrorDescription),
                    title: intl.formatMessage(BookingInformation_messages.cancelErrorTitle),
                    status: ModifyDates_constants/* STATUS_NOT_OK */.lm
                })
            }),
            paymentStatusFailed && !isCancelled && /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformation_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_FeedbackSection, {
                    ref: messageRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FeedbackVoucher, {
                        dataTestId: "payment-not-ok",
                        text: [
                            intl.formatMessage(BookingInformation_messages.bookingNotPaid),
                            intl.formatMessage(BookingInformation_messages.creditCardNeeded),
                            intl.formatMessage(BookingInformation_messages.previousAttempt, {
                                card_last_digits: (ref1 = bookingInformation.creditCard) === null || ref1 === void 0 ? void 0 : ref1.number
                            }), 
                        ],
                        status: ModifyDates_constants/* STATUS_NOT_OK */.lm
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformationTitleSection, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformationTitle, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, BookingInformation_messages.bookingInformation))
                })
            }),
            showRefundableBtn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RefundRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                        onClick: handleRefundWallet,
                        variant: "tertiary",
                        dataTestId: "refund-staywallet-".concat(bookingInformation === null || bookingInformation === void 0 ? void 0 : bookingInformation.voucher),
                        text: intl.formatMessage(BookingInformation_messages.refundStaywallet),
                        fullWidth: !isWide
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                        onClick: handleRefundCreditCard,
                        variant: "primary",
                        dataTestId: "refund-credit-card-".concat(bookingInformation === null || bookingInformation === void 0 ? void 0 : bookingInformation.voucher),
                        text: intl.formatMessage(BookingInformation_messages.refundCreditCard),
                        fullWidth: !isWide
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookingInformation_styles_Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookingInformationHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookingInformation_styles_Row, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformationSubtitle, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, BookingInformation_messages.bookedBy))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformationValue, {
                                        children: bookingInformation.userFullName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowSeparator, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformationLabel, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, BookingInformation_messages.checkIn))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformationValue, {
                                        suppressHydrationWarning: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateIntl/* default */.Z, {
                                            value: bookingInformation.checkIn,
                                            format: DateIntl_constants/* DATE_INTL_FORMAT_WEEKDAY_MONTH_TEXT */.qN
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowSeparator, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformationLabel, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, BookingInformation_messages.checkOut))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformationValue, {
                                        suppressHydrationWarning: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateIntl/* default */.Z, {
                                            value: bookingInformation.checkOut,
                                            format: DateIntl_constants/* DATE_INTL_FORMAT_WEEKDAY_MONTH_TEXT */.qN
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowSeparator, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformationLabel, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, BookingInformation_messages.stay))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformationValue, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, BookingInformation_messages.nightsCount), {
                                            values: {
                                                nights: bookingInformation.nights
                                            }
                                        }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookingInformation_styles_Row, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformationLabel, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, BookingInformation_messages.guests))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Capacity/* default */.Z, {
                                        adults: adults,
                                        children: children,
                                        childrenAges: bookingInformation.childrenAges,
                                        showAges: false,
                                        title: false
                                    })
                                ]
                            }),
                            bookingInformation.isCancellable && !unconfirmedStatus && ((ref2 = bookingInformation.issues) === null || ref2 === void 0 ? void 0 : ref2.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformation_styles_Row, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_DatesChangeConnected, {
                                    trackingData: {
                                        context: "booking_thanks",
                                        details: "Initiate change dates/people"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSimple/* default */.Z, {
                                        onClick: function() {
                                            return setOpen(!open);
                                        },
                                        variant: "tertiary",
                                        dataTestId: "modify-dates-and-paxes-".concat(bookingInformation.voucher),
                                        text: intl.formatMessage(rooms > 1 ? BookingInformation_messages.modifyDates : BookingInformation_messages.modifyDatesAndPaxes)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformation_styles_Row, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomCard_RoomCard, {
                                    adults: adults,
                                    beds: bookingInformation.beds,
                                    boardCode: bookingInformation.boardCode,
                                    boardName: bookingInformation.boardName,
                                    children: children,
                                    childrenAges: bookingInformation.childrenAges,
                                    holders: bookingInformation.holders,
                                    isMobile: bookingInformation.isMobile,
                                    roomName: bookingInformation.roomName,
                                    rooms: rooms
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PaymentInformation, {
                                confirmedStatus: !unconfirmedStatus,
                                creditCard: bookingInformation.creditCard,
                                currency: bookingInformation.currency,
                                displayForm: displayForm,
                                hash: bookingInformation.hash,
                                isCancellable: bookingInformation.isCancellable,
                                isCreditCard: bookingInformation.creditCard !== null,
                                isPayable: bookingInformation.isPayable,
                                language: bookingInformation.language,
                                needToPay: paymentStatusFailed,
                                paymentMethods: paymentMethods,
                                pendingAmount: bookingInformation.pendingAmount,
                                purchaseId: purchaseId,
                                ticketsPaid: bookingInformation.ticketsPaid,
                                totalPaid: bookingInformation.totalPaid,
                                partialAmounts: bookingInformation.partialAmounts,
                                bookingHash: bookingInformation.hash
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_CancellationPolicies, {
                                cancellationPolicies: bookingInformation.cancellationPolicies,
                                pendingAmount: bookingInformation.pendingAmount,
                                generatedWallet: bookingInformation.generatedWallet,
                                hash: bookingInformation.hash,
                                rateName: bookingInformation.rateName,
                                internal: bookingInformation.internal,
                                confirmedStatus: !unconfirmedStatus,
                                voucherIssues: ((ref3 = bookingInformation.issues) === null || ref3 === void 0 ? void 0 : ref3.length) > 0,
                                idBooking: bookingInformation.idBooking,
                                isRefundable: isRefundable
                            }),
                            !unconfirmedStatus && /*#__PURE__*/ (0,jsx_runtime.jsx)(Molecules_InvoicePanel, {
                                date: (ref4 = bookingInformation.invoice) === null || ref4 === void 0 ? void 0 : ref4.datetime,
                                hash: bookingInformation.hash,
                                status: (ref5 = bookingInformation.invoice) === null || ref5 === void 0 ? void 0 : ref5.status
                            })
                        ]
                    })
                ]
            }),
            !unconfirmedStatus && /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformation_styles_Row, {
                className: "noPrint",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(effects_SpecialRequests, {
                    specialRequests: bookingInformation.specialRequests,
                    hash: bookingInformation.hash
                })
            }),
            bookingInformation.comments && /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInformation_styles_Row, {
                className: "noPrint",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleSection/* default */.Z, {
                    title: intl.formatMessage(BookingInformation_messages.additionalInformation),
                    fullWidth: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                        html: bookingInformation.comments
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                    show: open,
                    minWidth: "720px",
                    variant: isWide ? Modal_constants/* VARIANT_DEFAULT */.Wv : Modal_constants/* VARIANT_FULLSCREEN */.VU,
                    handleClose: handleCloseModal,
                    onBeforeClose: function() {
                        if (isEmailVerified && step) {
                            setConfirmExitOpen(true);
                            return false;
                        }
                        return true;
                    },
                    children: isEmailVerified ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(effects_ModifyDates.ConfirmExit, {
                                open: confirmExitOpen,
                                onClose: function() {
                                    return setConfirmExitOpen(false);
                                },
                                onContinueEditing: handleContinueEditing,
                                onExitWithoutSaving: handleExitWithoutSaving
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(effects_ModifyDates, {
                                bookingInformation: bookingInformation,
                                propertyId: propertyId,
                                sellingRate: bookingInformation.sellingRate,
                                rooms: rooms
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(effects_VerifyEmail, {
                        buttonText: intl.formatMessage(rooms > 1 ? BookingInformation_messages.modifyDates : BookingInformation_messages.modifyDatesAndPaxes),
                        hash: bookingInformation === null || bookingInformation === void 0 ? void 0 : bookingInformation.hash
                    })
                })
            })
        ]
    });
};
BookingInformation.propTypes = {
    bookingInformation: typeBookingInformation,
    displayForm: (prop_types_default()).bool,
    paymentMethods: checkout/* typePaymentMethods */.In,
    propertyId: (prop_types_default()).string,
    purchaseId: (prop_types_default()).string,
    rooms: (prop_types_default()).number,
    isRefundable: (prop_types_default()).bool
};
/* harmony default export */ var comps_BookingInformation = (BookingInformation);

// EXTERNAL MODULE: ./src/comps/Molecules/Conditions/index.tsx + 6 modules
var Conditions = __webpack_require__(66967);
;// CONCATENATED MODULE: ./client/components/HotelPreview/styles.js

function HotelPreview_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  background: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: 8px;\n\n  padding-block: 20px;\n  padding-inline: 20px;\n\n  ",
        " {\n    justify-content: flex-start;\n    align-items: flex-start;\n    max-width: 600px;\n  }\n"
    ]);
    HotelPreview_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HotelPreview_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  padding-block-start: 0;\n\n  ",
        " {\n    flex-wrap: nowrap;\n  }\n"
    ]);
    HotelPreview_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HotelPreview_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-block-start: 20px;\n  align-items: flex-start;\n  flex-direction: column;\n\n  ",
        " {\n    flex-direction: row;\n    align-items: center;\n  }\n"
    ]);
    HotelPreview_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HotelPreview_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 180px;\n  width: 100%;\n  background-color: ",
        ";\n  border-radius: 8px;\n  overflow: hidden;\n\n  ",
        " {\n    width: 330px;\n  }\n"
    ]);
    HotelPreview_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HotelPreview_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-block-start: 20px;\n  margin-inline-start: 0;\n\n  ",
        " {\n    margin-inline-start: 20px;\n    margin-block-start: 0;\n  }\n"
    ]);
    HotelPreview_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HotelPreview_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 100%;\n  margin-block-end: 13px;\n\n  color: ",
        ";\n  ",
        " {\n    font-size: 34px;\n    margin-block-end: 0;\n  }\n"
    ]);
    HotelPreview_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HotelPreview_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n  margin-block-start: 12px;\n\n  text-decoration-line: underline;\n\n  color: ",
        ";\n  max-width: 100%;\n"
    ]);
    HotelPreview_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function HotelPreview_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  padding-inline-start: 0;\n  ",
        " {\n    padding-inline-start: 18px;\n  }\n"
    ]);
    HotelPreview_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function HotelPreview_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  ",
        ";\n  ",
        ";\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n"
    ]);
    HotelPreview_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var HotelPreviewBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HotelPreviewBase",
    componentId: "sc-296dbdb1-0"
})(HotelPreview_styles_templateObject(), styles/* colors.white */.O9.white, styles/* colors.grey4 */.O9.grey4, styles/* media.tablet */.BC.tablet);
var HotelPreview_styles_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-296dbdb1-1"
})(HotelPreview_styles_templateObject1(), styles/* media.tablet */.BC.tablet);
var RowHotelName = (0,styled_components_browser_esm/* default */.ZP)(HotelPreview_styles_Row).withConfig({
    displayName: "styles__RowHotelName",
    componentId: "sc-296dbdb1-2"
})(HotelPreview_styles_templateObject2(), styles/* media.tablet */.BC.tablet);
var ImageBoxLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ImageBoxLeft",
    componentId: "sc-296dbdb1-3"
})(HotelPreview_styles_templateObject3(), styles/* colors.grey5 */.O9.grey5, styles/* media.tablet */.BC.tablet);
var ImageMap = (0,styled_components_browser_esm/* default */.ZP)(ImageBoxLeft).withConfig({
    displayName: "styles__ImageMap",
    componentId: "sc-296dbdb1-4"
})(HotelPreview_styles_templateObject4(), styles/* media.tablet */.BC.tablet);
var HotelName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HotelName",
    componentId: "sc-296dbdb1-5"
})(HotelPreview_styles_templateObject5(), styles/* colors.grey1 */.O9.grey1, styles/* media.tablet */.BC.tablet);
var HotelAddress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HotelAddress",
    componentId: "sc-296dbdb1-6"
})(HotelPreview_styles_templateObject6(), styles/* colors.grey2 */.O9.grey2);
var HotelRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HotelRating",
    componentId: "sc-296dbdb1-7"
})(HotelPreview_styles_templateObject7(), styles/* media.tablet */.BC.tablet);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "styles__Image",
    componentId: "sc-296dbdb1-8"
})(HotelPreview_styles_templateObject8(), function(props) {
    return "background-image: url(".concat(props.src, ")");
}, function(props) {
    return !props.src && "background-color:".concat(styles/* colors.grey5 */.O9.grey5);
});

;// CONCATENATED MODULE: ./client/components/HotelPreview/utils.js
var ref, ref1;
var getPropertyId = function(hotelPreview, property) {
    var ref2;
    return (ref1 = (ref = hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.propertyId) !== null && ref !== void 0 ? ref : property === null || property === void 0 ? void 0 : (ref2 = property.id) === null || ref2 === void 0 ? void 0 : ref2.toString()) !== null && ref1 !== void 0 ? ref1 : "";
};
var ref2, ref3;
var getPropertyName = function(hotelPreview, property) {
    return (ref3 = (ref2 = hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.propertyName) !== null && ref2 !== void 0 ? ref2 : property === null || property === void 0 ? void 0 : property.name) !== null && ref3 !== void 0 ? ref3 : "";
};
var ref4, ref5;
var getPropertyStars = function(hotelPreview, property) {
    return (ref5 = (ref4 = hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.propertyStars) !== null && ref4 !== void 0 ? ref4 : property === null || property === void 0 ? void 0 : property.stars) !== null && ref5 !== void 0 ? ref5 : null;
};
var ref6, ref7;
var getCitySlug = function(hotelPreview, property) {
    var ref;
    return (ref7 = (ref6 = property === null || property === void 0 ? void 0 : property.citySlug) !== null && ref6 !== void 0 ? ref6 : hotelPreview === null || hotelPreview === void 0 ? void 0 : (ref = hotelPreview.propertyCity) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== null && ref7 !== void 0 ? ref7 : "";
};
var ref8, ref9;
var getCountry = function(hotelPreview, property) {
    return (ref9 = (ref8 = property === null || property === void 0 ? void 0 : property.country) !== null && ref8 !== void 0 ? ref8 : hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.propertyCountry) !== null && ref9 !== void 0 ? ref9 : "";
};
var getAddressString = function(property) {
    var addressParts = [];
    if (property === null || property === void 0 ? void 0 : property.address) {
        addressParts.push(property.address);
    }
    if (property === null || property === void 0 ? void 0 : property.postalCode) {
        addressParts.push(property.postalCode);
    }
    if (property === null || property === void 0 ? void 0 : property.city) {
        addressParts.push(property.city);
    }
    return addressParts.join(" ").trim();
};
var ref10, ref11;
var getFullAddress = function(hotelPreview, property) {
    return (ref11 = (ref10 = hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.fullAddress) !== null && ref10 !== void 0 ? ref10 : getAddressString(property)) !== null && ref11 !== void 0 ? ref11 : "";
};
var getMapPreview = function() {
    var propertyLocation = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).propertyLocation;
    if (!propertyLocation) {
        return "";
    }
    var latitude = propertyLocation.latitude, longitude = propertyLocation.longitude;
    return "https://maps.googleapis.com/maps/api/staticmap?size=270x180&center=".concat(latitude, ",").concat(longitude, "&zoom=13&key=").concat("AIzaSyB3Q0xwiR8Tvclzr4-ElDEK6PnjrYDA9CE", "&markers=").concat(latitude, ",").concat(longitude);
};


// EXTERNAL MODULE: ./src/comps/Image/constants.ts
var Image_constants = __webpack_require__(3282);
// EXTERNAL MODULE: ./client/components/Stars/index.js + 3 modules
var Stars = __webpack_require__(3705);
;// CONCATENATED MODULE: ./client/components/HotelPreview/LinkToProperty/styles.ts

function LinkToProperty_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  text-decoration: none;\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n\n    img {\n      opacity: 0.8;\n    }\n  }\n"
    ]);
    LinkToProperty_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LinkToPropertyBase = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__LinkToPropertyBase",
    componentId: "sc-bfe808c4-0"
})(LinkToProperty_styles_templateObject(), function(props) {
    return props.theme.colors.grey2;
}, function(props) {
    return props.theme.colors.grey3;
});

;// CONCATENATED MODULE: ./client/components/HotelPreview/LinkToProperty/index.tsx




function LinkToProperty(param) {
    var propertyId = param.propertyId, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/hotel-detail/".concat(propertyId),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkToPropertyBase, {
            target: "_blank",
            rel: "noopener",
            children: children
        })
    });
}

;// CONCATENATED MODULE: ./client/components/HotelPreview/LinkToPropertyMap/styles.ts

function LinkToPropertyMap_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  text-decoration: none;\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n\n    img {\n      opacity: 0.8;\n    }\n  }\n"
    ]);
    LinkToPropertyMap_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LinkToPropertyMapBase = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__LinkToPropertyMapBase",
    componentId: "sc-b3e2ed9f-0"
})(LinkToPropertyMap_styles_templateObject(), function(props) {
    return props.theme.colors.grey2;
}, function(props) {
    return props.theme.colors.grey3;
});

// EXTERNAL MODULE: ./src/comps/Link/index.js + 1 modules
var Link = __webpack_require__(99646);
;// CONCATENATED MODULE: ./client/components/HotelPreview/LinkToPropertyMap/index.tsx




function LinkToPropertyMap(param) {
    var propertyId = param.propertyId, country = param.country, citySlug = param.citySlug, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        page: "map",
        query: {
            country: country,
            type: "city",
            slug: citySlug,
            highlightedProperty: propertyId
        },
        target: "_blank",
        rel: "noopener",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkToPropertyMapBase, {
            children: children
        })
    });
}

// EXTERNAL MODULE: ./src/helpers/imageHandler.ts + 1 modules
var imageHandler = __webpack_require__(35267);
;// CONCATENATED MODULE: ./client/components/HotelPreview/HotelPreview.js











var HotelPreview = function(param) {
    var hotelPreview = param.hotelPreview, property = param.property;
    if (!hotelPreview && !(property === null || property === void 0 ? void 0 : property.photo) && !(hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.propertyLocation)) {
        return null;
    }
    var photoURL = (property === null || property === void 0 ? void 0 : property.photo) ? (0,imageHandler/* renderSrc */.DW)({
        imgObj: property.photo,
        width: 580
    }) : "";
    var propertyId = getPropertyId(hotelPreview, property);
    var propertyName = getPropertyName(hotelPreview, property);
    var propertyStars = getPropertyStars(hotelPreview, property);
    var fullAddress = getFullAddress(hotelPreview, property);
    var citySlug = getCitySlug(hotelPreview, property);
    var country = getCountry(hotelPreview, property);
    var mapPreview = getMapPreview(hotelPreview);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HotelPreviewBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HotelPreview_styles_Row, {
                className: "noPrint",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBoxLeft, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkToProperty, {
                            propertyId: propertyId,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                src: photoURL,
                                alt: "hotel image",
                                "data-testid": "hotel-image",
                                width: "100%",
                                height: 180,
                                layout: Image_constants/* LAYOUT_RESPONSIVE */.Ij
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageMap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkToPropertyMap, {
                            propertyId: propertyId,
                            citySlug: citySlug,
                            country: country,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                src: mapPreview,
                                "data-testid": "hotel-map"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowHotelName, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelName, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkToProperty, {
                            propertyId: propertyId,
                            children: propertyName
                        })
                    }),
                    propertyStars ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkToProperty, {
                        propertyId: propertyId,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelRating, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars/* default */.Z, {
                                stars: propertyStars,
                                size: 15,
                                color: "grey2"
                            })
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelPreview_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelAddress, {
                    "data-testid": "hotel-address",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkToPropertyMap, {
                        propertyId: propertyId,
                        citySlug: citySlug,
                        country: country,
                        children: fullAddress
                    })
                })
            })
        ]
    });
};
HotelPreview.propTypes = {
    hotelPreview: prop_types_default().shape({
        propertyId: (prop_types_default()).string,
        propertyCity: (prop_types_default()).string,
        propertyCountry: (prop_types_default()).string,
        propertySlug: (prop_types_default()).string,
        fullAddress: (prop_types_default()).string,
        addressUrl: (prop_types_default()).string,
        propertyAddress: (prop_types_default()).string.isRequired,
        propertyName: (prop_types_default()).string.isRequired,
        propertyStars: (prop_types_default()).number,
        propertyImages: prop_types_default().arrayOf(prop_types_default().shape({
            path: (prop_types_default()).string,
            source: (prop_types_default()).string,
            code: (prop_types_default()).string,
            bookingIdRoom: (prop_types_default()).string
        })),
        propertyLocation: prop_types_default().shape({
            cityName: (prop_types_default()).string,
            latitude: (prop_types_default()).number,
            longitude: (prop_types_default()).number,
            postalCode: (prop_types_default()).string
        })
    }),
    property: client_types/* typeProperty */._T
};
/* harmony default export */ var HotelPreview_HotelPreview = (HotelPreview);

// EXTERNAL MODULE: ./client/icons/Add.js
var Add = __webpack_require__(50625);
// EXTERNAL MODULE: ./client/icons/Remove.js
var Remove = __webpack_require__(79335);
// EXTERNAL MODULE: ./client/components/Insurance/Section/InsuranceSection.js + 1 modules
var InsuranceSection = __webpack_require__(78893);
// EXTERNAL MODULE: ./client/components/PriceDetails/index.tsx
var PriceDetails = __webpack_require__(96540);
// EXTERNAL MODULE: ./src/comps/Molecules/PriceDropProtection/index.tsx + 2 modules
var PriceDropProtection = __webpack_require__(18985);
// EXTERNAL MODULE: ./src/comps/Atom/Buttons/Button/index.tsx
var Button = __webpack_require__(9961);
;// CONCATENATED MODULE: ./src/comps/Atom/Buttons/SecondaryButton/index.tsx



function SecondaryButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    SecondaryButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SecondaryButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs(function(props) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        backgroundColor: "grey8",
        borderColor: "grey2",
        color: "grey2"
    });
}).withConfig({
    displayName: "SecondaryButton",
    componentId: "sc-77ac0e5d-0"
})(SecondaryButton_templateObject());
/* harmony default export */ var Buttons_SecondaryButton = (SecondaryButton);

// EXTERNAL MODULE: ./client/icons/createSvgIcon.tsx + 1 modules
var createSvgIcon = __webpack_require__(88121);
;// CONCATENATED MODULE: ./client/icons/Printer.js



/* harmony default export */ var Printer = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M16.167 6.167h-.834V2.833c0-.5-.333-.833-.833-.833H6.167c-.5 0-.834.333-.834.833v3.334H4.5c-1.417 0-2.5 1.083-2.5 2.5v5c0 1.416 1.083 2.5 2.5 2.5h.833v1.666c0 .5.334.834.834.834H14.5c.5 0 .833-.334.833-.834v-1.666h.834c1.416 0 2.5-1.084 2.5-2.5v-5c0-1.417-1.084-2.5-2.5-2.5zM7 3.667h6.667v2.5H7v-2.5zM13.667 17H7v-3.333h6.667V17zM17 13.667c0 .5-.333.833-.833.833h-.834v-1.667c0-.5-.333-.833-.833-.833H6.167c-.5 0-.834.333-.834.833V14.5H4.5c-.5 0-.833-.333-.833-.833v-5c0-.5.333-.834.833-.834h11.667c.5 0 .833.334.833.834v5zm-10-5h-.833c-.5 0-.834.333-.834.833 0 .5.334.833.834.833H7c.5 0 .833-.333.833-.833 0-.5-.333-.833-.833-.833zM8.667 14.5H12c.5 0 .833.333.833.833 0 .5-.333.834-.833.834H8.667c-.5 0-.834-.334-.834-.834 0-.5.334-.833.834-.833z"
}), "Printer"));

;// CONCATENATED MODULE: ./src/comps/PrintButton/index.tsx





var PrintButton = function(param) {
    var children = param.children;
    var mobileAppVersion = (0,react_context_src/* useS4LContext */.ms)().mobileAppVersion;
    if (mobileAppVersion) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_SecondaryButton, {
        type: "button",
        size: "m",
        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Printer, {}),
        onClick: function(event) {
            event.preventDefault();
            window.print();
        },
        children: children
    });
};
/* harmony default export */ var comps_PrintButton = (PrintButton);

// EXTERNAL MODULE: ./client/icons/Help.js
var Help = __webpack_require__(92308);
;// CONCATENATED MODULE: ./client/icons/Staywallet.js



/* harmony default export */ var Staywallet = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    fillRule: "evenodd",
    d: "M20.2 12a8.2 8.2 0 11-16.4 0 8.2 8.2 0 0116.4 0zm1.8 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-7.06-5.2c-.018.301-.083.593-.186.875-1.722-1.082-3.054-.64-3.761.178a2.58 2.58 0 00-.01 3.376 2.5 2.5 0 001.816.846c.307 0 .614-.066.894-.178.346-.144.667-.366.96-.639.054.42.045.849-.03 1.269-.004.025.006.045.028.059a2.914 2.914 0 01-2.597 2.376c-.093.01-.177.01-.27.01-1.601 0-2.905-1.307-2.914-2.934 0-.085 0-.16.01-.245a3.266 3.266 0 011.116-2.557L8.944 7.599a4.886 4.886 0 00-2.14 4.185c-.094 2.67 1.973 4.918 4.626 5.012h.373c2.644.113 4.878-1.965 4.99-4.636.01-.122.01-.254 0-.376a4.99 4.99 0 00-.533-2.34 5.167 5.167 0 00-.162-.306c.415-.912.64-1.813.64-2.329L14.94 6.8zm-1.964 3.874a1.146 1.146 0 01-1.136-1.147c0-.63.512-1.147 1.136-1.147.624 0 1.136.517 1.136 1.147a1.14 1.14 0 01-1.136 1.147z"
}), "Staywallet"));

// EXTERNAL MODULE: ./client/components/PriceDetails/styles.tsx + 1 modules
var PriceDetails_styles = __webpack_require__(43854);
// EXTERNAL MODULE: ./src/comps/AdditionalFees/styles.js
var AdditionalFees_styles = __webpack_require__(9163);
;// CONCATENATED MODULE: ./client/components/Tooltip/styles.js

function Tooltip_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      border: 2px solid ",
        ";\n      border-radius: 8px;\n    "
    ]);
    Tooltip_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Tooltip_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n    border: 2px solid ",
        ";\n    border-radius: 5px;\n    padding-block: 10px;\n    padding-inline: 10px;\n\n    /* Arrow */\n    &:after {\n      content: '';\n      width: 0;\n      height: 0;\n      border-inline-start: 6px solid transparent;\n      border-inline-end: 6px solid transparent;\n      border-block-start: 6px solid ",
        ";\n      inset-block-end: -5px;\n      position: absolute;\n      ",
        ";\n      ",
        ";\n      ",
        ";\n      transform: translateX(calc(var(--transform-direction) * -50%));\n    }\n\n    p {\n      color: ",
        ";\n      font-size: 12px;\n      line-height: 1.4;\n    }\n  "
    ]);
    Tooltip_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Tooltip_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  position: relative;\n  fill: ",
        ";\n\n  ",
        " {\n    border-radius: 8px;\n  }\n\n  ",
        ", ",
        " {\n    margin-block-end: 0 !important;\n  }\n"
    ]);
    Tooltip_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Tooltip_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset-block-start: -6px;\n  inset-inline-start: 50%;\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  width: ",
        ";\n  z-index: 20;\n  cursor: default;\n"
    ]);
    Tooltip_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Tooltip_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    Tooltip_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Tooltip_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 0;\n  padding-inline: 0;\n  appearance: none;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n"
    ]);
    Tooltip_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Tooltip_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  position: fixed;\n  inset-block-start: 0;\n  inset-inline-start: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n"
    ]);
    Tooltip_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




function getTheme(theme) {
    if (theme === "light") {
        return (0,styled_components_browser_esm/* css */.iv)(Tooltip_styles_templateObject(), styles/* colors.white */.O9.white, styles/* colors.grey4 */.O9.grey4);
    }
    return (0,styled_components_browser_esm/* css */.iv)(Tooltip_styles_templateObject1(), styles/* colors.white */.O9.white, styles/* colors.grey0 */.O9.grey0, styles/* colors.grey0 */.O9.grey0, styles/* colors.grey1 */.O9.grey1, function(props) {
        return props.position === "right" && "inset-inline-start: 90%;";
    }, function(props) {
        return props.position === "left" && "inset-inline-start: 10%;";
    }, function(props) {
        return props.position === "center" && "inset-inline-start: 50%;";
    }, styles/* colors.white */.O9.white);
}
var TooltipBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TooltipBase",
    componentId: "sc-ffb74c6c-0"
})(Tooltip_styles_templateObject2(), styles/* colors.grey2 */.O9.grey2, PriceDetails_styles/* PriceDetailsBase */.Sv, PriceDetails_styles/* PriceDetailsBase */.Sv, AdditionalFees_styles/* AdditionalFeesBase */.n_);
var bubbleStyles = (0,styled_components_browser_esm/* css */.iv)(Tooltip_styles_templateObject3(), function(props) {
    return props.position === "right" && "transform: translate(calc(var(--transform-direction) * -90%), -100%)";
}, function(props) {
    return props.position === "left" && "transform: translate(calc(var(--transform-direction) * -10%), -100%)";
}, function(props) {
    return props.position === "center" && "transform: translate(calc(var(--transform-direction) * -50%), -100%)";
}, function(props) {
    return getTheme(props.theme);
}, function(props) {
    return "".concat(props.width, "px");
});
var TooltipBubble = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__TooltipBubble",
    componentId: "sc-ffb74c6c-1"
})(Tooltip_styles_templateObject4(), function(props) {
    return props.isOpen ? bubbleStyles : styles/* helpers.isVisuallyHidden */.BM.isVisuallyHidden;
});
var Trigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__Trigger",
    componentId: "sc-ffb74c6c-2"
})(Tooltip_styles_templateObject5());
var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Overlay",
    componentId: "sc-ffb74c6c-3"
})(Tooltip_styles_templateObject6(), function(props) {
    return props.visible ? "block" : "none";
});

;// CONCATENATED MODULE: ./client/components/Tooltip/index.js





var Tooltip = function(param) {
    var content = param.content, maxContainerWidth = param.maxContainerWidth, children = param.children, theme = param.theme;
    var ref = (0,react.useState)(false), isOpen = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)("center"), position = ref1[0], setPosition = ref1[1];
    var trigger = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (trigger.current) {
            var ref = trigger.current.getBoundingClientRect(), right = ref.right, left = ref.left;
            if (left < maxContainerWidth / 2) {
                setPosition("left");
            } else if (window.innerWidth - right < maxContainerWidth / 2) {
                setPosition("right");
            }
        }
    }, [
        maxContainerWidth
    ]);
    var handleClick = function(e) {
        e.stopPropagation();
        setOpen(true);
    };
    var handleBlur = function(e) {
        e.stopPropagation();
        if (document.body.style.top) {
            (0,client_utils/* documentBodyUnfreeze */.D_)();
        }
        setOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                "data-testid": "tooltip-overlay",
                visible: isOpen,
                onClick: handleBlur
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipBase, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipBubble, {
                        isOpen: isOpen,
                        position: position,
                        role: "tooltip",
                        theme: theme,
                        width: maxContainerWidth,
                        onClick: function(e) {
                            return e.stopPropagation();
                        },
                        children: content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Trigger, {
                        type: "button",
                        onClick: handleClick,
                        ref: trigger,
                        children: children
                    })
                ]
            })
        ]
    });
};
Tooltip.propTypes = {
    children: (prop_types_default()).node.isRequired,
    content: (prop_types_default()).node.isRequired,
    maxContainerWidth: (prop_types_default()).number,
    theme: (prop_types_default()).string
};
/* harmony default export */ var components_Tooltip = (Tooltip);

;// CONCATENATED MODULE: ./src/comps/Staywallet/styles.js

function Staywallet_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  color: ",
        ";\n  display: flex;\n  font-size: 14px;\n  line-height: 1.2;\n\n  > svg {\n    fill: ",
        ";\n    flex: 0 0 auto;\n    margin-inline-end: 5px;\n  }\n\n  > p {\n    padding-block: 3px;\n    padding-inline: 6px;\n  }\n\n  strong {\n    color: ",
        ";\n  }\n\n  ",
        " {\n    display: flex;\n    margin-inline-start: 4px;\n\n    svg {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    Staywallet_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StaywalletBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StaywalletBase",
    componentId: "sc-2d2693d3-0"
})(Staywallet_styles_templateObject(), styles/* colors.grey2 */.O9.grey2, styles/* colors.magenta */.O9.magenta, styles/* colors.magenta */.O9.magenta, TooltipBase, styles/* colors.grey2 */.O9.grey2);

;// CONCATENATED MODULE: ./src/comps/Staywallet/messages.js

var Staywallet_messages_messages = (0,lib/* defineMessages */.vU)({
    youWonCredit: {
        id: "staywallet.you-won-credit"
    },
    earnStaywallet: {
        id: "staywallet.earn-list"
    },
    staywalletTooltip: {
        id: "staywallet.earn-list-tooltip"
    }
});
/* harmony default export */ var Staywallet_messages = (Staywallet_messages_messages);

;// CONCATENATED MODULE: ./src/comps/Staywallet/index.js












var Staywallet_Staywallet = function(param) {
    var amount = param.amount, currency = param.currency, tooltip = param.tooltip, isEarned = param.isEarned;
    if (!amount) {
        return null;
    }
    var creditAmount = {
        amount: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                amount: amount,
                currency: currency
            })
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StaywalletBase, {
        "data-testid": "staywallet-box",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Staywallet, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Staywallet_messages[isEarned ? "youWonCredit" : "earnStaywallet"]), {
                values: creditAmount,
                tagName: "p"
            })),
            tooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Tooltip, {
                maxContainerWidth: 250,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Staywallet_messages.staywalletTooltip), {
                    values: creditAmount,
                    tagName: "p"
                })),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {})
            })
        ]
    });
};
Staywallet_Staywallet.propTypes = {
    amount: (prop_types_default()).number,
    currency: (prop_types_default()).string,
    isEarned: (prop_types_default()).bool,
    tooltip: (prop_types_default()).bool
};
/* harmony default export */ var comps_Staywallet = (Staywallet_Staywallet);

// EXTERNAL MODULE: ./src/comps/TravelInsurance/index.tsx + 12 modules
var TravelInsurance = __webpack_require__(30979);
// EXTERNAL MODULE: ./client/components/VoucherBookingCodes/styles.module.css
var VoucherBookingCodes_styles_module = __webpack_require__(80632);
var VoucherBookingCodes_styles_module_default = /*#__PURE__*/__webpack_require__.n(VoucherBookingCodes_styles_module);
// EXTERNAL MODULE: ../../node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(50381);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
;// CONCATENATED MODULE: ./client/icons/CopyText.js



/* harmony default export */ var CopyText = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M10.2221 1.88867H3.55545C2.94434 1.88867 2.44434 2.38867 2.44434 2.99978V10.7776H3.55545V2.99978H10.2221V1.88867ZM11.8888 4.11089H5.77767C5.16656 4.11089 4.66656 4.61089 4.66656 5.22201V12.9998C4.66656 13.6109 5.16656 14.1109 5.77767 14.1109H11.8888C12.4999 14.1109 12.9999 13.6109 12.9999 12.9998V5.22201C12.9999 4.61089 12.4999 4.11089 11.8888 4.11089ZM11.8888 12.9998H5.77767V5.22201H11.8888V12.9998Z",
    fill: "#333333"
}), "CopyText", 16, "0 0 16 16"));

;// CONCATENATED MODULE: ./client/icons/SuccessFilled.js



/* harmony default export */ var SuccessFilled = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            clipPath: "url(#clip0_14267_3111)",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5316 5.52801C11.2714 5.26595 10.8476 5.2653 10.5865 5.52645C9.15309 6.95984 8.21801 7.89492 6.66659 9.44634L4.74358 7.52869C4.48372 7.26956 4.06308 7.26985 3.80358 7.52935C3.54382 7.7891 3.54382 8.21025 3.80358 8.47L5.95948 10.6259C6.35 11.0164 6.98317 11.0164 7.37369 10.6259L11.5299 6.46968C11.7898 6.20983 11.7905 5.78877 11.5316 5.52801ZM7.99992 1.33301C4.31992 1.33301 1.33325 4.31967 1.33325 7.99967C1.33325 11.6797 4.31992 14.6663 7.99992 14.6663C11.6799 14.6663 14.6666 11.6797 14.6666 7.99967C14.6666 4.31967 11.6799 1.33301 7.99992 1.33301Z",
                fill: "#4F9F52"
            })
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.5826 5.8024C11.3367 5.54609 10.9269 5.54561 10.6801 5.80104C9.36554 7.16167 8.50352 8.05388 7.07692 9.53046L5.31682 7.71377C5.07121 7.46026 4.66447 7.46055 4.41922 7.71439C4.18539 7.95641 4.18539 8.34018 4.41922 8.5822L6.35775 10.5886C6.75087 10.9955 7.40298 10.9955 7.7961 10.5886L11.5811 6.67106C11.815 6.42898 11.8156 6.0453 11.5826 5.8024Z",
            fill: "white"
        })
    ]
}), "SuccessFilled", 16, "0 0 16 16"));

// EXTERNAL MODULE: ./client/components/CopyText/styles.module.css
var CopyText_styles_module = __webpack_require__(62565);
var CopyText_styles_module_default = /*#__PURE__*/__webpack_require__.n(CopyText_styles_module);
// EXTERNAL MODULE: ./src/comps/Molecules/Tooltip/styles.module.css
var Tooltip_styles_module = __webpack_require__(44886);
var Tooltip_styles_module_default = /*#__PURE__*/__webpack_require__.n(Tooltip_styles_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/Tooltip/index.tsx





function Tooltip_Tooltip(param) {
    var message = param.message, _arrow = param.arrow, arrow = _arrow === void 0 ? false : _arrow, _align = param.align, align = _align === void 0 ? "center" : _align;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        "data-tooltip": true,
        "data-testid": "tooltip",
        className: classnames_default()((Tooltip_styles_module_default()).tooltip, arrow && (Tooltip_styles_module_default()).arrow, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Tooltip_styles_module_default()).center, align === "center"), (0,_define_property/* default */.Z)(_obj, (Tooltip_styles_module_default()).start, align === "start"), (0,_define_property/* default */.Z)(_obj, (Tooltip_styles_module_default()).end, align === "end"), _obj)),
        children: message
    });
}

;// CONCATENATED MODULE: ./client/components/CopyText/index.tsx








var CopyText_CopyText = function(param) {
    var children = param.children;
    var handleClick = function handleClick() {
        copy_to_clipboard_default()(children);
        setCopied(true);
        setTimeout(function() {
            return setCopied(false);
        }, 3000);
    };
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), copied = ref[0], setCopied = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: (CopyText_styles_module_default()).container,
        children: [
            children,
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                "data-testid": "copy-text",
                className: (CopyText_styles_module_default()).button,
                onClick: handleClick,
                children: [
                    copied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessFilled, {
                        size: 24
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyText, {
                        size: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip, {
                        message: intl.formatMessage({
                            id: copied ? "global.copied" : "global.copy"
                        }),
                        align: "center"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CopyText = (CopyText_CopyText);

// EXTERNAL MODULE: ./src/comps/Atom/Buttons/ButtonLink/index.tsx
var ButtonLink = __webpack_require__(92142);
;// CONCATENATED MODULE: ./client/components/VoucherBookingCodes/index.tsx







var VoucherBookingCodes = function(param) {
    var voucherNumbers = param.voucherNumbers, purchaseId = param.purchaseId, onClick = param.onClick;
    var intl = (0,useIntl/* default */.Z)();
    var getVoucherNumberLabel = function(index) {
        var label = intl.formatMessage({
            id: "voucher.number"
        });
        var suffix = voucherNumbers.length > 1 ? " ".concat(index + 1) : "";
        return "".concat(label).concat(suffix);
    };
    var getVoucherNumber = function(voucherNumber) {
        return voucherNumber === "" ? intl.formatMessage({
            id: "global.pending"
        }) : voucherNumber;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        className: (VoucherBookingCodes_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (VoucherBookingCodes_styles_module_default()).codes,
                children: [
                    voucherNumbers.map(function(voucherNumber, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                getVoucherNumberLabel(index),
                                ":",
                                " ",
                                voucherNumber ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CopyText, {
                                    children: getVoucherNumber(voucherNumber)
                                }) : getVoucherNumber(voucherNumber)
                            ]
                        }, voucherNumber);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            intl.formatMessage({
                                id: "global.pin_code"
                            }),
                            ": ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CopyText, {
                                children: purchaseId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (VoucherBookingCodes_styles_module_default()).linkContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (VoucherBookingCodes_styles_module_default()).link,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                            className: (VoucherBookingCodes_styles_module_default()).icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                            onClick: function() {
                                return onClick("codes");
                            },
                            text: "global.use-reservation-codes",
                            hasChevron: true
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_VoucherBookingCodes = (VoucherBookingCodes);

// EXTERNAL MODULE: ./client/components/VoucherBookingStatus/styles.module.css
var VoucherBookingStatus_styles_module = __webpack_require__(13564);
var VoucherBookingStatus_styles_module_default = /*#__PURE__*/__webpack_require__.n(VoucherBookingStatus_styles_module);
;// CONCATENATED MODULE: ./client/components/VoucherBookingStatus/index.tsx






var statusMap = {
    error: "pending",
    unsolved: "cancelled"
};
var VoucherBookingStatus = function(param) {
    var location = param.location, bookingInformation = param.bookingInformation, onClick = param.onClick, children = param.children;
    var ref;
    var intl = (0,useIntl/* default */.Z)();
    var bookingStatus = (ref = bookingInformation[0]) === null || ref === void 0 ? void 0 : ref.bookingStatus;
    var status = statusMap[bookingStatus] || bookingStatus.toLowerCase();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (VoucherBookingStatus_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (VoucherBookingStatus_styles_module_default()).statusContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            intl.formatMessage({
                                id: "global.booking-status"
                            }),
                            ":",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((VoucherBookingStatus_styles_module_default()).status, (VoucherBookingStatus_styles_module_default())[status]),
                                children: intl.formatMessage({
                                    id: "global.booking-status-".concat(status, "-title")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                        "data-testid": "info-icon",
                        size: 14,
                        onClick: function() {
                            return onClick("status");
                        }
                    })
                ]
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: intl.formatMessage({
                    id: "global.booking-in-destination"
                }, {
                    destination: location
                })
            })
        ]
    });
};
/* harmony default export */ var components_VoucherBookingStatus = (VoucherBookingStatus);

// EXTERNAL MODULE: ../../packages/icons/lib/IconArrowRight.tsx
var IconArrowRight = __webpack_require__(75300);
// EXTERNAL MODULE: ./client/components/VoucherGuestRoomListCta/styles.module.css
var VoucherGuestRoomListCta_styles_module = __webpack_require__(58697);
var VoucherGuestRoomListCta_styles_module_default = /*#__PURE__*/__webpack_require__.n(VoucherGuestRoomListCta_styles_module);
;// CONCATENATED MODULE: ./client/components/VoucherGuestRoomListCta/index.tsx






var VoucherGuestRoomListCta = function(param) {
    var bookNumber = param.bookNumber, onClick = param.onClick, totalGuests = param.totalGuests, isEnabled = param.isEnabled, isMultiBooking = param.isMultiBooking;
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    if (!isEnabled) {
        return null;
    }
    var message = isMultiBooking ? i18n.formatMessage({
        id: "guest-rooming-list.multibooking"
    }, {
        count: bookNumber
    }) : i18n.formatMessage({
        id: "global.fill-guest-details"
    }, {
        count: totalGuests
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* TextLink */.hh, {
        as: "button",
        onClick: function() {
            return onClick({
                bookNumber: bookNumber
            });
        },
        size: "medium",
        bold: true,
        variant: "neutral",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (VoucherGuestRoomListCta_styles_module_default()).link,
            children: [
                message,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowRight/* IconArrowRight */.E, {
                    size: 16,
                    "data-testid": "guest-room-list-cta-link-icon"
                })
            ]
        })
    });
};
/* harmony default export */ var components_VoucherGuestRoomListCta = (VoucherGuestRoomListCta);

// EXTERNAL MODULE: ./client/components/VoucherGuestRoomListMessage/styles.module.css
var VoucherGuestRoomListMessage_styles_module = __webpack_require__(51143);
var VoucherGuestRoomListMessage_styles_module_default = /*#__PURE__*/__webpack_require__.n(VoucherGuestRoomListMessage_styles_module);
// EXTERNAL MODULE: ../../packages/icons/lib/IconWarningMsg.tsx
var IconWarningMsg = __webpack_require__(22731);
;// CONCATENATED MODULE: ./client/components/VoucherGuestRoomListMessage/index.tsx





var VoucherGuestRoomListMessage = function(param) {
    var children = param.children, totalGuests = param.totalGuests, isEnabled = param.isEnabled;
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    if (!isEnabled) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (VoucherGuestRoomListMessage_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (VoucherGuestRoomListMessage_styles_module_default()).title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWarningMsg/* IconWarningMsg */.F, {
                        "data-testid": "guest-room-list-message-icon"
                    }),
                    i18n.formatMessage({
                        id: "guest-rooming-list-banner.title"
                    }, {
                        count: totalGuests
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (VoucherGuestRoomListMessage_styles_module_default()).body,
                children: i18n.formatMessage({
                    id: "guest-rooming-list-banner.body"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (VoucherGuestRoomListMessage_styles_module_default()).children,
                children: children
            })
        ]
    });
};
/* harmony default export */ var components_VoucherGuestRoomListMessage = (VoucherGuestRoomListMessage);

// EXTERNAL MODULE: ./src/comps/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(61985);
// EXTERNAL MODULE: ./client/components/VoucherGuestRoomListModal/styles.module.css
var VoucherGuestRoomListModal_styles_module = __webpack_require__(20475);
var VoucherGuestRoomListModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(VoucherGuestRoomListModal_styles_module);
;// CONCATENATED MODULE: ./client/components/VoucherGuestRoomListModal/Form/index.tsx



















var CountryResidenceSelector = /*#__PURE__*/ (0,react.lazy)(function() {
    return __webpack_require__.e(/* import() */ 2771).then(__webpack_require__.bind(__webpack_require__, 92771));
});
var VoucherGuestRoomListForm = function(param) {
    var alertContainerId = param.alertContainerId, hash = param.hash, initialGuest = param.initialGuest, isMultiBooking = param.isMultiBooking, onClose = param.onClose, pendingRoomingListCount = param.pendingRoomingListCount, purchaseId = param.purchaseId, totalGuests = param.totalGuests;
    var ref = (0,react_context_src/* useS4LContext */.ms)(), domain = ref.domain, i18n = ref.i18n;
    var dispatch = (0,es/* useDispatch */.I0)();
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var isDesktop = activeBreakpoint === device/* BreakpointSizes.L */.a.L;
    var initialTouchedFields = Array.from({
        length: totalGuests
    }, function() {
        return {
            firstName: false,
            lastName: false,
            country: false
        };
    });
    var initialGuests = Array.from({
        length: totalGuests
    }, function(_, index) {
        return {
            id: String(index),
            firstName: index === 0 ? initialGuest.firstName : "",
            lastName: index === 0 ? initialGuest.lastName : "",
            country: {
                code: "",
                name: "",
                originalName: ""
            }
        };
    });
    var initialOpenStates = Array.from({
        length: totalGuests
    }, function(_, index) {
        return index === 0;
    });
    var ref1 = (0,react.useState)(initialGuests), guests = ref1[0], setGuests = ref1[1];
    var ref2 = (0,react.useState)(initialTouchedFields), touchedFields = ref2[0], setTouchedFields = ref2[1];
    var ref3 = (0,react.useState)(initialOpenStates), openStates = ref3[0], setOpenStates = ref3[1];
    var ref4 = (0,react.useState)(false), isSubmitted = ref4[0], setIsSubmitted = ref4[1];
    var hasErrors = guests.some(function(guest) {
        return !guest.firstName || !guest.lastName || !guest.country.code;
    });
    var updateGuestField = function(index, field, value) {
        setGuests(function(prevGuests) {
            var next = (0,_to_consumable_array/* default */.Z)(prevGuests);
            if (field === "country") {
                next[index] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next[index]), {
                    country: value
                });
            } else {
                next[index] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next[index]), (0,_define_property/* default */.Z)({}, field, value));
            }
            return next;
        });
    };
    var markFieldAsTouched = function(index, field) {
        setTouchedFields(function(prev) {
            var next = (0,_to_consumable_array/* default */.Z)(prev);
            next[index] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next[index]), (0,_define_property/* default */.Z)({}, field, true));
            return next;
        });
    };
    var dispatchAlert = function(param) {
        var title = param.title, description = param.description, severity = param.severity, containerId = param.containerId;
        return dispatch((0,AlertMessage_actions/* displayAlertAction */.Hn)({
            title: title,
            description: description,
            severity: severity,
            containerId: containerId
        }));
    };
    var handleFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var errorGuests, holders, ref, error, successMessageId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        setIsSubmitted(true);
                        if (hasErrors) {
                            errorGuests = guests.map(function(param) {
                                var firstName = param.firstName, lastName = param.lastName, country = param.country;
                                return !firstName || !lastName || !country.code;
                            });
                            setOpenStates(function(prev) {
                                return prev.map(function(open, index) {
                                    return errorGuests[index] ? true : open;
                                });
                            });
                            dispatchAlert({
                                title: i18n.formatMessage({
                                    id: "guest-rooming-list.error-notification-title"
                                }),
                                description: i18n.formatMessage({
                                    id: "guest-rooming-list.error-notification-body"
                                }),
                                containerId: alertContainerId
                            });
                            return [
                                2
                            ];
                        }
                        holders = guests.map(function(guest) {
                            return {
                                firstName: guest.firstName,
                                lastName: guest.lastName,
                                country: guest.country.originalName
                            };
                        });
                        return [
                            4,
                            domain.CreateGuestRoomingListBookingUseCase.execute({
                                hash: hash,
                                holders: holders
                            })
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), error = ref[0];
                        if (error) {
                            dispatchAlert({
                                title: i18n.formatMessage({
                                    id: "error.pre-title"
                                }),
                                description: i18n.formatMessage({
                                    id: "error.request-try-later"
                                }),
                                containerId: alertContainerId
                            });
                            console.error(error);
                            return [
                                2
                            ];
                        }
                        successMessageId = isMultiBooking && pendingRoomingListCount > 1 ? "guest-rooming-list.success-notification-body-multibooking" : "guest-rooming-list.success-notification-body";
                        dispatchAlert({
                            title: i18n.formatMessage({
                                id: "guest-rooming-list.success-notification-title"
                            }),
                            description: i18n.formatMessage({
                                id: successMessageId
                            }),
                            severity: "success"
                        });
                        dispatch((0,actions/* fetchVoucherRequestAction */.hE)({
                            purchaseId: purchaseId
                        }));
                        onClose();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFormSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var buildRequiredErrors = function(shouldShow) {
        return shouldShow ? [
            i18n.formatMessage({
                id: "guest-rooming-list.input-inline-error"
            })
        ] : [];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleFormSubmit,
        className: (VoucherGuestRoomListModal_styles_module_default()).form,
        children: [
            guests.map(function(guest, index) {
                var ref, ref1, ref2;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ds_src/* Collapsible */.zF, {
                    title: i18n.formatMessage({
                        id: "guest-rooming-list.guest-number"
                    }, {
                        number: index + 1
                    }),
                    open: openStates[index],
                    onToggle: function(next) {
                        return setOpenStates(function(prev) {
                            var updated = (0,_to_consumable_array/* default */.Z)(prev);
                            updated[index] = next;
                            return updated;
                        });
                    },
                    children: openStates[index] && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (VoucherGuestRoomListModal_styles_module_default()).collapsibleContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    label: i18n.formatMessage({
                                        id: "user.first-name"
                                    }),
                                    name: "guest-name-".concat(index),
                                    value: guest.firstName,
                                    onChange: function(value) {
                                        return updateGuestField(index, "firstName", value);
                                    },
                                    onBlur: function() {
                                        return markFieldAsTouched(index, "firstName");
                                    },
                                    errors: buildRequiredErrors((isSubmitted || ((ref = touchedFields[index]) === null || ref === void 0 ? void 0 : ref.firstName)) && !guest.firstName)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    label: i18n.formatMessage({
                                        id: "user.last-name"
                                    }),
                                    name: "guest-surname-".concat(index),
                                    value: guest.lastName,
                                    onChange: function(value) {
                                        return updateGuestField(index, "lastName", value);
                                    },
                                    onBlur: function() {
                                        return markFieldAsTouched(index, "lastName");
                                    },
                                    errors: buildRequiredErrors((isSubmitted || ((ref1 = touchedFields[index]) === null || ref1 === void 0 ? void 0 : ref1.lastName)) && !guest.lastName)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountryResidenceSelector, {
                                    onSelect: function(country) {
                                        return updateGuestField(index, "country", country);
                                    },
                                    value: guest.country,
                                    errors: buildRequiredErrors((isSubmitted || ((ref2 = touchedFields[index]) === null || ref2 === void 0 ? void 0 : ref2.country)) && !guest.country.code)
                                })
                            })
                        ]
                    })
                }, guest.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (VoucherGuestRoomListModal_styles_module_default()).ctaContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Button */.zx, {
                    type: "submit",
                    variant: "filled-rounded",
                    fullWidth: !isDesktop,
                    children: i18n.formatMessage({
                        id: "guest-rooming-list.cta"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var VoucherGuestRoomListModal_Form = (VoucherGuestRoomListForm);

;// CONCATENATED MODULE: ./client/components/VoucherGuestRoomListModal/index.tsx







var ALERT_CONTAINER_ID = "voucher-guest-room-list-modal";
var VoucherGuestRoomListModal = function(param) {
    var hash = param.hash, bookNumber = param.bookNumber, isOpen = param.isOpen, isMultiBooking = param.isMultiBooking, onClose = param.onClose, pendingRoomingListCount = param.pendingRoomingListCount, purchaseId = param.purchaseId, totalGuests = param.totalGuests, initialGuest = param.initialGuest;
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    var titleMessage = isMultiBooking ? i18n.formatMessage({
        id: "guest-rooming-list.multibooking"
    }, {
        count: bookNumber
    }) : i18n.formatMessage({
        id: "global.guest-details-default"
    }, {
        count: totalGuests
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* BottomSheet */.R1, {
        autoFocus: true,
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* BottomSheet.Content */.R1.Content, {
            title: titleMessage,
            modalOnDesktop: true,
            scroll: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (VoucherGuestRoomListModal_styles_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertMessage/* default */.Z, {
                        containerId: ALERT_CONTAINER_ID
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                        variant: "body",
                        size: "m",
                        children: i18n.formatMessage({
                            id: "guest-rooming-list.body"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherGuestRoomListModal_Form, {
                        alertContainerId: ALERT_CONTAINER_ID,
                        hash: hash,
                        initialGuest: initialGuest,
                        isMultiBooking: isMultiBooking,
                        onClose: onClose,
                        pendingRoomingListCount: pendingRoomingListCount,
                        purchaseId: purchaseId,
                        totalGuests: totalGuests
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_VoucherGuestRoomListModal = (VoucherGuestRoomListModal);

// EXTERNAL MODULE: ./client/components/VoucherGuestRoomListStatus/styles.module.css
var VoucherGuestRoomListStatus_styles_module = __webpack_require__(1722);
var VoucherGuestRoomListStatus_styles_module_default = /*#__PURE__*/__webpack_require__.n(VoucherGuestRoomListStatus_styles_module);
;// CONCATENATED MODULE: ../../packages/icons/lib/IconWarning.tsx




var IconWarning = function(_param) {
    var _color = _param.color, color = _color === void 0 ? "currentColor" : _color, _size = _param.size, size = _size === void 0 ? 24 : _size, className = _param.className, _rotateOnRtl = _param.rotateOnRtl, rotateOnRtl = _rotateOnRtl === void 0 ? false : _rotateOnRtl, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size",
        "className",
        "rotateOnRtl"
    ]);
    var props = (0,_object_spread/* default */.Z)((0,_define_property/* default */.Z)({
        width: size,
        height: size,
        fill: color,
        // stroke: color,
        className: className,
        viewBox: "0 0 24 24"
    }, "data-rotateonrtl", false), rest);
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_18920_69953)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2Z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17Z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V11Z"
    })), /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_18920_69953"
    }, /*#__PURE__*/ react.createElement("rect", {
        width: 24,
        height: 24
    }))));
};

;// CONCATENATED MODULE: ./client/components/VoucherGuestRoomListStatus/index.tsx





var VoucherGuestRoomListStatus = function(param) {
    var children = param.children, isEnabled = param.isEnabled;
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    if (!isEnabled) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (VoucherGuestRoomListStatus_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (VoucherGuestRoomListStatus_styles_module_default()).statusContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: i18n.formatMessage({
                            id: "global.guest-details"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (VoucherGuestRoomListStatus_styles_module_default()).status,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWarning, {
                                size: 16,
                                "data-testid": "guest-room-list-status-icon"
                            }),
                            i18n.formatMessage({
                                id: "global.pending"
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};
/* harmony default export */ var components_VoucherGuestRoomListStatus = (VoucherGuestRoomListStatus);

// EXTERNAL MODULE: ./src/comps/VoucherInfoModal/styles.module.css
var VoucherInfoModal_styles_module = __webpack_require__(54533);
var VoucherInfoModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(VoucherInfoModal_styles_module);
;// CONCATENATED MODULE: ./src/comps/VoucherInfoModal/BookingCodesContent.tsx






var BookingCodesContent = function(key) {
    var intl = (0,useIntl/* default */.Z)();
    var helpCenterUrl = (0,useMarket/* useMarket */.A)().helpCenterUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: classnames_default()((VoucherInfoModal_styles_module_default()).title, (VoucherInfoModal_styles_module_default()).sticky),
                children: intl.formatMessage({
                    id: "booking-codes.title"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (VoucherInfoModal_styles_module_default()).description,
                children: intl.formatMessage({
                    id: "booking-codes.body-1"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                className: (VoucherInfoModal_styles_module_default()).description,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (VoucherInfoModal_styles_module_default()).strong,
                                children: [
                                    intl.formatMessage({
                                        id: "voucher.number"
                                    }),
                                    ":"
                                ]
                            }),
                            " ",
                            intl.formatMessage({
                                id: "booking-codes.voucher-number-body"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (VoucherInfoModal_styles_module_default()).strong,
                                children: [
                                    intl.formatMessage({
                                        id: "global.pin_code"
                                    }),
                                    ":"
                                ]
                            }),
                            " ",
                            intl.formatMessage({
                                id: "booking-codes.security-code-body"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (VoucherInfoModal_styles_module_default()).description,
                children: intl.formatMessage({
                    id: "booking-codes.body-2"
                }, {
                    helpCenter: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: helpCenterUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Help Center"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (VoucherInfoModal_styles_module_default()).description,
                children: intl.formatMessage({
                    id: "booking-codes.body-3"
                })
            })
        ]
    }, key);
};
/* harmony default export */ var VoucherInfoModal_BookingCodesContent = (BookingCodesContent);

;// CONCATENATED MODULE: ./src/comps/VoucherInfoModal/BookingStatusContent.tsx






var BookingStatusContent = function(key) {
    var intl = (0,useIntl/* default */.Z)();
    var helpCenterUrl = (0,useMarket/* useMarket */.A)().helpCenterUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (VoucherInfoModal_styles_module_default()).description,
                children: intl.formatMessage({
                    id: "global.booking-status-intro"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: (VoucherInfoModal_styles_module_default()).description,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((VoucherInfoModal_styles_module_default()).strong, (VoucherInfoModal_styles_module_default()).confirmed),
                                children: intl.formatMessage({
                                    id: "global.booking-status-confirmed-title"
                                })
                            }),
                            ": ",
                            intl.formatMessage({
                                id: "global.booking-status-confirmed-body"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((VoucherInfoModal_styles_module_default()).strong, (VoucherInfoModal_styles_module_default()).cancelled),
                                children: intl.formatMessage({
                                    id: "global.booking-status-cancelled-title"
                                })
                            }),
                            ": ",
                            intl.formatMessage({
                                id: "global.booking-status-cancelled-body"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((VoucherInfoModal_styles_module_default()).strong, (VoucherInfoModal_styles_module_default()).pending),
                                children: intl.formatMessage({
                                    id: "global.booking-status-pending-title"
                                })
                            }),
                            ": ",
                            intl.formatMessage({
                                id: "global.booking-status-pending-body"
                            }, {
                                help_center: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: helpCenterUrl,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: "Help Center"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (VoucherInfoModal_styles_module_default()).description,
                children: intl.formatMessage({
                    id: "global.booking-status-closing"
                }, {
                    help_center: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: helpCenterUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Help Center"
                    })
                })
            })
        ]
    }, key);
};
/* harmony default export */ var VoucherInfoModal_BookingStatusContent = (BookingStatusContent);

;// CONCATENATED MODULE: ./src/comps/VoucherInfoModal/utils.ts



var CreateDescriptionBlocks = function(key) {
    var intl = (0,useIntl/* default */.Z)();
    return [
        {
            key: "codes",
            title: intl.formatMessage({
                id: "global.booking-codes"
            }),
            content: VoucherInfoModal_BookingCodesContent(key)
        },
        {
            key: "status",
            title: intl.formatMessage({
                id: "global.booking-status"
            }),
            content: VoucherInfoModal_BookingStatusContent(key)
        }, 
    ].filter(function(item) {
        return item.key === key;
    });
};

;// CONCATENATED MODULE: ./src/comps/VoucherInfoModal/index.tsx





var VoucherInfoModal = function(param) {
    var item = param.item, isOpen = param.isOpen, onClose = param.onClose;
    var descriptionToRender = function(items) {
        return items.map(function(param) {
            var title = param.title, content = param.content;
            return {
                title: title,
                content: /*#__PURE__*/ (0,react.isValidElement)(content) ? content : null
            };
        });
    };
    var ref = (0,_sliced_to_array/* default */.Z)(descriptionToRender(CreateDescriptionBlocks(item)), 1), tmp = ref[0], ref1 = tmp === void 0 ? {
        title: "",
        content: null
    } : tmp, title = ref1.title, content = ref1.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* BottomSheet */.R1, {
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* BottomSheet.Content */.R1.Content, {
            title: title,
            modalOnDesktop: true,
            children: content
        })
    });
};
/* harmony default export */ var comps_VoucherInfoModal = (VoucherInfoModal);

// EXTERNAL MODULE: ./client/components/CollapsibleSection/styles.js
var CollapsibleSection_styles = __webpack_require__(89683);
;// CONCATENATED MODULE: ./src/comps/Voucher/styles.js

function Voucher_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border-radius: var(--radius-8);\n  border: 2px solid ",
        ";\n  min-height: 245px;\n  width: 100%;\n  padding: var(--space-24);\n\n  ",
        " {\n    width: 100%;\n  }\n\n  ",
        " {\n    max-width: 400px;\n  }\n"
    ]);
    Voucher_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Voucher_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border-radius: var(--radius-8);\n  border: 2px solid ",
        ";\n  padding-block: 20px;\n  padding-inline: 20px;\n  width: 100%;\n"
    ]);
    Voucher_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Voucher_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: var(--radius-8);\n  border: 2px solid ",
        ";\n  width: 100%;\n  padding-block: 20px;\n  padding-inline: 20px;\n\n  @media print {\n    margin-block-start: 12px;\n    padding-block: 12px;\n    padding-inline: 12px;\n\n    & > div a {\n      padding-block: 0;\n      padding-inline: 0;\n    }\n  }\n"
    ]);
    Voucher_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Voucher_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  align-items: stretch;\n  flex-wrap: wrap;\n  width: 100%;\n  margin-inline: 0;\n  margin-block: 15px;\n  ",
        "\n\n  ",
        " {\n    margin-block: 15px 0;\n    margin-inline: 0;\n  }\n\n  ",
        " {\n    width: 100%;\n    max-width: 1110px;\n    margin-inline: auto;\n    margin-block: auto;\n    padding-block: 15px;\n    padding-inline: 40px;\n    flex-direction: row;\n    align-items: flex-start;\n\n    ",
        " {\n      align-items: unset;\n    }\n\n    ",
        " {\n      margin-block: 0;\n      margin-inline: 0;\n\n      ",
        " {\n        background-color: transparent;\n      }\n    }\n\n    ",
        " {\n      margin-block-end: 15px;\n    }\n  }\n\n  ",
        " {\n    gap: 16px;\n    flex-wrap: nowrap;\n  }\n\n  @media screen and (max-width: ",
        "px) {\n    ",
        " {\n      max-width: 100%;\n    }\n\n    ",
        " {\n      max-width: 100%;\n      width: 100%;\n    }\n  }\n\n  @media print {\n    display: block;\n    margin-block: 0;\n    margin-inline: 0;\n\n    & > div {\n      padding-block: 12px;\n      padding-inline: 12px;\n      margin-inline: 0 !important;\n      margin-block: 0 !important;\n    }\n\n    ",
        " {\n      padding-block: 12px 0;\n      padding-inline: 0;\n    }\n  }\n"
    ]);
    Voucher_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Voucher_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 0;\n  margin-block: 0;\n\n  button {\n    ",
        " {\n      margin-block-start: 0;\n    }\n  }\n\n  ",
        " {\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n  }\n"
    ]);
    Voucher_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Voucher_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-inline: 0;\n  margin-block: 0 15px;\n\n  ",
        " {\n    margin-block: 0;\n    margin-inline: 0;\n    padding-block-start: 0;\n  }\n\n  @media print {\n    order: 1;\n  }\n"
    ]);
    Voucher_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Voucher_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 1100px;\n  border-radius: var(--radius-8);\n  width: 100%;\n  border: 2px solid ",
        ";\n  padding-block: 0;\n  padding-inline: 20px;\n"
    ]);
    Voucher_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Voucher_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 25px;\n  color: ",
        ";\n"
    ]);
    Voucher_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Voucher_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-inline: 15px;\n  margin-block: 0;\n  max-width: 1100px;\n\n  ",
        " {\n    margin-inline: 20px;\n    margin-block: 0;\n  }\n\n  ",
        " {\n    margin-inline: auto;\n    margin-block: auto;\n  }\n\n  @media print {\n    margin-inline: 0;\n    margin-block: 0;\n    padding-block: 0;\n    padding-inline: 0;\n    max-width: none;\n\n    & button {\n      display: none;\n    }\n\n    & > ",
        " {\n      padding-block: 0;\n      padding-inline: 0;\n      margin-block-end: 12px;\n    }\n\n    ",
        " {\n      display: none;\n    }\n\n    ",
        " {\n      display: none;\n\n      &:last-child {\n        padding-block-end: auto;\n      }\n    }\n\n    ",
        " {\n      display: none;\n    }\n\n    ",
        " {\n      display: none;\n    }\n\n    ",
        " {\n      max-width: 100%;\n    }\n\n    ",
        " {\n      border: 0;\n      max-width: 100%;\n      min-height: 0;\n\n      ",
        " {\n        width: 100%;\n        padding-block: 0;\n        padding-inline: 0;\n      }\n\n      ",
        " {\n        border-width: 2px;\n        margin-block: 0;\n        margin-inline: 0;\n      }\n    }\n\n    ",
        " {\n      display: flex;\n      max-width: 100%;\n      border: 2px solid #e0e0e0;\n      border-radius: var(--radius-8);\n      padding-block: 12px;\n      padding-inline: 12px;\n    }\n\n    ",
        " {\n      display: block;\n      & > div {\n        display: block;\n      }\n    }\n\n    ",
        ", ",
        ", ",
        ", ",
        " {\n      display: block;\n      max-width: 100%;\n      min-height: 0;\n    }\n  }\n"
    ]);
    Voucher_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}











var PriceDetailsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PriceDetailsContainer",
    componentId: "sc-9c291000-0"
})(Voucher_styles_templateObject(), styles/* colors.grey4 */.O9.grey4, PriceDetails_styles/* PriceDetailsBase */.Sv, styles/* updatedMedia.mobile */.$c.mobile);
var StaywalletContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__StaywalletContainer",
    componentId: "sc-9c291000-1"
})(Voucher_styles_templateObject1(), styles/* colors.grey4 */.O9.grey4);
var ContactDetailsContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__ContactDetailsContainer",
    componentId: "sc-9c291000-2"
})(Voucher_styles_templateObject2(), styles/* colors.grey4 */.O9.grey4);
var Voucher_styles_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-9c291000-3"
})(Voucher_styles_templateObject3(), function(props) {
    return props.hidden && "display: none;";
}, PriceDetailsContainer, styles/* updatedMedia.tablet */.$c.tablet, CollapsibleSection_styles/* CollapsibleSectionBase */.J2, PriceDetailsContainer, PriceDetails_styles/* PriceDetailsBase */.Sv, HotelPreviewBase, styles/* updatedMedia.desktop */.$c.desktop, styles/* updatedSizes.desktop */.CA.desktop - 1, PriceDetailsContainer, HotelPreviewBase, PriceDetailsContainer);
var RowHeader = (0,styled_components_browser_esm/* default */.ZP)(Voucher_styles_Row).withConfig({
    displayName: "styles__RowHeader",
    componentId: "sc-9c291000-4"
})(Voucher_styles_templateObject4(), styles/* updatedMedia.tablet */.$c.tablet, styles/* updatedMedia.tablet */.$c.tablet);
var ContactRow = (0,styled_components_browser_esm/* default */.ZP)(Voucher_styles_Row).withConfig({
    displayName: "styles__ContactRow",
    componentId: "sc-9c291000-5"
})(Voucher_styles_templateObject5(), styles/* updatedMedia.tablet */.$c.tablet);
var CheckinSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CheckinSection",
    componentId: "sc-9c291000-6"
})(Voucher_styles_templateObject6(), styles/* colors.grey4 */.O9.grey4);
var CancelledBooking = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CancelledBooking",
    componentId: "sc-9c291000-7"
})(Voucher_styles_templateObject7(), styles/* colors.red */.O9.red);
var VoucherBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__VoucherBase",
    componentId: "sc-9c291000-8"
})(Voucher_styles_templateObject8(), styles/* updatedMedia.tablet */.$c.tablet, styles/* updatedMedia.desktop */.$c.desktop, Voucher_styles_Row, RowHeader, PriceDetails_styles/* Line */.x1, MobileOnlyBase, PaymentInformationBase, HotelPreviewBase, PriceDetailsContainer, PriceDetails_styles/* PriceDetailsBase */.Sv, AdditionalFees_styles/* AdditionalFeesBase */.n_, PriceDetails_styles/* LineAdditionalFeesBase */.Hp, BookingInformationBase, RoomCardBase, BookingInformationHeader, CancellationPoliciesBase, Column);

// EXTERNAL MODULE: ./src/comps/Voucher/styles.module.css
var Voucher_styles_module = __webpack_require__(33929);
var Voucher_styles_module_default = /*#__PURE__*/__webpack_require__.n(Voucher_styles_module);
;// CONCATENATED MODULE: ./src/comps/Voucher/messages.js

var Voucher_messages_messages = (0,lib/* defineMessages */.vU)({
    printVoucher: {
        id: "voucher.print-voucher"
    },
    bookingCancelled: {
        id: "global.voucher-booking-cancelled"
    }
});
/* harmony default export */ var Voucher_messages = (Voucher_messages_messages);

;// CONCATENATED MODULE: ./src/comps/Voucher/index.js





































var GUEST_ROOM_LIST_MODAL_KEY = "guest-room-list";
var Voucher = function(param) {
    var pageId = param.pageId, paymentMethods = param.paymentMethods, purchaseId = param.purchaseId, voucher = param.voucher, property = param.property, supportInfoJSON = param.supportInfoJSON;
    var ref, ref1;
    var intl = (0,useIntl/* default */.Z)();
    var ref2 = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId
    }), sendAncillaryClickEvent = ref2.sendEvent;
    var ref3 = (0,react.useState)({
        isOpen: false,
        key: null,
        bookNumber: null
    }), modalConfig = ref3[0], setModalConfig = ref3[1];
    var bookingInformation = voucher.bookingInformation, currency = voucher.currency, hotelPreview = voucher.hotelPreview, nights = voucher.nights, priceSummary = voucher.priceSummary, roomsFullInformation = voucher.roomsFullInformation;
    var _obj;
    var statusOrder = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants_voucher/* BOOKING_CONFIRMED */.a9, 1), (0,_define_property/* default */.Z)(_obj, constants_voucher/* BOOKING_PENDING */.Bc, 1), (0,_define_property/* default */.Z)(_obj, constants_voucher/* BOOKING_UNSOLVED */.P1, 2), (0,_define_property/* default */.Z)(_obj, constants_voucher/* BOOKING_CANCELLED */.e1, 2), _obj);
    var title = /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelledBooking, {
        children: intl.formatMessage(Voucher_messages.bookingCancelled)
    });
    var isFormDisplayed = false;
    var insurance = bookingInformation[0].insurance;
    var isMultiBooking = bookingInformation.length > 1;
    var isPrime = priceSummary.isPrime || false;
    var walletEarned = (0,utils/* sumGeneratedWallet */.x)(bookingInformation);
    var showDiscount = (priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.bigHead) > 0;
    var roomPrice = showDiscount ? priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.bigHead : priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.price;
    var showPriceDropProtection = priceSummary.priceDropProtection > 0;
    var voucherNumbersFiltered = bookingInformation.filter(function(item) {
        return item.bookingStatus !== constants_voucher/* BOOKING_CANCELLED */.e1;
    }).map(function(item) {
        return item.voucher;
    });
    var voucherNumbers = voucherNumbersFiltered.length > 0 ? voucherNumbersFiltered : [
        bookingInformation[0].voucher
    ];
    var getTotalGuests = function(booking) {
        return (Number(booking.adults) + Number(booking.children)) * Number(booking.rooms);
    };
    var getFirstGuest = function(booking) {
        return booking.holders[0] || {};
    };
    var pendingRoomingListCount = bookingInformation.filter(function(item) {
        return item.isRoomingList;
    }).length;
    var haveSomeRoomingList = pendingRoomingListCount > 0;
    var totalGuests = bookingInformation.reduce(function(acc, book) {
        return acc + getTotalGuests(book);
    }, 0);
    var openInfoModal = function(key) {
        setModalConfig({
            isOpen: true,
            key: key
        });
    };
    var openGuestRoomListModal = function(param) {
        var bookNumber = param.bookNumber;
        setModalConfig({
            isOpen: true,
            key: GUEST_ROOM_LIST_MODAL_KEY,
            bookNumber: bookNumber
        });
    };
    var closeModal = function() {
        setModalConfig({
            isOpen: false,
            key: null,
            bookNumber: null
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VoucherBase, {
        "data-testid": "voucher-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (Voucher_styles_module_default()).bookingHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VoucherBookingStatus, {
                            location: hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.propertyCity,
                            bookingInformation: bookingInformation,
                            onClick: openInfoModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VoucherGuestRoomListStatus, {
                                isEnabled: haveSomeRoomingList,
                                children: bookingInformation.map(function(book, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VoucherGuestRoomListCta, {
                                        bookNumber: index + 1,
                                        isEnabled: book.isRoomingList,
                                        isMultiBooking: isMultiBooking,
                                        onClick: openGuestRoomListModal,
                                        totalGuests: getTotalGuests(book)
                                    }, book.hash);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VoucherBookingCodes, {
                        voucherNumbers: voucherNumbers,
                        purchaseId: purchaseId,
                        onClick: openInfoModal
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Voucher_styles_Row, {
                hidden: !haveSomeRoomingList,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VoucherGuestRoomListMessage, {
                    isEnabled: haveSomeRoomingList,
                    totalGuests: totalGuests,
                    children: bookingInformation.map(function(book, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VoucherGuestRoomListCta, {
                            bookNumber: index + 1,
                            isEnabled: book.isRoomingList,
                            isMultiBooking: isMultiBooking,
                            onClick: openGuestRoomListModal,
                            totalGuests: getTotalGuests(book)
                        }, book.hash);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_PrintButton, {
                    children: intl.formatMessage({
                        id: "voucher.print-voucher"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Voucher_styles_Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelPreview_HotelPreview, {
                        hotelPreview: hotelPreview,
                        property: property
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDetailsContainer, {
                        className: (priceSummary === null || priceSummary === void 0 ? void 0 : (ref = priceSummary.additionalFees) === null || ref === void 0 ? void 0 : ref.length) ? "" : "noPrint",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDetails/* default */.ZP, {
                            additionalProducts: priceSummary.additionalProducts,
                            nights: nights,
                            roomsFullInformation: roomsFullInformation,
                            total: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.total,
                            sellingRate: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.price,
                            sellingRateCurrency: currency,
                            totalCurrency: currency,
                            bighead: roomPrice,
                            bigheadCurrency: currency,
                            taxes: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.taxes,
                            taxesCurrency: currency,
                            staywallet: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.wallet,
                            staywalletCurrency: currency,
                            subtotal: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.subtotal,
                            subtotalCurrency: currency,
                            additionalFees: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.additionalFees,
                            insurance: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.insurance,
                            insuranceCurrency: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.currency,
                            showPaymentDates: false,
                            pdp: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.priceDropProtection,
                            pdpCurrency: currency,
                            isPrime: isPrime,
                            isVoucher: true,
                            showDiscount: showDiscount,
                            paymentPolicy: bookingInformation[0].rateName
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactRow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* SupportInfo */.Kc, {
                    supportInfoJSON: supportInfoJSON
                })
            }),
            insurance && /*#__PURE__*/ (0,jsx_runtime.jsx)(Voucher_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceSection/* default */.Z, {
                    insurance: insurance,
                    consumer: pageId
                })
            }),
            showPriceDropProtection && /*#__PURE__*/ (0,jsx_runtime.jsx)(Voucher_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDropProtection/* PriceDropProtection */.T, {
                    source: "voucher",
                    quotes: priceSummary.priceDropProtection,
                    paymentDate: (ref1 = bookingInformation[0].cancellationPolicies[0]) === null || ref1 === void 0 ? void 0 : ref1.cancellationDate
                })
            }),
            walletEarned > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Voucher_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StaywalletContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_Staywallet, {
                        amount: walletEarned,
                        currency: currency,
                        isEarned: true
                    })
                })
            }),
            bookingInformation.sort(function(a, b) {
                return statusOrder[a.bookingStatus] - statusOrder[b.bookingStatus];
            }).map(function(booking) {
                var ref;
                if (booking.bookingStatus === constants_voucher/* BOOKING_CANCELLED */.e1) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Voucher_styles_Row, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleSection/* default */.Z, {
                            fullWidth: true,
                            title: title,
                            iconToOpen: Add/* default */.Z,
                            iconToClose: Remove/* default */.Z,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_BookingInformation, {
                                bookingInformation: booking,
                                displayForm: false,
                                paymentMethods: paymentMethods,
                                propertyId: hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.propertyId,
                                purchaseId: purchaseId,
                                rooms: booking.rooms
                            })
                        })
                    }, booking.hash);
                }
                var displayForm = !isFormDisplayed && booking.bookingStatus === "confirmed" && (booking.paymentStatus === "failed" || booking.paymentStatus === "pending");
                if (displayForm) {
                    isFormDisplayed = true;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Voucher_styles_Row, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_BookingInformation, {
                                bookingInformation: booking,
                                displayForm: displayForm,
                                paymentMethods: paymentMethods,
                                propertyId: hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.propertyId,
                                purchaseId: purchaseId,
                                rooms: booking.rooms,
                                isRefundable: roomsFullInformation === null || roomsFullInformation === void 0 ? void 0 : (ref = roomsFullInformation[0]) === null || ref === void 0 ? void 0 : ref.isRefundable
                            })
                        }, booking === null || booking === void 0 ? void 0 : booking.idBooking),
                        booking.travelInsurance && /*#__PURE__*/ (0,jsx_runtime.jsx)(Voucher_styles_Row, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelInsurance/* default.Summary */.Z.Summary, {
                                insuranceTypeId: booking.travelInsurance.type,
                                currency: booking.travelInsurance.currency
                            })
                        })
                    ]
                });
            }),
            (hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.conditions) && Object.keys(hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.conditions).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Voucher_styles_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckinSection, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hotelPreview === null || hotelPreview === void 0 ? void 0 : hotelPreview.conditions), {
                        onModal: false
                    }))
                })
            }),
            voucher.ancillaries && /*#__PURE__*/ (0,jsx_runtime.jsx)(Voucher_styles_Row, {
                className: "noPrint",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Voucher_styles_module_default()).ancillaries,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* AncillariesBanner */.Kl, {
                        ancillariesJSON: {
                            list: voucher.ancillaries
                        },
                        onClick: function(param) {
                            var type = param.type;
                            return sendAncillaryClickEvent({
                                section: useKafkaEvent_constants/* SECTIONS */.SA["ANCILLARIES_".concat(type.toUpperCase())]
                            }, {
                                ancillaryOrigin: "voucher"
                            });
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_VoucherInfoModal, {
                item: modalConfig.key,
                isOpen: modalConfig.isOpen && modalConfig.key !== GUEST_ROOM_LIST_MODAL_KEY,
                onClose: closeModal
            }),
            bookingInformation.map(function(book, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VoucherGuestRoomListModal, {
                    hash: book.hash,
                    bookNumber: index + 1,
                    initialGuest: getFirstGuest(book),
                    isOpen: modalConfig.isOpen && modalConfig.key === GUEST_ROOM_LIST_MODAL_KEY && modalConfig.bookNumber === index + 1,
                    isMultiBooking: isMultiBooking,
                    onClose: closeModal,
                    pendingRoomingListCount: pendingRoomingListCount,
                    purchaseId: purchaseId,
                    totalGuests: getTotalGuests(book)
                }, book.hash);
            })
        ]
    });
};
Voucher.propTypes = {
    pageId: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    paymentMethods: checkout/* typePaymentMethods */.In,
    purchaseId: (prop_types_default()).string,
    voucher: typeVoucher,
    property: client_types/* typeProperty */._T,
    supportInfoJSON: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var comps_Voucher = (Voucher);

;// CONCATENATED MODULE: ./src/comps/Voucher/container.js












var VoucherContainer = function(param) {
    var pageId = param.pageId, paymentMethods = param.paymentMethods, purchaseId = param.purchaseId, voucherFromServer = param.voucher, property = param.property, supportInfoJSON = param.supportInfoJSON;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isLoading = (0,es/* useSelector */.v9)(getIsFetching);
    var refetch = (0,es/* useSelector */.v9)(getRefetch);
    var voucherFromStore = (0,es/* useSelector */.v9)(getVoucher);
    var voucher = Object.keys(voucherFromStore).length ? voucherFromStore : voucherFromServer;
    (0,react.useEffect)(function() {
        if (refetch) {
            dispatch((0,actions/* fetchVoucherRequestAction */.hE)({
                purchaseId: purchaseId
            }));
        } else {
            dispatch((0,actions/* updateVoucherAction */.Pc)(voucherFromServer));
        }
    }, [
        dispatch,
        refetch,
        purchaseId
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    (0,react.useEffect)(function() {
        if (voucher) {
            var ref = voucher.bookingInformation[0], checkIn = ref.checkIn, checkOut = ref.checkOut;
            var searchParams = {
                checkIn: checkIn,
                checkOut: checkOut
            };
            dispatch((0,Search_actions/* updateSearchAction */.uE)(searchParams));
        }
    }, [
        dispatch,
        voucher
    ]);
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_Voucher, {
        pageId: pageId,
        paymentMethods: paymentMethods,
        purchaseId: purchaseId,
        voucher: voucher,
        property: property,
        supportInfoJSON: supportInfoJSON
    });
};
VoucherContainer.propTypes = {
    pageId: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]).isRequired,
    paymentMethods: checkout/* typePaymentMethods */.In,
    purchaseId: (prop_types_default()).string,
    voucher: typeVoucher,
    property: client_types/* typeProperty */._T,
    supportInfoJSON: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var container = (VoucherContainer);


/***/ }),

/***/ 69835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bc": function() { return /* binding */ BOOKING_PENDING; },
/* harmony export */   "Ok": function() { return /* binding */ BOOKING_VARIANTS; },
/* harmony export */   "P1": function() { return /* binding */ BOOKING_UNSOLVED; },
/* harmony export */   "a9": function() { return /* binding */ BOOKING_CONFIRMED; },
/* harmony export */   "e1": function() { return /* binding */ BOOKING_CANCELLED; },
/* harmony export */   "l1": function() { return /* binding */ BOOKING_ERROR; }
/* harmony export */ });
var BOOKING_VARIANTS = [
    "confirmed",
    "pending",
    "unsolved",
    "error",
    "cancelled"
];
var BOOKING_CONFIRMED = "confirmed";
var BOOKING_PENDING = "pending";
var BOOKING_UNSOLVED = "unsolved";
var BOOKING_ERROR = "error";
var BOOKING_CANCELLED = "cancelled";


/***/ }),

/***/ 62565:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__chEqK system_textBodyL__xkApD","button":"styles_button__XIqQO"};

/***/ }),

/***/ 47247:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"allotmentContainer":"styles_allotmentContainer__2IqGH"};

/***/ }),

/***/ 80632:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__R__mR","codes":"styles_codes__REoYI system_captionL__E1FNu","linkContainer":"styles_linkContainer__yVZUY","link":"styles_link__od3P4","icon":"styles_icon__oer_3"};

/***/ }),

/***/ 13564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fc1an","statusContainer":"styles_statusContainer__hClyx","status":"styles_status__E9Ku6","confirmed":"styles_confirmed__oA0Rd","pending":"styles_pending__rOsUD","cancelled":"styles_cancelled__vG_CX","confirmation":"styles_confirmation__JFw_o","links":"styles_links__fzxrR"};

/***/ }),

/***/ 58697:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__9TgUA"};

/***/ }),

/***/ 51143:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gROnF","title":"styles_title__pXwmn","body":"styles_body__eLCvb","children":"styles_children__hKoOO"};

/***/ }),

/***/ 20475:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__2B2n6","form":"styles_form__xes9n","collapsibleContent":"styles_collapsibleContent__PUV0a","ctaContainer":"styles_ctaContainer__LK1Df"};

/***/ }),

/***/ 1722:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__WCeAT","statusContainer":"styles_statusContainer__MWywM","status":"styles_status__G3p2r"};

/***/ }),

/***/ 49312:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___tVrs","border":"styles_border__Te8jq","header":"styles_header__qyX5i","grid":"styles_grid__6TAAp","label":"styles_label__RW98k","totalValue":"styles_totalValue__JNJpD","value":"styles_value__LM6eQ"};

/***/ }),

/***/ 89549:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__eRg4W","roomContainer":"styles_roomContainer__GsoiZ","detailsContainer":"styles_detailsContainer__Dq6KJ system_captionM__csIyD","offersContainer":"styles_offersContainer__hh8X9","boardContainer":"styles_boardContainer__FPwFB","offerConditionsContainer":"styles_offerConditionsContainer__eMH3A","offerConditionsList":"styles_offerConditionsList__ZFxxc","priceBookingContainer":"styles_priceBookingContainer__h0Vge","priceContainer":"styles_priceContainer__jOgPL","priceLabel":"styles_priceLabel__0RHY4","roomHeader":"styles_roomHeader__bt1JI","roomName":"styles_roomName__HIu0E system_textBodyXL__3G5bt","detailsCapacityContainer":"styles_detailsCapacityContainer__8_zWT","capacityAndBedTypeSeparator":"styles_capacityAndBedTypeSeparator__l30k6","bookingButtonContainer":"styles_bookingButtonContainer__7TGHE"};

/***/ }),

/***/ 78005:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkItem":"CheckItem_checkItem__D_cn8","checkIcon":"CheckItem_checkIcon__a0sT_"};

/***/ }),

/***/ 80538:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"FormFields_formGroup__N2lNJ","lastFormGroup":"FormFields_lastFormGroup__5azQw","emailNote":"FormFields_emailNote__SNCF_"};

/***/ }),

/***/ 93842:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"invoiceNote":"InvoiceInfo_invoiceNote__SWYyY"};

/***/ }),

/***/ 41685:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formActions":"SubmitButton_formActions__pxMxP"};

/***/ }),

/***/ 95934:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"termsContainer":"TermsSection_termsContainer___hBCP","termsLink":"TermsSection_termsLink__E6xSg"};

/***/ }),

/***/ 11062:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formTitle":"RequestModal_formTitle__IESw8"};

/***/ }),

/***/ 76796:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"statusBadge":"StatusBadge_statusBadge__uoj0_"};

/***/ }),

/***/ 77299:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"InvoicePanel_container__qrowc","title":"InvoicePanel_title__mwGu_"};

/***/ }),

/***/ 44886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__c2xbI system_captionL__E1FNu","arrow":"styles_arrow__sG77U","center":"styles_center__2oBBv","end":"styles_end__Tfv3n","start":"styles_start__Dlfa6"};

/***/ }),

/***/ 33929:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bookingHeader":"styles_bookingHeader__fbSRV","ancillaries":"styles_ancillaries__qyX42"};

/***/ }),

/***/ 54533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__OSGhG system_textBodyL__xkApD","sticky":"styles_sticky__Eqtcd","description":"styles_description__x6qRX system_textBodyL__xkApD","confirmed":"styles_confirmed__apOp3","pending":"styles_pending__O_2hs","cancelled":"styles_cancelled__8ybGU","strong":"styles_strong__W4dol"};

/***/ }),

/***/ 1566:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__BO0Jo","actions":"styles_actions__xzfX1"};

/***/ }),

/***/ 89751:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"requestName":"styles_requestName__4QtOI"};

/***/ }),

/***/ 89076:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"requestSent":"styles_requestSent__R7lG8","requestSentWithBackground":"styles_requestSentWithBackground__hY9qU","requestSentTitle":"styles_requestSentTitle__7cLAh","requestSentTitleIcon":"styles_requestSentTitleIcon__vINpd"};

/***/ }),

/***/ 7032:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"specialRequests":"styles_specialRequests__mO_7k","specialRequestsTitle":"styles_specialRequestsTitle__81GTc","addSpecialRequest":"styles_addSpecialRequest__m9Plf","feedbackSection":"styles_feedbackSection__5Yn_z"};

/***/ })

}]);